var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 362,
    viewBox: "0 0 536 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6136_4726)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 362,
    rx: 16.8,
    fill: "url(#paint0_linear_6136_4726)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 362,
    rx: 16.8,
    fill: "url(#paint1_linear_6136_4726)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6136_4726)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6136_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 7.9334C7.4 8.32 7.0866 8.6334 6.7 8.6334C6.3134 8.6334 6 8.32 6 7.9334C6 7.5468 6.3134 7.2334 6.7 7.2334C7.0866 7.2334 7.4 7.5468 7.4 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 7.9334C25.6031 8.32 25.2897 8.6334 24.9031 8.6334C24.5166 8.6334 24.2031 8.32 24.2031 7.9334C24.2031 7.5468 24.5166 7.2334 24.9031 7.2334C25.2897 7.2334 25.6031 7.5468 25.6031 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 7.9334C43.7984 8.32 43.485 8.6334 43.0984 8.6334C42.7119 8.6334 42.3984 8.32 42.3984 7.9334C42.3984 7.5468 42.7119 7.2334 43.0984 7.2334C43.485 7.2334 43.7984 7.5468 43.7984 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 7.9334C62.0016 8.32 61.6881 8.6334 61.3016 8.6334C60.915 8.6334 60.6016 8.32 60.6016 7.9334C60.6016 7.5468 60.915 7.2334 61.3016 7.2334C61.6881 7.2334 62.0016 7.5468 62.0016 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 7.9334C80.2047 8.32 79.8912 8.6334 79.5047 8.6334C79.1181 8.6334 78.8047 8.32 78.8047 7.9334C78.8047 7.5468 79.1181 7.2334 79.5047 7.2334C79.8912 7.2334 80.2047 7.5468 80.2047 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 7.9334C98.4 8.32 98.0865 8.6334 97.7 8.6334C97.3135 8.6334 97 8.32 97 7.9334C97 7.5468 97.3135 7.2334 97.7 7.2334C98.0865 7.2334 98.4 7.5468 98.4 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 7.9334C116.603 8.32 116.29 8.6334 115.903 8.6334C115.517 8.6334 115.203 8.32 115.203 7.9334C115.203 7.5468 115.517 7.2334 115.903 7.2334C116.29 7.2334 116.603 7.5468 116.603 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 7.9334C134.798 8.32 134.485 8.6334 134.098 8.6334C133.712 8.6334 133.398 8.32 133.398 7.9334C133.398 7.5468 133.712 7.2334 134.098 7.2334C134.485 7.2334 134.798 7.5468 134.798 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 7.9334C153.002 8.32 152.688 8.6334 152.302 8.6334C151.915 8.6334 151.602 8.32 151.602 7.9334C151.602 7.5468 151.915 7.2334 152.302 7.2334C152.688 7.2334 153.002 7.5468 153.002 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 7.9334C171.205 8.32 170.891 8.6334 170.505 8.6334C170.118 8.6334 169.805 8.32 169.805 7.9334C169.805 7.5468 170.118 7.2334 170.505 7.2334C170.891 7.2334 171.205 7.5468 171.205 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 26.1336C7.4 26.5201 7.0866 26.8336 6.7 26.8336C6.3134 26.8336 6 26.5201 6 26.1336C6 25.7471 6.3134 25.4336 6.7 25.4336C7.0866 25.4336 7.4 25.7471 7.4 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 26.1336C25.6031 26.5201 25.2897 26.8336 24.9031 26.8336C24.5166 26.8336 24.2031 26.5201 24.2031 26.1336C24.2031 25.7471 24.5166 25.4336 24.9031 25.4336C25.2897 25.4336 25.6031 25.7471 25.6031 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 26.1336C43.7984 26.5201 43.485 26.8336 43.0984 26.8336C42.7119 26.8336 42.3984 26.5201 42.3984 26.1336C42.3984 25.7471 42.7119 25.4336 43.0984 25.4336C43.485 25.4336 43.7984 25.7471 43.7984 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 26.1333C62.0016 26.5199 61.6881 26.8333 61.3016 26.8333C60.915 26.8333 60.6016 26.5199 60.6016 26.1333C60.6016 25.7468 60.915 25.4333 61.3016 25.4333C61.6881 25.4333 62.0016 25.7468 62.0016 26.1333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 26.1336C80.2047 26.5201 79.8912 26.8336 79.5047 26.8336C79.1181 26.8336 78.8047 26.5201 78.8047 26.1336C78.8047 25.7471 79.1181 25.4336 79.5047 25.4336C79.8912 25.4336 80.2047 25.7471 80.2047 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 26.1336C98.4 26.5201 98.0865 26.8336 97.7 26.8336C97.3135 26.8336 97 26.5201 97 26.1336C97 25.7471 97.3135 25.4336 97.7 25.4336C98.0865 25.4336 98.4 25.7471 98.4 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 26.1336C116.603 26.5201 116.29 26.8336 115.903 26.8336C115.517 26.8336 115.203 26.5201 115.203 26.1336C115.203 25.7471 115.517 25.4336 115.903 25.4336C116.29 25.4336 116.603 25.7471 116.603 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 26.1336C134.798 26.5201 134.485 26.8336 134.098 26.8336C133.712 26.8336 133.398 26.5201 133.398 26.1336C133.398 25.7471 133.712 25.4336 134.098 25.4336C134.485 25.4336 134.798 25.7471 134.798 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 26.1333C153.002 26.5199 152.688 26.8333 152.302 26.8333C151.915 26.8333 151.602 26.5199 151.602 26.1333C151.602 25.7468 151.915 25.4333 152.302 25.4333C152.688 25.4333 153.002 25.7468 153.002 26.1333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 26.1336C171.205 26.5201 170.891 26.8336 170.505 26.8336C170.118 26.8336 169.805 26.5201 169.805 26.1336C169.805 25.7471 170.118 25.4336 170.505 25.4336C170.891 25.4336 171.205 25.7471 171.205 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 44.3338C7.4 44.7203 7.0866 45.0338 6.7 45.0338C6.3134 45.0338 6 44.7203 6 44.3338C6 43.9472 6.3134 43.6338 6.7 43.6338C7.0866 43.6338 7.4 43.9472 7.4 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 44.3338C25.6031 44.7203 25.2897 45.0338 24.9031 45.0338C24.5166 45.0338 24.2031 44.7203 24.2031 44.3338C24.2031 43.9472 24.5166 43.6338 24.9031 43.6338C25.2897 43.6338 25.6031 43.9472 25.6031 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 44.3338C43.7984 44.7203 43.485 45.0338 43.0984 45.0338C42.7119 45.0338 42.3984 44.7203 42.3984 44.3338C42.3984 43.9472 42.7119 43.6338 43.0984 43.6338C43.485 43.6338 43.7984 43.9472 43.7984 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 44.3338C62.0016 44.7203 61.6881 45.0338 61.3016 45.0338C60.915 45.0338 60.6016 44.7203 60.6016 44.3338C60.6016 43.9472 60.915 43.6338 61.3016 43.6338C61.6881 43.6338 62.0016 43.9472 62.0016 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 44.3338C80.2047 44.7203 79.8912 45.0338 79.5047 45.0338C79.1181 45.0338 78.8047 44.7203 78.8047 44.3338C78.8047 43.9472 79.1181 43.6338 79.5047 43.6338C79.8912 43.6338 80.2047 43.9472 80.2047 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 44.3338C98.4 44.7203 98.0865 45.0338 97.7 45.0338C97.3135 45.0338 97 44.7203 97 44.3338C97 43.9472 97.3135 43.6338 97.7 43.6338C98.0865 43.6338 98.4 43.9472 98.4 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 44.3338C116.603 44.7203 116.29 45.0338 115.903 45.0338C115.517 45.0338 115.203 44.7203 115.203 44.3338C115.203 43.9472 115.517 43.6338 115.903 43.6338C116.29 43.6338 116.603 43.9472 116.603 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 44.3338C134.798 44.7203 134.485 45.0338 134.098 45.0338C133.712 45.0338 133.398 44.7203 133.398 44.3338C133.398 43.9472 133.712 43.6338 134.098 43.6338C134.485 43.6338 134.798 43.9472 134.798 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 44.3338C153.002 44.7203 152.688 45.0338 152.302 45.0338C151.915 45.0338 151.602 44.7203 151.602 44.3338C151.602 43.9472 151.915 43.6338 152.302 43.6338C152.688 43.6338 153.002 43.9472 153.002 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 44.3338C171.205 44.7203 170.891 45.0338 170.505 45.0338C170.118 45.0338 169.805 44.7203 169.805 44.3338C169.805 43.9472 170.118 43.6338 170.505 43.6338C170.891 43.6338 171.205 43.9472 171.205 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 62.533C7.4 62.9195 7.0866 63.233 6.7 63.233C6.3134 63.233 6 62.9195 6 62.533C6 62.1465 6.3134 61.833 6.7 61.833C7.0866 61.833 7.4 62.1465 7.4 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 62.533C25.6031 62.9195 25.2897 63.233 24.9031 63.233C24.5166 63.233 24.2031 62.9195 24.2031 62.533C24.2031 62.1465 24.5166 61.833 24.9031 61.833C25.2897 61.833 25.6031 62.1465 25.6031 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 62.533C43.7984 62.9195 43.485 63.233 43.0984 63.233C42.7119 63.233 42.3984 62.9195 42.3984 62.533C42.3984 62.1465 42.7119 61.833 43.0984 61.833C43.485 61.833 43.7984 62.1465 43.7984 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 62.533C62.0016 62.9195 61.6881 63.233 61.3016 63.233C60.915 63.233 60.6016 62.9195 60.6016 62.533C60.6016 62.1465 60.915 61.833 61.3016 61.833C61.6881 61.833 62.0016 62.1465 62.0016 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 62.533C80.2047 62.9195 79.8912 63.233 79.5047 63.233C79.1181 63.233 78.8047 62.9195 78.8047 62.533C78.8047 62.1465 79.1181 61.833 79.5047 61.833C79.8912 61.833 80.2047 62.1465 80.2047 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 62.533C98.4 62.9195 98.0865 63.233 97.7 63.233C97.3135 63.233 97 62.9195 97 62.533C97 62.1465 97.3135 61.833 97.7 61.833C98.0865 61.833 98.4 62.1465 98.4 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 62.533C116.603 62.9195 116.29 63.233 115.903 63.233C115.517 63.233 115.203 62.9195 115.203 62.533C115.203 62.1465 115.517 61.833 115.903 61.833C116.29 61.833 116.603 62.1465 116.603 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 62.533C134.798 62.9195 134.485 63.233 134.098 63.233C133.712 63.233 133.398 62.9195 133.398 62.533C133.398 62.1465 133.712 61.833 134.098 61.833C134.485 61.833 134.798 62.1465 134.798 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 62.533C153.002 62.9195 152.688 63.233 152.302 63.233C151.915 63.233 151.602 62.9195 151.602 62.533C151.602 62.1465 151.915 61.833 152.302 61.833C152.688 61.833 153.002 62.1465 153.002 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 62.533C171.205 62.9195 170.891 63.233 170.505 63.233C170.118 63.233 169.805 62.9195 169.805 62.533C169.805 62.1465 170.118 61.833 170.505 61.833C170.891 61.833 171.205 62.1465 171.205 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 80.7332C7.4 81.1197 7.0866 81.4332 6.7 81.4332C6.3134 81.4332 6 81.1197 6 80.7332C6 80.3467 6.3134 80.0332 6.7 80.0332C7.0866 80.0332 7.4 80.3467 7.4 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 80.7332C25.6031 81.1197 25.2897 81.4332 24.9031 81.4332C24.5166 81.4332 24.2031 81.1197 24.2031 80.7332C24.2031 80.3467 24.5166 80.0332 24.9031 80.0332C25.2897 80.0332 25.6031 80.3467 25.6031 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 80.7332C43.7984 81.1197 43.485 81.4332 43.0984 81.4332C42.7119 81.4332 42.3984 81.1197 42.3984 80.7332C42.3984 80.3467 42.7119 80.0332 43.0984 80.0332C43.485 80.0332 43.7984 80.3467 43.7984 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 80.7334C62.0016 81.12 61.6881 81.4334 61.3016 81.4334C60.915 81.4334 60.6016 81.12 60.6016 80.7334C60.6016 80.3469 60.915 80.0334 61.3016 80.0334C61.6881 80.0334 62.0016 80.3469 62.0016 80.7334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 80.7332C80.2047 81.1197 79.8912 81.4332 79.5047 81.4332C79.1181 81.4332 78.8047 81.1197 78.8047 80.7332C78.8047 80.3467 79.1181 80.0332 79.5047 80.0332C79.8912 80.0332 80.2047 80.3467 80.2047 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 80.7332C98.4 81.1197 98.0865 81.4332 97.7 81.4332C97.3135 81.4332 97 81.1197 97 80.7332C97 80.3467 97.3135 80.0332 97.7 80.0332C98.0865 80.0332 98.4 80.3467 98.4 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 80.7332C116.603 81.1197 116.29 81.4332 115.903 81.4332C115.517 81.4332 115.203 81.1197 115.203 80.7332C115.203 80.3467 115.517 80.0332 115.903 80.0332C116.29 80.0332 116.603 80.3467 116.603 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 80.7332C134.798 81.1197 134.485 81.4332 134.098 81.4332C133.712 81.4332 133.398 81.1197 133.398 80.7332C133.398 80.3467 133.712 80.0332 134.098 80.0332C134.485 80.0332 134.798 80.3467 134.798 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 80.7334C153.002 81.12 152.688 81.4334 152.302 81.4334C151.915 81.4334 151.602 81.12 151.602 80.7334C151.602 80.3469 151.915 80.0334 152.302 80.0334C152.688 80.0334 153.002 80.3469 153.002 80.7334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 80.7332C171.205 81.1197 170.891 81.4332 170.505 81.4332C170.118 81.4332 169.805 81.1197 169.805 80.7332C169.805 80.3467 170.118 80.0332 170.505 80.0332C170.891 80.0332 171.205 80.3467 171.205 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 98.9334C7.4 99.3199 7.0866 99.6334 6.7 99.6334C6.3134 99.6334 6 99.3199 6 98.9334C6 98.5469 6.3134 98.2334 6.7 98.2334C7.0866 98.2334 7.4 98.5469 7.4 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 98.9334C25.6031 99.3199 25.2897 99.6334 24.9031 99.6334C24.5166 99.6334 24.2031 99.3199 24.2031 98.9334C24.2031 98.5469 24.5166 98.2334 24.9031 98.2334C25.2897 98.2334 25.6031 98.5469 25.6031 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 98.9334C43.7984 99.3199 43.485 99.6334 43.0984 99.6334C42.7119 99.6334 42.3984 99.3199 42.3984 98.9334C42.3984 98.5469 42.7119 98.2334 43.0984 98.2334C43.485 98.2334 43.7984 98.5469 43.7984 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 98.9334C62.0016 99.3199 61.6881 99.6334 61.3016 99.6334C60.915 99.6334 60.6016 99.3199 60.6016 98.9334C60.6016 98.5469 60.915 98.2334 61.3016 98.2334C61.6881 98.2334 62.0016 98.5469 62.0016 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 98.9334C80.2047 99.3199 79.8912 99.6334 79.5047 99.6334C79.1181 99.6334 78.8047 99.3199 78.8047 98.9334C78.8047 98.5469 79.1181 98.2334 79.5047 98.2334C79.8912 98.2334 80.2047 98.5469 80.2047 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 98.9334C98.4 99.3199 98.0865 99.6334 97.7 99.6334C97.3135 99.6334 97 99.3199 97 98.9334C97 98.5469 97.3135 98.2334 97.7 98.2334C98.0865 98.2334 98.4 98.5469 98.4 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 98.9334C116.603 99.3199 116.29 99.6334 115.903 99.6334C115.517 99.6334 115.203 99.3199 115.203 98.9334C115.203 98.5469 115.517 98.2334 115.903 98.2334C116.29 98.2334 116.603 98.5469 116.603 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 98.9334C134.798 99.3199 134.485 99.6334 134.098 99.6334C133.712 99.6334 133.398 99.3199 133.398 98.9334C133.398 98.5469 133.712 98.2334 134.098 98.2334C134.485 98.2334 134.798 98.5469 134.798 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 98.9334C153.002 99.3199 152.688 99.6334 152.302 99.6334C151.915 99.6334 151.602 99.3199 151.602 98.9334C151.602 98.5469 151.915 98.2334 152.302 98.2334C152.688 98.2334 153.002 98.5469 153.002 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 98.9334C171.205 99.3199 170.891 99.6334 170.505 99.6334C170.118 99.6334 169.805 99.3199 169.805 98.9334C169.805 98.5469 170.118 98.2334 170.505 98.2334C170.891 98.2334 171.205 98.5469 171.205 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 117.134C7.4 117.52 7.0866 117.834 6.7 117.834C6.3134 117.834 6 117.52 6 117.134C6 116.747 6.3134 116.434 6.7 116.434C7.0866 116.434 7.4 116.747 7.4 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 117.134C25.6031 117.52 25.2897 117.834 24.9031 117.834C24.5166 117.834 24.2031 117.52 24.2031 117.134C24.2031 116.747 24.5166 116.434 24.9031 116.434C25.2897 116.434 25.6031 116.747 25.6031 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 117.134C43.7984 117.52 43.485 117.834 43.0984 117.834C42.7119 117.834 42.3984 117.52 42.3984 117.134C42.3984 116.747 42.7119 116.434 43.0984 116.434C43.485 116.434 43.7984 116.747 43.7984 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 117.133C62.0016 117.52 61.6881 117.833 61.3016 117.833C60.915 117.833 60.6016 117.52 60.6016 117.133C60.6016 116.747 60.915 116.433 61.3016 116.433C61.6881 116.433 62.0016 116.747 62.0016 117.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 117.134C80.2047 117.52 79.8912 117.834 79.5047 117.834C79.1181 117.834 78.8047 117.52 78.8047 117.134C78.8047 116.747 79.1181 116.434 79.5047 116.434C79.8912 116.434 80.2047 116.747 80.2047 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 117.134C98.4 117.52 98.0865 117.834 97.7 117.834C97.3135 117.834 97 117.52 97 117.134C97 116.747 97.3135 116.434 97.7 116.434C98.0865 116.434 98.4 116.747 98.4 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 117.134C116.603 117.52 116.29 117.834 115.903 117.834C115.517 117.834 115.203 117.52 115.203 117.134C115.203 116.747 115.517 116.434 115.903 116.434C116.29 116.434 116.603 116.747 116.603 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 117.134C134.798 117.52 134.485 117.834 134.098 117.834C133.712 117.834 133.398 117.52 133.398 117.134C133.398 116.747 133.712 116.434 134.098 116.434C134.485 116.434 134.798 116.747 134.798 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 117.133C153.002 117.52 152.688 117.833 152.302 117.833C151.915 117.833 151.602 117.52 151.602 117.133C151.602 116.747 151.915 116.433 152.302 116.433C152.688 116.433 153.002 116.747 153.002 117.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 117.134C171.205 117.52 170.891 117.834 170.505 117.834C170.118 117.834 169.805 117.52 169.805 117.134C169.805 116.747 170.118 116.434 170.505 116.434C170.891 116.434 171.205 116.747 171.205 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 135.334C7.4 135.72 7.0866 136.034 6.7 136.034C6.3134 136.034 6 135.72 6 135.334C6 134.947 6.3134 134.634 6.7 134.634C7.0866 134.634 7.4 134.947 7.4 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 135.334C25.6031 135.72 25.2897 136.034 24.9031 136.034C24.5166 136.034 24.2031 135.72 24.2031 135.334C24.2031 134.947 24.5166 134.634 24.9031 134.634C25.2897 134.634 25.6031 134.947 25.6031 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 135.334C43.7984 135.72 43.485 136.034 43.0984 136.034C42.7119 136.034 42.3984 135.72 42.3984 135.334C42.3984 134.947 42.7119 134.634 43.0984 134.634C43.485 134.634 43.7984 134.947 43.7984 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 135.334C62.0016 135.72 61.6881 136.034 61.3016 136.034C60.915 136.034 60.6016 135.72 60.6016 135.334C60.6016 134.947 60.915 134.634 61.3016 134.634C61.6881 134.634 62.0016 134.947 62.0016 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 135.334C80.2047 135.72 79.8912 136.034 79.5047 136.034C79.1181 136.034 78.8047 135.72 78.8047 135.334C78.8047 134.947 79.1181 134.634 79.5047 134.634C79.8912 134.634 80.2047 134.947 80.2047 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 135.334C98.4 135.72 98.0865 136.034 97.7 136.034C97.3135 136.034 97 135.72 97 135.334C97 134.947 97.3135 134.634 97.7 134.634C98.0865 134.634 98.4 134.947 98.4 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 135.334C116.603 135.72 116.29 136.034 115.903 136.034C115.517 136.034 115.203 135.72 115.203 135.334C115.203 134.947 115.517 134.634 115.903 134.634C116.29 134.634 116.603 134.947 116.603 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 135.334C134.798 135.72 134.485 136.034 134.098 136.034C133.712 136.034 133.398 135.72 133.398 135.334C133.398 134.947 133.712 134.634 134.098 134.634C134.485 134.634 134.798 134.947 134.798 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 135.334C153.002 135.72 152.688 136.034 152.302 136.034C151.915 136.034 151.602 135.72 151.602 135.334C151.602 134.947 151.915 134.634 152.302 134.634C152.688 134.634 153.002 134.947 153.002 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 135.334C171.205 135.72 170.891 136.034 170.505 136.034C170.118 136.034 169.805 135.72 169.805 135.334C169.805 134.947 170.118 134.634 170.505 134.634C170.891 134.634 171.205 134.947 171.205 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 153.533C7.4 153.919 7.0866 154.233 6.7 154.233C6.3134 154.233 6 153.919 6 153.533C6 153.147 6.3134 152.833 6.7 152.833C7.0866 152.833 7.4 153.147 7.4 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 153.533C25.6031 153.919 25.2897 154.233 24.9031 154.233C24.5166 154.233 24.2031 153.919 24.2031 153.533C24.2031 153.147 24.5166 152.833 24.9031 152.833C25.2897 152.833 25.6031 153.147 25.6031 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 153.533C43.7984 153.919 43.485 154.233 43.0984 154.233C42.7119 154.233 42.3984 153.919 42.3984 153.533C42.3984 153.147 42.7119 152.833 43.0984 152.833C43.485 152.833 43.7984 153.147 43.7984 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 153.533C62.0016 153.919 61.6881 154.233 61.3016 154.233C60.915 154.233 60.6016 153.919 60.6016 153.533C60.6016 153.147 60.915 152.833 61.3016 152.833C61.6881 152.833 62.0016 153.147 62.0016 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 153.533C80.2047 153.919 79.8912 154.233 79.5047 154.233C79.1181 154.233 78.8047 153.919 78.8047 153.533C78.8047 153.147 79.1181 152.833 79.5047 152.833C79.8912 152.833 80.2047 153.147 80.2047 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 153.533C98.4 153.919 98.0865 154.233 97.7 154.233C97.3135 154.233 97 153.919 97 153.533C97 153.147 97.3135 152.833 97.7 152.833C98.0865 152.833 98.4 153.147 98.4 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 153.533C116.603 153.919 116.29 154.233 115.903 154.233C115.517 154.233 115.203 153.919 115.203 153.533C115.203 153.147 115.517 152.833 115.903 152.833C116.29 152.833 116.603 153.147 116.603 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 153.533C134.798 153.919 134.485 154.233 134.098 154.233C133.712 154.233 133.398 153.919 133.398 153.533C133.398 153.147 133.712 152.833 134.098 152.833C134.485 152.833 134.798 153.147 134.798 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 153.533C153.002 153.919 152.688 154.233 152.302 154.233C151.915 154.233 151.602 153.919 151.602 153.533C151.602 153.147 151.915 152.833 152.302 152.833C152.688 152.833 153.002 153.147 153.002 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 153.533C171.205 153.919 170.891 154.233 170.505 154.233C170.118 154.233 169.805 153.919 169.805 153.533C169.805 153.147 170.118 152.833 170.505 152.833C170.891 152.833 171.205 153.147 171.205 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 171.733C7.4 172.12 7.0866 172.433 6.7 172.433C6.3134 172.433 6 172.12 6 171.733C6 171.347 6.3134 171.033 6.7 171.033C7.0866 171.033 7.4 171.347 7.4 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 171.733C25.6031 172.12 25.2897 172.433 24.9031 172.433C24.5166 172.433 24.2031 172.12 24.2031 171.733C24.2031 171.347 24.5166 171.033 24.9031 171.033C25.2897 171.033 25.6031 171.347 25.6031 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 171.733C43.7984 172.12 43.485 172.433 43.0984 172.433C42.7119 172.433 42.3984 172.12 42.3984 171.733C42.3984 171.347 42.7119 171.033 43.0984 171.033C43.485 171.033 43.7984 171.347 43.7984 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 171.733C62.0016 172.12 61.6881 172.433 61.3016 172.433C60.915 172.433 60.6016 172.12 60.6016 171.733C60.6016 171.347 60.915 171.033 61.3016 171.033C61.6881 171.033 62.0016 171.347 62.0016 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 171.733C80.2047 172.12 79.8912 172.433 79.5047 172.433C79.1181 172.433 78.8047 172.12 78.8047 171.733C78.8047 171.347 79.1181 171.033 79.5047 171.033C79.8912 171.033 80.2047 171.347 80.2047 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 171.733C98.4 172.12 98.0865 172.433 97.7 172.433C97.3135 172.433 97 172.12 97 171.733C97 171.347 97.3135 171.033 97.7 171.033C98.0865 171.033 98.4 171.347 98.4 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 171.733C116.603 172.12 116.29 172.433 115.903 172.433C115.517 172.433 115.203 172.12 115.203 171.733C115.203 171.347 115.517 171.033 115.903 171.033C116.29 171.033 116.603 171.347 116.603 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 171.733C134.798 172.12 134.485 172.433 134.098 172.433C133.712 172.433 133.398 172.12 133.398 171.733C133.398 171.347 133.712 171.033 134.098 171.033C134.485 171.033 134.798 171.347 134.798 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 171.733C153.002 172.12 152.688 172.433 152.302 172.433C151.915 172.433 151.602 172.12 151.602 171.733C151.602 171.347 151.915 171.033 152.302 171.033C152.688 171.033 153.002 171.347 153.002 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 171.733C171.205 172.12 170.891 172.433 170.505 172.433C170.118 172.433 169.805 172.12 169.805 171.733C169.805 171.347 170.118 171.033 170.505 171.033C170.891 171.033 171.205 171.347 171.205 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 189.933C7.4 190.32 7.0866 190.633 6.7 190.633C6.3134 190.633 6 190.32 6 189.933C6 189.547 6.3134 189.233 6.7 189.233C7.0866 189.233 7.4 189.547 7.4 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 189.933C25.6031 190.32 25.2897 190.633 24.9031 190.633C24.5166 190.633 24.2031 190.32 24.2031 189.933C24.2031 189.547 24.5166 189.233 24.9031 189.233C25.2897 189.233 25.6031 189.547 25.6031 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 189.933C43.7984 190.32 43.485 190.633 43.0984 190.633C42.7119 190.633 42.3984 190.32 42.3984 189.933C42.3984 189.547 42.7119 189.233 43.0984 189.233C43.485 189.233 43.7984 189.547 43.7984 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 189.933C62.0016 190.32 61.6881 190.633 61.3016 190.633C60.915 190.633 60.6016 190.32 60.6016 189.933C60.6016 189.547 60.915 189.233 61.3016 189.233C61.6881 189.233 62.0016 189.547 62.0016 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 189.933C80.2047 190.32 79.8912 190.633 79.5047 190.633C79.1181 190.633 78.8047 190.32 78.8047 189.933C78.8047 189.547 79.1181 189.233 79.5047 189.233C79.8912 189.233 80.2047 189.547 80.2047 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 189.933C98.4 190.32 98.0865 190.633 97.7 190.633C97.3135 190.633 97 190.32 97 189.933C97 189.547 97.3135 189.233 97.7 189.233C98.0865 189.233 98.4 189.547 98.4 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 189.933C116.603 190.32 116.29 190.633 115.903 190.633C115.517 190.633 115.203 190.32 115.203 189.933C115.203 189.547 115.517 189.233 115.903 189.233C116.29 189.233 116.603 189.547 116.603 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 189.933C134.798 190.32 134.485 190.633 134.098 190.633C133.712 190.633 133.398 190.32 133.398 189.933C133.398 189.547 133.712 189.233 134.098 189.233C134.485 189.233 134.798 189.547 134.798 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 189.933C153.002 190.32 152.688 190.633 152.302 190.633C151.915 190.633 151.602 190.32 151.602 189.933C151.602 189.547 151.915 189.233 152.302 189.233C152.688 189.233 153.002 189.547 153.002 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 189.933C171.205 190.32 170.891 190.633 170.505 190.633C170.118 190.633 169.805 190.32 169.805 189.933C169.805 189.547 170.118 189.233 170.505 189.233C170.891 189.233 171.205 189.547 171.205 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 208.134C7.4 208.52 7.0866 208.834 6.7 208.834C6.3134 208.834 6 208.52 6 208.134C6 207.747 6.3134 207.434 6.7 207.434C7.0866 207.434 7.4 207.747 7.4 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 208.134C25.6031 208.52 25.2897 208.834 24.9031 208.834C24.5166 208.834 24.2031 208.52 24.2031 208.134C24.2031 207.747 24.5166 207.434 24.9031 207.434C25.2897 207.434 25.6031 207.747 25.6031 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 208.134C43.7984 208.52 43.485 208.834 43.0984 208.834C42.7119 208.834 42.3984 208.52 42.3984 208.134C42.3984 207.747 42.7119 207.434 43.0984 207.434C43.485 207.434 43.7984 207.747 43.7984 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 208.133C62.0016 208.52 61.6881 208.833 61.3016 208.833C60.915 208.833 60.6016 208.52 60.6016 208.133C60.6016 207.747 60.915 207.433 61.3016 207.433C61.6881 207.433 62.0016 207.747 62.0016 208.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 208.134C80.2047 208.52 79.8912 208.834 79.5047 208.834C79.1181 208.834 78.8047 208.52 78.8047 208.134C78.8047 207.747 79.1181 207.434 79.5047 207.434C79.8912 207.434 80.2047 207.747 80.2047 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 208.134C98.4 208.52 98.0865 208.834 97.7 208.834C97.3135 208.834 97 208.52 97 208.134C97 207.747 97.3135 207.434 97.7 207.434C98.0865 207.434 98.4 207.747 98.4 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 208.134C116.603 208.52 116.29 208.834 115.903 208.834C115.517 208.834 115.203 208.52 115.203 208.134C115.203 207.747 115.517 207.434 115.903 207.434C116.29 207.434 116.603 207.747 116.603 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 208.134C134.798 208.52 134.485 208.834 134.098 208.834C133.712 208.834 133.398 208.52 133.398 208.134C133.398 207.747 133.712 207.434 134.098 207.434C134.485 207.434 134.798 207.747 134.798 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 208.133C153.002 208.52 152.688 208.833 152.302 208.833C151.915 208.833 151.602 208.52 151.602 208.133C151.602 207.747 151.915 207.433 152.302 207.433C152.688 207.433 153.002 207.747 153.002 208.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 208.134C171.205 208.52 170.891 208.834 170.505 208.834C170.118 208.834 169.805 208.52 169.805 208.134C169.805 207.747 170.118 207.434 170.505 207.434C170.891 207.434 171.205 207.747 171.205 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 226.334C7.4 226.72 7.0866 227.034 6.7 227.034C6.3134 227.034 6 226.72 6 226.334C6 225.947 6.3134 225.634 6.7 225.634C7.0866 225.634 7.4 225.947 7.4 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 226.334C25.6031 226.72 25.2897 227.034 24.9031 227.034C24.5166 227.034 24.2031 226.72 24.2031 226.334C24.2031 225.947 24.5166 225.634 24.9031 225.634C25.2897 225.634 25.6031 225.947 25.6031 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 226.334C43.7984 226.72 43.485 227.034 43.0984 227.034C42.7119 227.034 42.3984 226.72 42.3984 226.334C42.3984 225.947 42.7119 225.634 43.0984 225.634C43.485 225.634 43.7984 225.947 43.7984 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 226.334C62.0016 226.72 61.6881 227.034 61.3016 227.034C60.915 227.034 60.6016 226.72 60.6016 226.334C60.6016 225.947 60.915 225.634 61.3016 225.634C61.6881 225.634 62.0016 225.947 62.0016 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 226.334C80.2047 226.72 79.8912 227.034 79.5047 227.034C79.1181 227.034 78.8047 226.72 78.8047 226.334C78.8047 225.947 79.1181 225.634 79.5047 225.634C79.8912 225.634 80.2047 225.947 80.2047 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 226.334C98.4 226.72 98.0865 227.034 97.7 227.034C97.3135 227.034 97 226.72 97 226.334C97 225.947 97.3135 225.634 97.7 225.634C98.0865 225.634 98.4 225.947 98.4 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 226.334C116.603 226.72 116.29 227.034 115.903 227.034C115.517 227.034 115.203 226.72 115.203 226.334C115.203 225.947 115.517 225.634 115.903 225.634C116.29 225.634 116.603 225.947 116.603 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 226.334C134.798 226.72 134.485 227.034 134.098 227.034C133.712 227.034 133.398 226.72 133.398 226.334C133.398 225.947 133.712 225.634 134.098 225.634C134.485 225.634 134.798 225.947 134.798 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 226.334C153.002 226.72 152.688 227.034 152.302 227.034C151.915 227.034 151.602 226.72 151.602 226.334C151.602 225.947 151.915 225.634 152.302 225.634C152.688 225.634 153.002 225.947 153.002 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 226.334C171.205 226.72 170.891 227.034 170.505 227.034C170.118 227.034 169.805 226.72 169.805 226.334C169.805 225.947 170.118 225.634 170.505 225.634C170.891 225.634 171.205 225.947 171.205 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 244.533C7.4 244.919 7.0866 245.233 6.7 245.233C6.3134 245.233 6 244.919 6 244.533C6 244.147 6.3134 243.833 6.7 243.833C7.0866 243.833 7.4 244.147 7.4 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 244.533C25.6031 244.919 25.2897 245.233 24.9031 245.233C24.5166 245.233 24.2031 244.919 24.2031 244.533C24.2031 244.147 24.5166 243.833 24.9031 243.833C25.2897 243.833 25.6031 244.147 25.6031 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 244.533C43.7984 244.919 43.485 245.233 43.0984 245.233C42.7119 245.233 42.3984 244.919 42.3984 244.533C42.3984 244.147 42.7119 243.833 43.0984 243.833C43.485 243.833 43.7984 244.147 43.7984 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 244.533C62.0016 244.919 61.6881 245.233 61.3016 245.233C60.915 245.233 60.6016 244.919 60.6016 244.533C60.6016 244.147 60.915 243.833 61.3016 243.833C61.6881 243.833 62.0016 244.147 62.0016 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 244.533C80.2047 244.919 79.8912 245.233 79.5047 245.233C79.1181 245.233 78.8047 244.919 78.8047 244.533C78.8047 244.147 79.1181 243.833 79.5047 243.833C79.8912 243.833 80.2047 244.147 80.2047 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 244.533C98.4 244.919 98.0865 245.233 97.7 245.233C97.3135 245.233 97 244.919 97 244.533C97 244.147 97.3135 243.833 97.7 243.833C98.0865 243.833 98.4 244.147 98.4 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 244.533C116.603 244.919 116.29 245.233 115.903 245.233C115.517 245.233 115.203 244.919 115.203 244.533C115.203 244.147 115.517 243.833 115.903 243.833C116.29 243.833 116.603 244.147 116.603 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 244.533C134.798 244.919 134.485 245.233 134.098 245.233C133.712 245.233 133.398 244.919 133.398 244.533C133.398 244.147 133.712 243.833 134.098 243.833C134.485 243.833 134.798 244.147 134.798 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 244.533C153.002 244.919 152.688 245.233 152.302 245.233C151.915 245.233 151.602 244.919 151.602 244.533C151.602 244.147 151.915 243.833 152.302 243.833C152.688 243.833 153.002 244.147 153.002 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 244.533C171.205 244.919 170.891 245.233 170.505 245.233C170.118 245.233 169.805 244.919 169.805 244.533C169.805 244.147 170.118 243.833 170.505 243.833C170.891 243.833 171.205 244.147 171.205 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 7.9334C351.805 8.32 352.118 8.6334 352.505 8.6334C352.891 8.6334 353.205 8.32 353.205 7.9334C353.205 7.5468 352.891 7.2334 352.505 7.2334C352.118 7.2334 351.805 7.5468 351.805 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 7.9334C333.602 8.32 333.915 8.6334 334.302 8.6334C334.688 8.6334 335.002 8.32 335.002 7.9334C335.002 7.5468 334.688 7.2334 334.302 7.2334C333.915 7.2334 333.602 7.5468 333.602 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 7.9334C315.398 8.32 315.712 8.6334 316.098 8.6334C316.485 8.6334 316.798 8.32 316.798 7.9334C316.798 7.5468 316.485 7.2334 316.098 7.2334C315.712 7.2334 315.398 7.5468 315.398 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 7.9334C297.203 8.32 297.517 8.6334 297.903 8.6334C298.29 8.6334 298.603 8.32 298.603 7.9334C298.603 7.5468 298.29 7.2334 297.903 7.2334C297.517 7.2334 297.203 7.5468 297.203 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 7.9334C279 8.32 279.314 8.6334 279.7 8.6334C280.086 8.6334 280.4 8.32 280.4 7.9334C280.4 7.5468 280.086 7.2334 279.7 7.2334C279.314 7.2334 279 7.5468 279 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 7.9334C260.805 8.32 261.118 8.6334 261.505 8.6334C261.891 8.6334 262.205 8.32 262.205 7.9334C262.205 7.5468 261.891 7.2334 261.505 7.2334C261.118 7.2334 260.805 7.5468 260.805 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 7.9334C242.602 8.32 242.915 8.6334 243.302 8.6334C243.688 8.6334 244.002 8.32 244.002 7.9334C244.002 7.5468 243.688 7.2334 243.302 7.2334C242.915 7.2334 242.602 7.5468 242.602 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 7.9334C224.398 8.32 224.712 8.6334 225.098 8.6334C225.485 8.6334 225.798 8.32 225.798 7.9334C225.798 7.5468 225.485 7.2334 225.098 7.2334C224.712 7.2334 224.398 7.5468 224.398 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 7.9334C206.203 8.32 206.517 8.6334 206.903 8.6334C207.29 8.6334 207.603 8.32 207.603 7.9334C207.603 7.5468 207.29 7.2334 206.903 7.2334C206.517 7.2334 206.203 7.5468 206.203 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 7.9334C188 8.32 188.314 8.6334 188.7 8.6334C189.086 8.6334 189.4 8.32 189.4 7.9334C189.4 7.5468 189.086 7.2334 188.7 7.2334C188.314 7.2334 188 7.5468 188 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 26.1336C351.805 26.5201 352.118 26.8336 352.505 26.8336C352.891 26.8336 353.205 26.5201 353.205 26.1336C353.205 25.7471 352.891 25.4336 352.505 25.4336C352.118 25.4336 351.805 25.7471 351.805 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 26.1333C333.602 26.5199 333.915 26.8333 334.302 26.8333C334.688 26.8333 335.002 26.5199 335.002 26.1333C335.002 25.7468 334.688 25.4333 334.302 25.4333C333.915 25.4333 333.602 25.7468 333.602 26.1333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 26.1336C315.398 26.5201 315.712 26.8336 316.098 26.8336C316.485 26.8336 316.798 26.5201 316.798 26.1336C316.798 25.7471 316.485 25.4336 316.098 25.4336C315.712 25.4336 315.398 25.7471 315.398 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 26.1336C297.203 26.5201 297.517 26.8336 297.903 26.8336C298.29 26.8336 298.603 26.5201 298.603 26.1336C298.603 25.7471 298.29 25.4336 297.903 25.4336C297.517 25.4336 297.203 25.7471 297.203 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 26.1336C279 26.5201 279.314 26.8336 279.7 26.8336C280.086 26.8336 280.4 26.5201 280.4 26.1336C280.4 25.7471 280.086 25.4336 279.7 25.4336C279.314 25.4336 279 25.7471 279 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 26.1336C260.805 26.5201 261.118 26.8336 261.505 26.8336C261.891 26.8336 262.205 26.5201 262.205 26.1336C262.205 25.7471 261.891 25.4336 261.505 25.4336C261.118 25.4336 260.805 25.7471 260.805 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 26.1333C242.602 26.5199 242.915 26.8333 243.302 26.8333C243.688 26.8333 244.002 26.5199 244.002 26.1333C244.002 25.7468 243.688 25.4333 243.302 25.4333C242.915 25.4333 242.602 25.7468 242.602 26.1333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 26.1336C224.398 26.5201 224.712 26.8336 225.098 26.8336C225.485 26.8336 225.798 26.5201 225.798 26.1336C225.798 25.7471 225.485 25.4336 225.098 25.4336C224.712 25.4336 224.398 25.7471 224.398 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 26.1336C206.203 26.5201 206.517 26.8336 206.903 26.8336C207.29 26.8336 207.603 26.5201 207.603 26.1336C207.603 25.7471 207.29 25.4336 206.903 25.4336C206.517 25.4336 206.203 25.7471 206.203 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 26.1336C188 26.5201 188.314 26.8336 188.7 26.8336C189.086 26.8336 189.4 26.5201 189.4 26.1336C189.4 25.7471 189.086 25.4336 188.7 25.4336C188.314 25.4336 188 25.7471 188 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 44.3338C351.805 44.7203 352.118 45.0338 352.505 45.0338C352.891 45.0338 353.205 44.7203 353.205 44.3338C353.205 43.9472 352.891 43.6338 352.505 43.6338C352.118 43.6338 351.805 43.9472 351.805 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 44.3338C333.602 44.7203 333.915 45.0338 334.302 45.0338C334.688 45.0338 335.002 44.7203 335.002 44.3338C335.002 43.9472 334.688 43.6338 334.302 43.6338C333.915 43.6338 333.602 43.9472 333.602 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 44.3338C315.398 44.7203 315.712 45.0338 316.098 45.0338C316.485 45.0338 316.798 44.7203 316.798 44.3338C316.798 43.9472 316.485 43.6338 316.098 43.6338C315.712 43.6338 315.398 43.9472 315.398 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 44.3338C297.203 44.7203 297.517 45.0338 297.903 45.0338C298.29 45.0338 298.603 44.7203 298.603 44.3338C298.603 43.9472 298.29 43.6338 297.903 43.6338C297.517 43.6338 297.203 43.9472 297.203 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 44.3338C279 44.7203 279.314 45.0338 279.7 45.0338C280.086 45.0338 280.4 44.7203 280.4 44.3338C280.4 43.9472 280.086 43.6338 279.7 43.6338C279.314 43.6338 279 43.9472 279 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 44.3338C260.805 44.7203 261.118 45.0338 261.505 45.0338C261.891 45.0338 262.205 44.7203 262.205 44.3338C262.205 43.9472 261.891 43.6338 261.505 43.6338C261.118 43.6338 260.805 43.9472 260.805 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 44.3338C242.602 44.7203 242.915 45.0338 243.302 45.0338C243.688 45.0338 244.002 44.7203 244.002 44.3338C244.002 43.9472 243.688 43.6338 243.302 43.6338C242.915 43.6338 242.602 43.9472 242.602 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 44.3338C224.398 44.7203 224.712 45.0338 225.098 45.0338C225.485 45.0338 225.798 44.7203 225.798 44.3338C225.798 43.9472 225.485 43.6338 225.098 43.6338C224.712 43.6338 224.398 43.9472 224.398 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 44.3338C206.203 44.7203 206.517 45.0338 206.903 45.0338C207.29 45.0338 207.603 44.7203 207.603 44.3338C207.603 43.9472 207.29 43.6338 206.903 43.6338C206.517 43.6338 206.203 43.9472 206.203 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 44.3338C188 44.7203 188.314 45.0338 188.7 45.0338C189.086 45.0338 189.4 44.7203 189.4 44.3338C189.4 43.9472 189.086 43.6338 188.7 43.6338C188.314 43.6338 188 43.9472 188 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 62.533C351.805 62.9195 352.118 63.233 352.505 63.233C352.891 63.233 353.205 62.9195 353.205 62.533C353.205 62.1465 352.891 61.833 352.505 61.833C352.118 61.833 351.805 62.1465 351.805 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 62.533C333.602 62.9195 333.915 63.233 334.302 63.233C334.688 63.233 335.002 62.9195 335.002 62.533C335.002 62.1465 334.688 61.833 334.302 61.833C333.915 61.833 333.602 62.1465 333.602 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 62.533C315.398 62.9195 315.712 63.233 316.098 63.233C316.485 63.233 316.798 62.9195 316.798 62.533C316.798 62.1465 316.485 61.833 316.098 61.833C315.712 61.833 315.398 62.1465 315.398 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 62.533C297.203 62.9195 297.517 63.233 297.903 63.233C298.29 63.233 298.603 62.9195 298.603 62.533C298.603 62.1465 298.29 61.833 297.903 61.833C297.517 61.833 297.203 62.1465 297.203 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 62.533C279 62.9195 279.314 63.233 279.7 63.233C280.086 63.233 280.4 62.9195 280.4 62.533C280.4 62.1465 280.086 61.833 279.7 61.833C279.314 61.833 279 62.1465 279 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 62.533C260.805 62.9195 261.118 63.233 261.505 63.233C261.891 63.233 262.205 62.9195 262.205 62.533C262.205 62.1465 261.891 61.833 261.505 61.833C261.118 61.833 260.805 62.1465 260.805 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 62.533C242.602 62.9195 242.915 63.233 243.302 63.233C243.688 63.233 244.002 62.9195 244.002 62.533C244.002 62.1465 243.688 61.833 243.302 61.833C242.915 61.833 242.602 62.1465 242.602 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 62.533C224.398 62.9195 224.712 63.233 225.098 63.233C225.485 63.233 225.798 62.9195 225.798 62.533C225.798 62.1465 225.485 61.833 225.098 61.833C224.712 61.833 224.398 62.1465 224.398 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 62.533C206.203 62.9195 206.517 63.233 206.903 63.233C207.29 63.233 207.603 62.9195 207.603 62.533C207.603 62.1465 207.29 61.833 206.903 61.833C206.517 61.833 206.203 62.1465 206.203 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 62.533C188 62.9195 188.314 63.233 188.7 63.233C189.086 63.233 189.4 62.9195 189.4 62.533C189.4 62.1465 189.086 61.833 188.7 61.833C188.314 61.833 188 62.1465 188 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 80.7332C351.805 81.1197 352.118 81.4332 352.505 81.4332C352.891 81.4332 353.205 81.1197 353.205 80.7332C353.205 80.3467 352.891 80.0332 352.505 80.0332C352.118 80.0332 351.805 80.3467 351.805 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 80.7334C333.602 81.12 333.915 81.4334 334.302 81.4334C334.688 81.4334 335.002 81.12 335.002 80.7334C335.002 80.3469 334.688 80.0334 334.302 80.0334C333.915 80.0334 333.602 80.3469 333.602 80.7334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 80.7332C315.398 81.1197 315.712 81.4332 316.098 81.4332C316.485 81.4332 316.798 81.1197 316.798 80.7332C316.798 80.3467 316.485 80.0332 316.098 80.0332C315.712 80.0332 315.398 80.3467 315.398 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 80.7332C297.203 81.1197 297.517 81.4332 297.903 81.4332C298.29 81.4332 298.603 81.1197 298.603 80.7332C298.603 80.3467 298.29 80.0332 297.903 80.0332C297.517 80.0332 297.203 80.3467 297.203 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 80.7332C279 81.1197 279.314 81.4332 279.7 81.4332C280.086 81.4332 280.4 81.1197 280.4 80.7332C280.4 80.3467 280.086 80.0332 279.7 80.0332C279.314 80.0332 279 80.3467 279 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 80.7332C260.805 81.1197 261.118 81.4332 261.505 81.4332C261.891 81.4332 262.205 81.1197 262.205 80.7332C262.205 80.3467 261.891 80.0332 261.505 80.0332C261.118 80.0332 260.805 80.3467 260.805 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 80.7334C242.602 81.12 242.915 81.4334 243.302 81.4334C243.688 81.4334 244.002 81.12 244.002 80.7334C244.002 80.3469 243.688 80.0334 243.302 80.0334C242.915 80.0334 242.602 80.3469 242.602 80.7334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 80.7332C224.398 81.1197 224.712 81.4332 225.098 81.4332C225.485 81.4332 225.798 81.1197 225.798 80.7332C225.798 80.3467 225.485 80.0332 225.098 80.0332C224.712 80.0332 224.398 80.3467 224.398 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 80.7332C206.203 81.1197 206.517 81.4332 206.903 81.4332C207.29 81.4332 207.603 81.1197 207.603 80.7332C207.603 80.3467 207.29 80.0332 206.903 80.0332C206.517 80.0332 206.203 80.3467 206.203 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 80.7332C188 81.1197 188.314 81.4332 188.7 81.4332C189.086 81.4332 189.4 81.1197 189.4 80.7332C189.4 80.3467 189.086 80.0332 188.7 80.0332C188.314 80.0332 188 80.3467 188 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 98.9334C351.805 99.3199 352.118 99.6334 352.505 99.6334C352.891 99.6334 353.205 99.3199 353.205 98.9334C353.205 98.5469 352.891 98.2334 352.505 98.2334C352.118 98.2334 351.805 98.5469 351.805 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 98.9334C333.602 99.3199 333.915 99.6334 334.302 99.6334C334.688 99.6334 335.002 99.3199 335.002 98.9334C335.002 98.5469 334.688 98.2334 334.302 98.2334C333.915 98.2334 333.602 98.5469 333.602 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 98.9334C315.398 99.3199 315.712 99.6334 316.098 99.6334C316.485 99.6334 316.798 99.3199 316.798 98.9334C316.798 98.5469 316.485 98.2334 316.098 98.2334C315.712 98.2334 315.398 98.5469 315.398 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 98.9334C297.203 99.3199 297.517 99.6334 297.903 99.6334C298.29 99.6334 298.603 99.3199 298.603 98.9334C298.603 98.5469 298.29 98.2334 297.903 98.2334C297.517 98.2334 297.203 98.5469 297.203 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 98.9334C279 99.3199 279.314 99.6334 279.7 99.6334C280.086 99.6334 280.4 99.3199 280.4 98.9334C280.4 98.5469 280.086 98.2334 279.7 98.2334C279.314 98.2334 279 98.5469 279 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 98.9334C260.805 99.3199 261.118 99.6334 261.505 99.6334C261.891 99.6334 262.205 99.3199 262.205 98.9334C262.205 98.5469 261.891 98.2334 261.505 98.2334C261.118 98.2334 260.805 98.5469 260.805 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 98.9334C242.602 99.3199 242.915 99.6334 243.302 99.6334C243.688 99.6334 244.002 99.3199 244.002 98.9334C244.002 98.5469 243.688 98.2334 243.302 98.2334C242.915 98.2334 242.602 98.5469 242.602 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 98.9334C224.398 99.3199 224.712 99.6334 225.098 99.6334C225.485 99.6334 225.798 99.3199 225.798 98.9334C225.798 98.5469 225.485 98.2334 225.098 98.2334C224.712 98.2334 224.398 98.5469 224.398 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 98.9334C206.203 99.3199 206.517 99.6334 206.903 99.6334C207.29 99.6334 207.603 99.3199 207.603 98.9334C207.603 98.5469 207.29 98.2334 206.903 98.2334C206.517 98.2334 206.203 98.5469 206.203 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 98.9334C188 99.3199 188.314 99.6334 188.7 99.6334C189.086 99.6334 189.4 99.3199 189.4 98.9334C189.4 98.5469 189.086 98.2334 188.7 98.2334C188.314 98.2334 188 98.5469 188 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 117.134C351.805 117.52 352.118 117.834 352.505 117.834C352.891 117.834 353.205 117.52 353.205 117.134C353.205 116.747 352.891 116.434 352.505 116.434C352.118 116.434 351.805 116.747 351.805 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 117.133C333.602 117.52 333.915 117.833 334.302 117.833C334.688 117.833 335.002 117.52 335.002 117.133C335.002 116.747 334.688 116.433 334.302 116.433C333.915 116.433 333.602 116.747 333.602 117.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 117.134C315.398 117.52 315.712 117.834 316.098 117.834C316.485 117.834 316.798 117.52 316.798 117.134C316.798 116.747 316.485 116.434 316.098 116.434C315.712 116.434 315.398 116.747 315.398 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 117.134C297.203 117.52 297.517 117.834 297.903 117.834C298.29 117.834 298.603 117.52 298.603 117.134C298.603 116.747 298.29 116.434 297.903 116.434C297.517 116.434 297.203 116.747 297.203 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 117.134C279 117.52 279.314 117.834 279.7 117.834C280.086 117.834 280.4 117.52 280.4 117.134C280.4 116.747 280.086 116.434 279.7 116.434C279.314 116.434 279 116.747 279 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 117.134C260.805 117.52 261.118 117.834 261.505 117.834C261.891 117.834 262.205 117.52 262.205 117.134C262.205 116.747 261.891 116.434 261.505 116.434C261.118 116.434 260.805 116.747 260.805 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 117.133C242.602 117.52 242.915 117.833 243.302 117.833C243.688 117.833 244.002 117.52 244.002 117.133C244.002 116.747 243.688 116.433 243.302 116.433C242.915 116.433 242.602 116.747 242.602 117.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 117.134C224.398 117.52 224.712 117.834 225.098 117.834C225.485 117.834 225.798 117.52 225.798 117.134C225.798 116.747 225.485 116.434 225.098 116.434C224.712 116.434 224.398 116.747 224.398 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 117.134C206.203 117.52 206.517 117.834 206.903 117.834C207.29 117.834 207.603 117.52 207.603 117.134C207.603 116.747 207.29 116.434 206.903 116.434C206.517 116.434 206.203 116.747 206.203 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 117.134C188 117.52 188.314 117.834 188.7 117.834C189.086 117.834 189.4 117.52 189.4 117.134C189.4 116.747 189.086 116.434 188.7 116.434C188.314 116.434 188 116.747 188 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 135.334C351.805 135.72 352.118 136.034 352.505 136.034C352.891 136.034 353.205 135.72 353.205 135.334C353.205 134.947 352.891 134.634 352.505 134.634C352.118 134.634 351.805 134.947 351.805 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 135.334C333.602 135.72 333.915 136.034 334.302 136.034C334.688 136.034 335.002 135.72 335.002 135.334C335.002 134.947 334.688 134.634 334.302 134.634C333.915 134.634 333.602 134.947 333.602 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 135.334C315.398 135.72 315.712 136.034 316.098 136.034C316.485 136.034 316.798 135.72 316.798 135.334C316.798 134.947 316.485 134.634 316.098 134.634C315.712 134.634 315.398 134.947 315.398 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 135.334C297.203 135.72 297.517 136.034 297.903 136.034C298.29 136.034 298.603 135.72 298.603 135.334C298.603 134.947 298.29 134.634 297.903 134.634C297.517 134.634 297.203 134.947 297.203 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 135.334C279 135.72 279.314 136.034 279.7 136.034C280.086 136.034 280.4 135.72 280.4 135.334C280.4 134.947 280.086 134.634 279.7 134.634C279.314 134.634 279 134.947 279 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 135.334C260.805 135.72 261.118 136.034 261.505 136.034C261.891 136.034 262.205 135.72 262.205 135.334C262.205 134.947 261.891 134.634 261.505 134.634C261.118 134.634 260.805 134.947 260.805 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 135.334C242.602 135.72 242.915 136.034 243.302 136.034C243.688 136.034 244.002 135.72 244.002 135.334C244.002 134.947 243.688 134.634 243.302 134.634C242.915 134.634 242.602 134.947 242.602 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 135.334C224.398 135.72 224.712 136.034 225.098 136.034C225.485 136.034 225.798 135.72 225.798 135.334C225.798 134.947 225.485 134.634 225.098 134.634C224.712 134.634 224.398 134.947 224.398 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 135.334C206.203 135.72 206.517 136.034 206.903 136.034C207.29 136.034 207.603 135.72 207.603 135.334C207.603 134.947 207.29 134.634 206.903 134.634C206.517 134.634 206.203 134.947 206.203 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 135.334C188 135.72 188.314 136.034 188.7 136.034C189.086 136.034 189.4 135.72 189.4 135.334C189.4 134.947 189.086 134.634 188.7 134.634C188.314 134.634 188 134.947 188 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 153.533C351.805 153.919 352.118 154.233 352.505 154.233C352.891 154.233 353.205 153.919 353.205 153.533C353.205 153.147 352.891 152.833 352.505 152.833C352.118 152.833 351.805 153.147 351.805 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 153.533C333.602 153.919 333.915 154.233 334.302 154.233C334.688 154.233 335.002 153.919 335.002 153.533C335.002 153.147 334.688 152.833 334.302 152.833C333.915 152.833 333.602 153.147 333.602 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 153.533C315.398 153.919 315.712 154.233 316.098 154.233C316.485 154.233 316.798 153.919 316.798 153.533C316.798 153.147 316.485 152.833 316.098 152.833C315.712 152.833 315.398 153.147 315.398 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 153.533C297.203 153.919 297.517 154.233 297.903 154.233C298.29 154.233 298.603 153.919 298.603 153.533C298.603 153.147 298.29 152.833 297.903 152.833C297.517 152.833 297.203 153.147 297.203 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 153.533C279 153.919 279.314 154.233 279.7 154.233C280.086 154.233 280.4 153.919 280.4 153.533C280.4 153.147 280.086 152.833 279.7 152.833C279.314 152.833 279 153.147 279 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 153.533C260.805 153.919 261.118 154.233 261.505 154.233C261.891 154.233 262.205 153.919 262.205 153.533C262.205 153.147 261.891 152.833 261.505 152.833C261.118 152.833 260.805 153.147 260.805 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 153.533C242.602 153.919 242.915 154.233 243.302 154.233C243.688 154.233 244.002 153.919 244.002 153.533C244.002 153.147 243.688 152.833 243.302 152.833C242.915 152.833 242.602 153.147 242.602 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 153.533C224.398 153.919 224.712 154.233 225.098 154.233C225.485 154.233 225.798 153.919 225.798 153.533C225.798 153.147 225.485 152.833 225.098 152.833C224.712 152.833 224.398 153.147 224.398 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 153.533C206.203 153.919 206.517 154.233 206.903 154.233C207.29 154.233 207.603 153.919 207.603 153.533C207.603 153.147 207.29 152.833 206.903 152.833C206.517 152.833 206.203 153.147 206.203 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 153.533C188 153.919 188.314 154.233 188.7 154.233C189.086 154.233 189.4 153.919 189.4 153.533C189.4 153.147 189.086 152.833 188.7 152.833C188.314 152.833 188 153.147 188 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 171.733C351.805 172.12 352.118 172.433 352.505 172.433C352.891 172.433 353.205 172.12 353.205 171.733C353.205 171.347 352.891 171.033 352.505 171.033C352.118 171.033 351.805 171.347 351.805 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 171.733C333.602 172.12 333.915 172.433 334.302 172.433C334.688 172.433 335.002 172.12 335.002 171.733C335.002 171.347 334.688 171.033 334.302 171.033C333.915 171.033 333.602 171.347 333.602 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 171.733C315.398 172.12 315.712 172.433 316.098 172.433C316.485 172.433 316.798 172.12 316.798 171.733C316.798 171.347 316.485 171.033 316.098 171.033C315.712 171.033 315.398 171.347 315.398 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 171.733C297.203 172.12 297.517 172.433 297.903 172.433C298.29 172.433 298.603 172.12 298.603 171.733C298.603 171.347 298.29 171.033 297.903 171.033C297.517 171.033 297.203 171.347 297.203 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 171.733C279 172.12 279.314 172.433 279.7 172.433C280.086 172.433 280.4 172.12 280.4 171.733C280.4 171.347 280.086 171.033 279.7 171.033C279.314 171.033 279 171.347 279 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 171.733C260.805 172.12 261.118 172.433 261.505 172.433C261.891 172.433 262.205 172.12 262.205 171.733C262.205 171.347 261.891 171.033 261.505 171.033C261.118 171.033 260.805 171.347 260.805 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 171.733C242.602 172.12 242.915 172.433 243.302 172.433C243.688 172.433 244.002 172.12 244.002 171.733C244.002 171.347 243.688 171.033 243.302 171.033C242.915 171.033 242.602 171.347 242.602 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 171.733C224.398 172.12 224.712 172.433 225.098 172.433C225.485 172.433 225.798 172.12 225.798 171.733C225.798 171.347 225.485 171.033 225.098 171.033C224.712 171.033 224.398 171.347 224.398 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 171.733C206.203 172.12 206.517 172.433 206.903 172.433C207.29 172.433 207.603 172.12 207.603 171.733C207.603 171.347 207.29 171.033 206.903 171.033C206.517 171.033 206.203 171.347 206.203 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 171.733C188 172.12 188.314 172.433 188.7 172.433C189.086 172.433 189.4 172.12 189.4 171.733C189.4 171.347 189.086 171.033 188.7 171.033C188.314 171.033 188 171.347 188 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 189.933C351.805 190.32 352.118 190.633 352.505 190.633C352.891 190.633 353.205 190.32 353.205 189.933C353.205 189.547 352.891 189.233 352.505 189.233C352.118 189.233 351.805 189.547 351.805 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 189.933C333.602 190.32 333.915 190.633 334.302 190.633C334.688 190.633 335.002 190.32 335.002 189.933C335.002 189.547 334.688 189.233 334.302 189.233C333.915 189.233 333.602 189.547 333.602 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 189.933C315.398 190.32 315.712 190.633 316.098 190.633C316.485 190.633 316.798 190.32 316.798 189.933C316.798 189.547 316.485 189.233 316.098 189.233C315.712 189.233 315.398 189.547 315.398 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 189.933C297.203 190.32 297.517 190.633 297.903 190.633C298.29 190.633 298.603 190.32 298.603 189.933C298.603 189.547 298.29 189.233 297.903 189.233C297.517 189.233 297.203 189.547 297.203 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 189.933C279 190.32 279.314 190.633 279.7 190.633C280.086 190.633 280.4 190.32 280.4 189.933C280.4 189.547 280.086 189.233 279.7 189.233C279.314 189.233 279 189.547 279 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 189.933C260.805 190.32 261.118 190.633 261.505 190.633C261.891 190.633 262.205 190.32 262.205 189.933C262.205 189.547 261.891 189.233 261.505 189.233C261.118 189.233 260.805 189.547 260.805 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 189.933C242.602 190.32 242.915 190.633 243.302 190.633C243.688 190.633 244.002 190.32 244.002 189.933C244.002 189.547 243.688 189.233 243.302 189.233C242.915 189.233 242.602 189.547 242.602 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 189.933C224.398 190.32 224.712 190.633 225.098 190.633C225.485 190.633 225.798 190.32 225.798 189.933C225.798 189.547 225.485 189.233 225.098 189.233C224.712 189.233 224.398 189.547 224.398 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 189.933C206.203 190.32 206.517 190.633 206.903 190.633C207.29 190.633 207.603 190.32 207.603 189.933C207.603 189.547 207.29 189.233 206.903 189.233C206.517 189.233 206.203 189.547 206.203 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 189.933C188 190.32 188.314 190.633 188.7 190.633C189.086 190.633 189.4 190.32 189.4 189.933C189.4 189.547 189.086 189.233 188.7 189.233C188.314 189.233 188 189.547 188 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 208.134C351.805 208.52 352.118 208.834 352.505 208.834C352.891 208.834 353.205 208.52 353.205 208.134C353.205 207.747 352.891 207.434 352.505 207.434C352.118 207.434 351.805 207.747 351.805 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 208.133C333.602 208.52 333.915 208.833 334.302 208.833C334.688 208.833 335.002 208.52 335.002 208.133C335.002 207.747 334.688 207.433 334.302 207.433C333.915 207.433 333.602 207.747 333.602 208.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 208.134C315.398 208.52 315.712 208.834 316.098 208.834C316.485 208.834 316.798 208.52 316.798 208.134C316.798 207.747 316.485 207.434 316.098 207.434C315.712 207.434 315.398 207.747 315.398 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 208.134C297.203 208.52 297.517 208.834 297.903 208.834C298.29 208.834 298.603 208.52 298.603 208.134C298.603 207.747 298.29 207.434 297.903 207.434C297.517 207.434 297.203 207.747 297.203 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 208.134C279 208.52 279.314 208.834 279.7 208.834C280.086 208.834 280.4 208.52 280.4 208.134C280.4 207.747 280.086 207.434 279.7 207.434C279.314 207.434 279 207.747 279 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 208.134C260.805 208.52 261.118 208.834 261.505 208.834C261.891 208.834 262.205 208.52 262.205 208.134C262.205 207.747 261.891 207.434 261.505 207.434C261.118 207.434 260.805 207.747 260.805 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 208.133C242.602 208.52 242.915 208.833 243.302 208.833C243.688 208.833 244.002 208.52 244.002 208.133C244.002 207.747 243.688 207.433 243.302 207.433C242.915 207.433 242.602 207.747 242.602 208.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 208.134C224.398 208.52 224.712 208.834 225.098 208.834C225.485 208.834 225.798 208.52 225.798 208.134C225.798 207.747 225.485 207.434 225.098 207.434C224.712 207.434 224.398 207.747 224.398 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 208.134C206.203 208.52 206.517 208.834 206.903 208.834C207.29 208.834 207.603 208.52 207.603 208.134C207.603 207.747 207.29 207.434 206.903 207.434C206.517 207.434 206.203 207.747 206.203 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 208.134C188 208.52 188.314 208.834 188.7 208.834C189.086 208.834 189.4 208.52 189.4 208.134C189.4 207.747 189.086 207.434 188.7 207.434C188.314 207.434 188 207.747 188 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 226.334C351.805 226.72 352.118 227.034 352.505 227.034C352.891 227.034 353.205 226.72 353.205 226.334C353.205 225.947 352.891 225.634 352.505 225.634C352.118 225.634 351.805 225.947 351.805 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 226.334C333.602 226.72 333.915 227.034 334.302 227.034C334.688 227.034 335.002 226.72 335.002 226.334C335.002 225.947 334.688 225.634 334.302 225.634C333.915 225.634 333.602 225.947 333.602 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 226.334C315.398 226.72 315.712 227.034 316.098 227.034C316.485 227.034 316.798 226.72 316.798 226.334C316.798 225.947 316.485 225.634 316.098 225.634C315.712 225.634 315.398 225.947 315.398 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 226.334C297.203 226.72 297.517 227.034 297.903 227.034C298.29 227.034 298.603 226.72 298.603 226.334C298.603 225.947 298.29 225.634 297.903 225.634C297.517 225.634 297.203 225.947 297.203 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 226.334C279 226.72 279.314 227.034 279.7 227.034C280.086 227.034 280.4 226.72 280.4 226.334C280.4 225.947 280.086 225.634 279.7 225.634C279.314 225.634 279 225.947 279 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 226.334C260.805 226.72 261.118 227.034 261.505 227.034C261.891 227.034 262.205 226.72 262.205 226.334C262.205 225.947 261.891 225.634 261.505 225.634C261.118 225.634 260.805 225.947 260.805 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 226.334C242.602 226.72 242.915 227.034 243.302 227.034C243.688 227.034 244.002 226.72 244.002 226.334C244.002 225.947 243.688 225.634 243.302 225.634C242.915 225.634 242.602 225.947 242.602 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 226.334C224.398 226.72 224.712 227.034 225.098 227.034C225.485 227.034 225.798 226.72 225.798 226.334C225.798 225.947 225.485 225.634 225.098 225.634C224.712 225.634 224.398 225.947 224.398 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 226.334C206.203 226.72 206.517 227.034 206.903 227.034C207.29 227.034 207.603 226.72 207.603 226.334C207.603 225.947 207.29 225.634 206.903 225.634C206.517 225.634 206.203 225.947 206.203 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 226.334C188 226.72 188.314 227.034 188.7 227.034C189.086 227.034 189.4 226.72 189.4 226.334C189.4 225.947 189.086 225.634 188.7 225.634C188.314 225.634 188 225.947 188 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 244.533C351.805 244.919 352.118 245.233 352.505 245.233C352.891 245.233 353.205 244.919 353.205 244.533C353.205 244.147 352.891 243.833 352.505 243.833C352.118 243.833 351.805 244.147 351.805 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 244.533C333.602 244.919 333.915 245.233 334.302 245.233C334.688 245.233 335.002 244.919 335.002 244.533C335.002 244.147 334.688 243.833 334.302 243.833C333.915 243.833 333.602 244.147 333.602 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 244.533C315.398 244.919 315.712 245.233 316.098 245.233C316.485 245.233 316.798 244.919 316.798 244.533C316.798 244.147 316.485 243.833 316.098 243.833C315.712 243.833 315.398 244.147 315.398 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 244.533C297.203 244.919 297.517 245.233 297.903 245.233C298.29 245.233 298.603 244.919 298.603 244.533C298.603 244.147 298.29 243.833 297.903 243.833C297.517 243.833 297.203 244.147 297.203 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 244.533C279 244.919 279.314 245.233 279.7 245.233C280.086 245.233 280.4 244.919 280.4 244.533C280.4 244.147 280.086 243.833 279.7 243.833C279.314 243.833 279 244.147 279 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 244.533C260.805 244.919 261.118 245.233 261.505 245.233C261.891 245.233 262.205 244.919 262.205 244.533C262.205 244.147 261.891 243.833 261.505 243.833C261.118 243.833 260.805 244.147 260.805 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 244.533C242.602 244.919 242.915 245.233 243.302 245.233C243.688 245.233 244.002 244.919 244.002 244.533C244.002 244.147 243.688 243.833 243.302 243.833C242.915 243.833 242.602 244.147 242.602 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 244.533C224.398 244.919 224.712 245.233 225.098 245.233C225.485 245.233 225.798 244.919 225.798 244.533C225.798 244.147 225.485 243.833 225.098 243.833C224.712 243.833 224.398 244.147 224.398 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 244.533C206.203 244.919 206.517 245.233 206.903 245.233C207.29 245.233 207.603 244.919 207.603 244.533C207.603 244.147 207.29 243.833 206.903 243.833C206.517 243.833 206.203 244.147 206.203 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 244.533C188 244.919 188.314 245.233 188.7 245.233C189.086 245.233 189.4 244.919 189.4 244.533C189.4 244.147 189.086 243.833 188.7 243.833C188.314 243.833 188 244.147 188 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_6136_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 264.7C7.4 265.087 7.0866 265.4 6.7 265.4C6.3134 265.4 6 265.087 6 264.7C6 264.313 6.3134 264 6.7 264C7.0866 264 7.4 264.313 7.4 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 264.7C25.6031 265.087 25.2897 265.4 24.9031 265.4C24.5166 265.4 24.2031 265.087 24.2031 264.7C24.2031 264.313 24.5166 264 24.9031 264C25.2897 264 25.6031 264.313 25.6031 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 264.7C43.7984 265.087 43.485 265.4 43.0984 265.4C42.7119 265.4 42.3984 265.087 42.3984 264.7C42.3984 264.313 42.7119 264 43.0984 264C43.485 264 43.7984 264.313 43.7984 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 264.7C62.0016 265.087 61.6881 265.4 61.3016 265.4C60.915 265.4 60.6016 265.087 60.6016 264.7C60.6016 264.313 60.915 264 61.3016 264C61.6881 264 62.0016 264.313 62.0016 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 264.7C80.2047 265.087 79.8912 265.4 79.5047 265.4C79.1181 265.4 78.8047 265.087 78.8047 264.7C78.8047 264.313 79.1181 264 79.5047 264C79.8912 264 80.2047 264.313 80.2047 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 264.7C98.4 265.087 98.0865 265.4 97.7 265.4C97.3135 265.4 97 265.087 97 264.7C97 264.313 97.3135 264 97.7 264C98.0865 264 98.4 264.313 98.4 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 264.7C116.603 265.087 116.29 265.4 115.903 265.4C115.517 265.4 115.203 265.087 115.203 264.7C115.203 264.313 115.517 264 115.903 264C116.29 264 116.603 264.313 116.603 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 264.7C134.798 265.087 134.485 265.4 134.098 265.4C133.712 265.4 133.398 265.087 133.398 264.7C133.398 264.313 133.712 264 134.098 264C134.485 264 134.798 264.313 134.798 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 264.7C153.002 265.087 152.688 265.4 152.302 265.4C151.915 265.4 151.602 265.087 151.602 264.7C151.602 264.313 151.915 264 152.302 264C152.688 264 153.002 264.313 153.002 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 264.7C171.205 265.087 170.891 265.4 170.505 265.4C170.118 265.4 169.805 265.087 169.805 264.7C169.805 264.313 170.118 264 170.505 264C170.891 264 171.205 264.313 171.205 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 282.9C7.4 283.287 7.0866 283.6 6.7 283.6C6.3134 283.6 6 283.287 6 282.9C6 282.514 6.3134 282.2 6.7 282.2C7.0866 282.2 7.4 282.514 7.4 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 282.9C25.6031 283.287 25.2897 283.6 24.9031 283.6C24.5166 283.6 24.2031 283.287 24.2031 282.9C24.2031 282.514 24.5166 282.2 24.9031 282.2C25.2897 282.2 25.6031 282.514 25.6031 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 282.9C43.7984 283.287 43.485 283.6 43.0984 283.6C42.7119 283.6 42.3984 283.287 42.3984 282.9C42.3984 282.514 42.7119 282.2 43.0984 282.2C43.485 282.2 43.7984 282.514 43.7984 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 282.9C62.0016 283.286 61.6881 283.6 61.3016 283.6C60.915 283.6 60.6016 283.286 60.6016 282.9C60.6016 282.513 60.915 282.2 61.3016 282.2C61.6881 282.2 62.0016 282.513 62.0016 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 282.9C80.2047 283.287 79.8912 283.6 79.5047 283.6C79.1181 283.6 78.8047 283.287 78.8047 282.9C78.8047 282.514 79.1181 282.2 79.5047 282.2C79.8912 282.2 80.2047 282.514 80.2047 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 282.9C98.4 283.287 98.0865 283.6 97.7 283.6C97.3135 283.6 97 283.287 97 282.9C97 282.514 97.3135 282.2 97.7 282.2C98.0865 282.2 98.4 282.514 98.4 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 282.9C116.603 283.287 116.29 283.6 115.903 283.6C115.517 283.6 115.203 283.287 115.203 282.9C115.203 282.514 115.517 282.2 115.903 282.2C116.29 282.2 116.603 282.514 116.603 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 282.9C134.798 283.287 134.485 283.6 134.098 283.6C133.712 283.6 133.398 283.287 133.398 282.9C133.398 282.514 133.712 282.2 134.098 282.2C134.485 282.2 134.798 282.514 134.798 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 282.9C153.002 283.286 152.688 283.6 152.302 283.6C151.915 283.6 151.602 283.286 151.602 282.9C151.602 282.513 151.915 282.2 152.302 282.2C152.688 282.2 153.002 282.513 153.002 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 282.9C171.205 283.287 170.891 283.6 170.505 283.6C170.118 283.6 169.805 283.287 169.805 282.9C169.805 282.514 170.118 282.2 170.505 282.2C170.891 282.2 171.205 282.514 171.205 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 301.1C7.4 301.487 7.0866 301.8 6.7 301.8C6.3134 301.8 6 301.487 6 301.1C6 300.714 6.3134 300.4 6.7 300.4C7.0866 300.4 7.4 300.714 7.4 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 301.1C25.6031 301.487 25.2897 301.8 24.9031 301.8C24.5166 301.8 24.2031 301.487 24.2031 301.1C24.2031 300.714 24.5166 300.4 24.9031 300.4C25.2897 300.4 25.6031 300.714 25.6031 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 301.1C43.7984 301.487 43.485 301.8 43.0984 301.8C42.7119 301.8 42.3984 301.487 42.3984 301.1C42.3984 300.714 42.7119 300.4 43.0984 300.4C43.485 300.4 43.7984 300.714 43.7984 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 301.1C62.0016 301.487 61.6881 301.8 61.3016 301.8C60.915 301.8 60.6016 301.487 60.6016 301.1C60.6016 300.714 60.915 300.4 61.3016 300.4C61.6881 300.4 62.0016 300.714 62.0016 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 301.1C80.2047 301.487 79.8912 301.8 79.5047 301.8C79.1181 301.8 78.8047 301.487 78.8047 301.1C78.8047 300.714 79.1181 300.4 79.5047 300.4C79.8912 300.4 80.2047 300.714 80.2047 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 301.1C98.4 301.487 98.0865 301.8 97.7 301.8C97.3135 301.8 97 301.487 97 301.1C97 300.714 97.3135 300.4 97.7 300.4C98.0865 300.4 98.4 300.714 98.4 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 301.1C116.603 301.487 116.29 301.8 115.903 301.8C115.517 301.8 115.203 301.487 115.203 301.1C115.203 300.714 115.517 300.4 115.903 300.4C116.29 300.4 116.603 300.714 116.603 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 301.1C134.798 301.487 134.485 301.8 134.098 301.8C133.712 301.8 133.398 301.487 133.398 301.1C133.398 300.714 133.712 300.4 134.098 300.4C134.485 300.4 134.798 300.714 134.798 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 301.1C153.002 301.487 152.688 301.8 152.302 301.8C151.915 301.8 151.602 301.487 151.602 301.1C151.602 300.714 151.915 300.4 152.302 300.4C152.688 300.4 153.002 300.714 153.002 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 301.1C171.205 301.487 170.891 301.8 170.505 301.8C170.118 301.8 169.805 301.487 169.805 301.1C169.805 300.714 170.118 300.4 170.505 300.4C170.891 300.4 171.205 300.714 171.205 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 319.3C7.4 319.686 7.0866 320 6.7 320C6.3134 320 6 319.686 6 319.3C6 318.913 6.3134 318.6 6.7 318.6C7.0866 318.6 7.4 318.913 7.4 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 319.3C25.6031 319.686 25.2897 320 24.9031 320C24.5166 320 24.2031 319.686 24.2031 319.3C24.2031 318.913 24.5166 318.6 24.9031 318.6C25.2897 318.6 25.6031 318.913 25.6031 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 319.3C43.7984 319.686 43.485 320 43.0984 320C42.7119 320 42.3984 319.686 42.3984 319.3C42.3984 318.913 42.7119 318.6 43.0984 318.6C43.485 318.6 43.7984 318.913 43.7984 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 319.3C62.0016 319.686 61.6881 320 61.3016 320C60.915 320 60.6016 319.686 60.6016 319.3C60.6016 318.913 60.915 318.6 61.3016 318.6C61.6881 318.6 62.0016 318.913 62.0016 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 319.3C80.2047 319.686 79.8912 320 79.5047 320C79.1181 320 78.8047 319.686 78.8047 319.3C78.8047 318.913 79.1181 318.6 79.5047 318.6C79.8912 318.6 80.2047 318.913 80.2047 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 319.3C98.4 319.686 98.0865 320 97.7 320C97.3135 320 97 319.686 97 319.3C97 318.913 97.3135 318.6 97.7 318.6C98.0865 318.6 98.4 318.913 98.4 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 319.3C116.603 319.686 116.29 320 115.903 320C115.517 320 115.203 319.686 115.203 319.3C115.203 318.913 115.517 318.6 115.903 318.6C116.29 318.6 116.603 318.913 116.603 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 319.3C134.798 319.686 134.485 320 134.098 320C133.712 320 133.398 319.686 133.398 319.3C133.398 318.913 133.712 318.6 134.098 318.6C134.485 318.6 134.798 318.913 134.798 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 319.3C153.002 319.686 152.688 320 152.302 320C151.915 320 151.602 319.686 151.602 319.3C151.602 318.913 151.915 318.6 152.302 318.6C152.688 318.6 153.002 318.913 153.002 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 319.3C171.205 319.686 170.891 320 170.505 320C170.118 320 169.805 319.686 169.805 319.3C169.805 318.913 170.118 318.6 170.505 318.6C170.891 318.6 171.205 318.913 171.205 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 337.5C7.4 337.886 7.0866 338.2 6.7 338.2C6.3134 338.2 6 337.886 6 337.5C6 337.113 6.3134 336.8 6.7 336.8C7.0866 336.8 7.4 337.113 7.4 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 337.5C25.6031 337.886 25.2897 338.2 24.9031 338.2C24.5166 338.2 24.2031 337.886 24.2031 337.5C24.2031 337.113 24.5166 336.8 24.9031 336.8C25.2897 336.8 25.6031 337.113 25.6031 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 337.5C43.7984 337.886 43.485 338.2 43.0984 338.2C42.7119 338.2 42.3984 337.886 42.3984 337.5C42.3984 337.113 42.7119 336.8 43.0984 336.8C43.485 336.8 43.7984 337.113 43.7984 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 337.5C62.0016 337.887 61.6881 338.2 61.3016 338.2C60.915 338.2 60.6016 337.887 60.6016 337.5C60.6016 337.114 60.915 336.8 61.3016 336.8C61.6881 336.8 62.0016 337.114 62.0016 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 337.5C80.2047 337.886 79.8912 338.2 79.5047 338.2C79.1181 338.2 78.8047 337.886 78.8047 337.5C78.8047 337.113 79.1181 336.8 79.5047 336.8C79.8912 336.8 80.2047 337.113 80.2047 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 337.5C98.4 337.886 98.0865 338.2 97.7 338.2C97.3135 338.2 97 337.886 97 337.5C97 337.113 97.3135 336.8 97.7 336.8C98.0865 336.8 98.4 337.113 98.4 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 337.5C116.603 337.886 116.29 338.2 115.903 338.2C115.517 338.2 115.203 337.886 115.203 337.5C115.203 337.113 115.517 336.8 115.903 336.8C116.29 336.8 116.603 337.113 116.603 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 337.5C134.798 337.886 134.485 338.2 134.098 338.2C133.712 338.2 133.398 337.886 133.398 337.5C133.398 337.113 133.712 336.8 134.098 336.8C134.485 336.8 134.798 337.113 134.798 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 337.5C153.002 337.887 152.688 338.2 152.302 338.2C151.915 338.2 151.602 337.887 151.602 337.5C151.602 337.114 151.915 336.8 152.302 336.8C152.688 336.8 153.002 337.114 153.002 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 337.5C171.205 337.886 170.891 338.2 170.505 338.2C170.118 338.2 169.805 337.886 169.805 337.5C169.805 337.113 170.118 336.8 170.505 336.8C170.891 336.8 171.205 337.113 171.205 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 355.7C7.4 356.087 7.0866 356.4 6.7 356.4C6.3134 356.4 6 356.087 6 355.7C6 355.313 6.3134 355 6.7 355C7.0866 355 7.4 355.313 7.4 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6031 355.7C25.6031 356.087 25.2897 356.4 24.9031 356.4C24.5166 356.4 24.2031 356.087 24.2031 355.7C24.2031 355.313 24.5166 355 24.9031 355C25.2897 355 25.6031 355.313 25.6031 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7984 355.7C43.7984 356.087 43.485 356.4 43.0984 356.4C42.7119 356.4 42.3984 356.087 42.3984 355.7C42.3984 355.313 42.7119 355 43.0984 355C43.485 355 43.7984 355.313 43.7984 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0016 355.7C62.0016 356.087 61.6881 356.4 61.3016 356.4C60.915 356.4 60.6016 356.087 60.6016 355.7C60.6016 355.313 60.915 355 61.3016 355C61.6881 355 62.0016 355.313 62.0016 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2047 355.7C80.2047 356.087 79.8912 356.4 79.5047 356.4C79.1181 356.4 78.8047 356.087 78.8047 355.7C78.8047 355.313 79.1181 355 79.5047 355C79.8912 355 80.2047 355.313 80.2047 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 355.7C98.4 356.087 98.0865 356.4 97.7 356.4C97.3135 356.4 97 356.087 97 355.7C97 355.313 97.3135 355 97.7 355C98.0865 355 98.4 355.313 98.4 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.603 355.7C116.603 356.087 116.29 356.4 115.903 356.4C115.517 356.4 115.203 356.087 115.203 355.7C115.203 355.313 115.517 355 115.903 355C116.29 355 116.603 355.313 116.603 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 355.7C134.798 356.087 134.485 356.4 134.098 356.4C133.712 356.4 133.398 356.087 133.398 355.7C133.398 355.313 133.712 355 134.098 355C134.485 355 134.798 355.313 134.798 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.002 355.7C153.002 356.087 152.688 356.4 152.302 356.4C151.915 356.4 151.602 356.087 151.602 355.7C151.602 355.313 151.915 355 152.302 355C152.688 355 153.002 355.313 153.002 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.205 355.7C171.205 356.087 170.891 356.4 170.505 356.4C170.118 356.4 169.805 356.087 169.805 355.7C169.805 355.313 170.118 355 170.505 355C170.891 355 171.205 355.313 171.205 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 264.7C351.805 265.087 352.118 265.4 352.505 265.4C352.891 265.4 353.205 265.087 353.205 264.7C353.205 264.313 352.891 264 352.505 264C352.118 264 351.805 264.313 351.805 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 264.7C333.602 265.087 333.915 265.4 334.302 265.4C334.688 265.4 335.002 265.087 335.002 264.7C335.002 264.313 334.688 264 334.302 264C333.915 264 333.602 264.313 333.602 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 264.7C315.398 265.087 315.712 265.4 316.098 265.4C316.485 265.4 316.798 265.087 316.798 264.7C316.798 264.313 316.485 264 316.098 264C315.712 264 315.398 264.313 315.398 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 264.7C297.203 265.087 297.517 265.4 297.903 265.4C298.29 265.4 298.603 265.087 298.603 264.7C298.603 264.313 298.29 264 297.903 264C297.517 264 297.203 264.313 297.203 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 264.7C279 265.087 279.314 265.4 279.7 265.4C280.086 265.4 280.4 265.087 280.4 264.7C280.4 264.313 280.086 264 279.7 264C279.314 264 279 264.313 279 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 264.7C260.805 265.087 261.118 265.4 261.505 265.4C261.891 265.4 262.205 265.087 262.205 264.7C262.205 264.313 261.891 264 261.505 264C261.118 264 260.805 264.313 260.805 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 264.7C242.602 265.087 242.915 265.4 243.302 265.4C243.688 265.4 244.002 265.087 244.002 264.7C244.002 264.313 243.688 264 243.302 264C242.915 264 242.602 264.313 242.602 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 264.7C224.398 265.087 224.712 265.4 225.098 265.4C225.485 265.4 225.798 265.087 225.798 264.7C225.798 264.313 225.485 264 225.098 264C224.712 264 224.398 264.313 224.398 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 264.7C206.203 265.087 206.517 265.4 206.903 265.4C207.29 265.4 207.603 265.087 207.603 264.7C207.603 264.313 207.29 264 206.903 264C206.517 264 206.203 264.313 206.203 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 264.7C188 265.087 188.314 265.4 188.7 265.4C189.086 265.4 189.4 265.087 189.4 264.7C189.4 264.313 189.086 264 188.7 264C188.314 264 188 264.313 188 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 282.9C351.805 283.287 352.118 283.6 352.505 283.6C352.891 283.6 353.205 283.287 353.205 282.9C353.205 282.514 352.891 282.2 352.505 282.2C352.118 282.2 351.805 282.514 351.805 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 282.9C333.602 283.286 333.915 283.6 334.302 283.6C334.688 283.6 335.002 283.286 335.002 282.9C335.002 282.513 334.688 282.2 334.302 282.2C333.915 282.2 333.602 282.513 333.602 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 282.9C315.398 283.287 315.712 283.6 316.098 283.6C316.485 283.6 316.798 283.287 316.798 282.9C316.798 282.514 316.485 282.2 316.098 282.2C315.712 282.2 315.398 282.514 315.398 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 282.9C297.203 283.287 297.517 283.6 297.903 283.6C298.29 283.6 298.603 283.287 298.603 282.9C298.603 282.514 298.29 282.2 297.903 282.2C297.517 282.2 297.203 282.514 297.203 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 282.9C279 283.287 279.314 283.6 279.7 283.6C280.086 283.6 280.4 283.287 280.4 282.9C280.4 282.514 280.086 282.2 279.7 282.2C279.314 282.2 279 282.514 279 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 282.9C260.805 283.287 261.118 283.6 261.505 283.6C261.891 283.6 262.205 283.287 262.205 282.9C262.205 282.514 261.891 282.2 261.505 282.2C261.118 282.2 260.805 282.514 260.805 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 282.9C242.602 283.286 242.915 283.6 243.302 283.6C243.688 283.6 244.002 283.286 244.002 282.9C244.002 282.513 243.688 282.2 243.302 282.2C242.915 282.2 242.602 282.513 242.602 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 282.9C224.398 283.287 224.712 283.6 225.098 283.6C225.485 283.6 225.798 283.287 225.798 282.9C225.798 282.514 225.485 282.2 225.098 282.2C224.712 282.2 224.398 282.514 224.398 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 282.9C206.203 283.287 206.517 283.6 206.903 283.6C207.29 283.6 207.603 283.287 207.603 282.9C207.603 282.514 207.29 282.2 206.903 282.2C206.517 282.2 206.203 282.514 206.203 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 282.9C188 283.287 188.314 283.6 188.7 283.6C189.086 283.6 189.4 283.287 189.4 282.9C189.4 282.514 189.086 282.2 188.7 282.2C188.314 282.2 188 282.514 188 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 301.1C351.805 301.487 352.118 301.8 352.505 301.8C352.891 301.8 353.205 301.487 353.205 301.1C353.205 300.714 352.891 300.4 352.505 300.4C352.118 300.4 351.805 300.714 351.805 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 301.1C333.602 301.487 333.915 301.8 334.302 301.8C334.688 301.8 335.002 301.487 335.002 301.1C335.002 300.714 334.688 300.4 334.302 300.4C333.915 300.4 333.602 300.714 333.602 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 301.1C315.398 301.487 315.712 301.8 316.098 301.8C316.485 301.8 316.798 301.487 316.798 301.1C316.798 300.714 316.485 300.4 316.098 300.4C315.712 300.4 315.398 300.714 315.398 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 301.1C297.203 301.487 297.517 301.8 297.903 301.8C298.29 301.8 298.603 301.487 298.603 301.1C298.603 300.714 298.29 300.4 297.903 300.4C297.517 300.4 297.203 300.714 297.203 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 301.1C279 301.487 279.314 301.8 279.7 301.8C280.086 301.8 280.4 301.487 280.4 301.1C280.4 300.714 280.086 300.4 279.7 300.4C279.314 300.4 279 300.714 279 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 301.1C260.805 301.487 261.118 301.8 261.505 301.8C261.891 301.8 262.205 301.487 262.205 301.1C262.205 300.714 261.891 300.4 261.505 300.4C261.118 300.4 260.805 300.714 260.805 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 301.1C242.602 301.487 242.915 301.8 243.302 301.8C243.688 301.8 244.002 301.487 244.002 301.1C244.002 300.714 243.688 300.4 243.302 300.4C242.915 300.4 242.602 300.714 242.602 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 301.1C224.398 301.487 224.712 301.8 225.098 301.8C225.485 301.8 225.798 301.487 225.798 301.1C225.798 300.714 225.485 300.4 225.098 300.4C224.712 300.4 224.398 300.714 224.398 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 301.1C206.203 301.487 206.517 301.8 206.903 301.8C207.29 301.8 207.603 301.487 207.603 301.1C207.603 300.714 207.29 300.4 206.903 300.4C206.517 300.4 206.203 300.714 206.203 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 301.1C188 301.487 188.314 301.8 188.7 301.8C189.086 301.8 189.4 301.487 189.4 301.1C189.4 300.714 189.086 300.4 188.7 300.4C188.314 300.4 188 300.714 188 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 319.3C351.805 319.686 352.118 320 352.505 320C352.891 320 353.205 319.686 353.205 319.3C353.205 318.913 352.891 318.6 352.505 318.6C352.118 318.6 351.805 318.913 351.805 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 319.3C333.602 319.686 333.915 320 334.302 320C334.688 320 335.002 319.686 335.002 319.3C335.002 318.913 334.688 318.6 334.302 318.6C333.915 318.6 333.602 318.913 333.602 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 319.3C315.398 319.686 315.712 320 316.098 320C316.485 320 316.798 319.686 316.798 319.3C316.798 318.913 316.485 318.6 316.098 318.6C315.712 318.6 315.398 318.913 315.398 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 319.3C297.203 319.686 297.517 320 297.903 320C298.29 320 298.603 319.686 298.603 319.3C298.603 318.913 298.29 318.6 297.903 318.6C297.517 318.6 297.203 318.913 297.203 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 319.3C279 319.686 279.314 320 279.7 320C280.086 320 280.4 319.686 280.4 319.3C280.4 318.913 280.086 318.6 279.7 318.6C279.314 318.6 279 318.913 279 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 319.3C260.805 319.686 261.118 320 261.505 320C261.891 320 262.205 319.686 262.205 319.3C262.205 318.913 261.891 318.6 261.505 318.6C261.118 318.6 260.805 318.913 260.805 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 319.3C242.602 319.686 242.915 320 243.302 320C243.688 320 244.002 319.686 244.002 319.3C244.002 318.913 243.688 318.6 243.302 318.6C242.915 318.6 242.602 318.913 242.602 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 319.3C224.398 319.686 224.712 320 225.098 320C225.485 320 225.798 319.686 225.798 319.3C225.798 318.913 225.485 318.6 225.098 318.6C224.712 318.6 224.398 318.913 224.398 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 319.3C206.203 319.686 206.517 320 206.903 320C207.29 320 207.603 319.686 207.603 319.3C207.603 318.913 207.29 318.6 206.903 318.6C206.517 318.6 206.203 318.913 206.203 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 319.3C188 319.686 188.314 320 188.7 320C189.086 320 189.4 319.686 189.4 319.3C189.4 318.913 189.086 318.6 188.7 318.6C188.314 318.6 188 318.913 188 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 337.5C351.805 337.886 352.118 338.2 352.505 338.2C352.891 338.2 353.205 337.886 353.205 337.5C353.205 337.113 352.891 336.8 352.505 336.8C352.118 336.8 351.805 337.113 351.805 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 337.5C333.602 337.887 333.915 338.2 334.302 338.2C334.688 338.2 335.002 337.887 335.002 337.5C335.002 337.114 334.688 336.8 334.302 336.8C333.915 336.8 333.602 337.114 333.602 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 337.5C315.398 337.886 315.712 338.2 316.098 338.2C316.485 338.2 316.798 337.886 316.798 337.5C316.798 337.113 316.485 336.8 316.098 336.8C315.712 336.8 315.398 337.113 315.398 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 337.5C297.203 337.886 297.517 338.2 297.903 338.2C298.29 338.2 298.603 337.886 298.603 337.5C298.603 337.113 298.29 336.8 297.903 336.8C297.517 336.8 297.203 337.113 297.203 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 337.5C279 337.886 279.314 338.2 279.7 338.2C280.086 338.2 280.4 337.886 280.4 337.5C280.4 337.113 280.086 336.8 279.7 336.8C279.314 336.8 279 337.113 279 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 337.5C260.805 337.886 261.118 338.2 261.505 338.2C261.891 338.2 262.205 337.886 262.205 337.5C262.205 337.113 261.891 336.8 261.505 336.8C261.118 336.8 260.805 337.113 260.805 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 337.5C242.602 337.887 242.915 338.2 243.302 338.2C243.688 338.2 244.002 337.887 244.002 337.5C244.002 337.114 243.688 336.8 243.302 336.8C242.915 336.8 242.602 337.114 242.602 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 337.5C224.398 337.886 224.712 338.2 225.098 338.2C225.485 338.2 225.798 337.886 225.798 337.5C225.798 337.113 225.485 336.8 225.098 336.8C224.712 336.8 224.398 337.113 224.398 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 337.5C206.203 337.886 206.517 338.2 206.903 338.2C207.29 338.2 207.603 337.886 207.603 337.5C207.603 337.113 207.29 336.8 206.903 336.8C206.517 336.8 206.203 337.113 206.203 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 337.5C188 337.886 188.314 338.2 188.7 338.2C189.086 338.2 189.4 337.886 189.4 337.5C189.4 337.113 189.086 336.8 188.7 336.8C188.314 336.8 188 337.113 188 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.805 355.7C351.805 356.087 352.118 356.4 352.505 356.4C352.891 356.4 353.205 356.087 353.205 355.7C353.205 355.313 352.891 355 352.505 355C352.118 355 351.805 355.313 351.805 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.602 355.7C333.602 356.087 333.915 356.4 334.302 356.4C334.688 356.4 335.002 356.087 335.002 355.7C335.002 355.313 334.688 355 334.302 355C333.915 355 333.602 355.313 333.602 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.398 355.7C315.398 356.087 315.712 356.4 316.098 356.4C316.485 356.4 316.798 356.087 316.798 355.7C316.798 355.313 316.485 355 316.098 355C315.712 355 315.398 355.313 315.398 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.203 355.7C297.203 356.087 297.517 356.4 297.903 356.4C298.29 356.4 298.603 356.087 298.603 355.7C298.603 355.313 298.29 355 297.903 355C297.517 355 297.203 355.313 297.203 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 355.7C279 356.087 279.314 356.4 279.7 356.4C280.086 356.4 280.4 356.087 280.4 355.7C280.4 355.313 280.086 355 279.7 355C279.314 355 279 355.313 279 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.805 355.7C260.805 356.087 261.118 356.4 261.505 356.4C261.891 356.4 262.205 356.087 262.205 355.7C262.205 355.313 261.891 355 261.505 355C261.118 355 260.805 355.313 260.805 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.602 355.7C242.602 356.087 242.915 356.4 243.302 356.4C243.688 356.4 244.002 356.087 244.002 355.7C244.002 355.313 243.688 355 243.302 355C242.915 355 242.602 355.313 242.602 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.398 355.7C224.398 356.087 224.712 356.4 225.098 356.4C225.485 356.4 225.798 356.087 225.798 355.7C225.798 355.313 225.485 355 225.098 355C224.712 355 224.398 355.313 224.398 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.203 355.7C206.203 356.087 206.517 356.4 206.903 356.4C207.29 356.4 207.603 356.087 207.603 355.7C207.603 355.313 207.29 355 206.903 355C206.517 355 206.203 355.313 206.203 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 355.7C188 356.087 188.314 356.4 188.7 356.4C189.086 356.4 189.4 356.087 189.4 355.7C189.4 355.313 189.086 355 188.7 355C188.314 355 188 355.313 188 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_6136_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.4 7.9334C370.4 8.32 370.087 8.6334 369.7 8.6334C369.313 8.6334 369 8.32 369 7.9334C369 7.5468 369.313 7.2334 369.7 7.2334C370.087 7.2334 370.4 7.5468 370.4 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 7.9334C388.603 8.32 388.29 8.6334 387.903 8.6334C387.517 8.6334 387.203 8.32 387.203 7.9334C387.203 7.5468 387.517 7.2334 387.903 7.2334C388.29 7.2334 388.603 7.5468 388.603 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 7.9334C406.798 8.32 406.485 8.6334 406.098 8.6334C405.712 8.6334 405.398 8.32 405.398 7.9334C405.398 7.5468 405.712 7.2334 406.098 7.2334C406.485 7.2334 406.798 7.5468 406.798 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 7.9334C425.002 8.32 424.688 8.6334 424.302 8.6334C423.915 8.6334 423.602 8.32 423.602 7.9334C423.602 7.5468 423.915 7.2334 424.302 7.2334C424.688 7.2334 425.002 7.5468 425.002 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 7.9334C443.205 8.32 442.891 8.6334 442.505 8.6334C442.118 8.6334 441.805 8.32 441.805 7.9334C441.805 7.5468 442.118 7.2334 442.505 7.2334C442.891 7.2334 443.205 7.5468 443.205 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 7.9334C461.4 8.32 461.087 8.6334 460.7 8.6334C460.313 8.6334 460 8.32 460 7.9334C460 7.5468 460.313 7.2334 460.7 7.2334C461.087 7.2334 461.4 7.5468 461.4 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 7.9334C479.603 8.32 479.29 8.6334 478.903 8.6334C478.517 8.6334 478.203 8.32 478.203 7.9334C478.203 7.5468 478.517 7.2334 478.903 7.2334C479.29 7.2334 479.603 7.5468 479.603 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 7.9334C497.798 8.32 497.485 8.6334 497.098 8.6334C496.712 8.6334 496.398 8.32 496.398 7.9334C496.398 7.5468 496.712 7.2334 497.098 7.2334C497.485 7.2334 497.798 7.5468 497.798 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 7.9334C516.002 8.32 515.688 8.6334 515.302 8.6334C514.915 8.6334 514.602 8.32 514.602 7.9334C514.602 7.5468 514.915 7.2334 515.302 7.2334C515.688 7.2334 516.002 7.5468 516.002 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 7.9334C534.205 8.32 533.891 8.6334 533.505 8.6334C533.118 8.6334 532.805 8.32 532.805 7.9334C532.805 7.5468 533.118 7.2334 533.505 7.2334C533.891 7.2334 534.205 7.5468 534.205 7.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 26.1336C370.4 26.5201 370.087 26.8336 369.7 26.8336C369.313 26.8336 369 26.5201 369 26.1336C369 25.7471 369.313 25.4336 369.7 25.4336C370.087 25.4336 370.4 25.7471 370.4 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 26.1336C388.603 26.5201 388.29 26.8336 387.903 26.8336C387.517 26.8336 387.203 26.5201 387.203 26.1336C387.203 25.7471 387.517 25.4336 387.903 25.4336C388.29 25.4336 388.603 25.7471 388.603 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 26.1336C406.798 26.5201 406.485 26.8336 406.098 26.8336C405.712 26.8336 405.398 26.5201 405.398 26.1336C405.398 25.7471 405.712 25.4336 406.098 25.4336C406.485 25.4336 406.798 25.7471 406.798 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 26.1333C425.002 26.5199 424.688 26.8333 424.302 26.8333C423.915 26.8333 423.602 26.5199 423.602 26.1333C423.602 25.7468 423.915 25.4333 424.302 25.4333C424.688 25.4333 425.002 25.7468 425.002 26.1333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 26.1336C443.205 26.5201 442.891 26.8336 442.505 26.8336C442.118 26.8336 441.805 26.5201 441.805 26.1336C441.805 25.7471 442.118 25.4336 442.505 25.4336C442.891 25.4336 443.205 25.7471 443.205 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 26.1336C461.4 26.5201 461.087 26.8336 460.7 26.8336C460.313 26.8336 460 26.5201 460 26.1336C460 25.7471 460.313 25.4336 460.7 25.4336C461.087 25.4336 461.4 25.7471 461.4 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 26.1336C479.603 26.5201 479.29 26.8336 478.903 26.8336C478.517 26.8336 478.203 26.5201 478.203 26.1336C478.203 25.7471 478.517 25.4336 478.903 25.4336C479.29 25.4336 479.603 25.7471 479.603 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 26.1336C497.798 26.5201 497.485 26.8336 497.098 26.8336C496.712 26.8336 496.398 26.5201 496.398 26.1336C496.398 25.7471 496.712 25.4336 497.098 25.4336C497.485 25.4336 497.798 25.7471 497.798 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 26.1333C516.002 26.5199 515.688 26.8333 515.302 26.8333C514.915 26.8333 514.602 26.5199 514.602 26.1333C514.602 25.7468 514.915 25.4333 515.302 25.4333C515.688 25.4333 516.002 25.7468 516.002 26.1333Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 26.1336C534.205 26.5201 533.891 26.8336 533.505 26.8336C533.118 26.8336 532.805 26.5201 532.805 26.1336C532.805 25.7471 533.118 25.4336 533.505 25.4336C533.891 25.4336 534.205 25.7471 534.205 26.1336Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 44.3338C370.4 44.7203 370.087 45.0338 369.7 45.0338C369.313 45.0338 369 44.7203 369 44.3338C369 43.9472 369.313 43.6338 369.7 43.6338C370.087 43.6338 370.4 43.9472 370.4 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 44.3338C388.603 44.7203 388.29 45.0338 387.903 45.0338C387.517 45.0338 387.203 44.7203 387.203 44.3338C387.203 43.9472 387.517 43.6338 387.903 43.6338C388.29 43.6338 388.603 43.9472 388.603 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 44.3338C406.798 44.7203 406.485 45.0338 406.098 45.0338C405.712 45.0338 405.398 44.7203 405.398 44.3338C405.398 43.9472 405.712 43.6338 406.098 43.6338C406.485 43.6338 406.798 43.9472 406.798 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 44.3338C425.002 44.7203 424.688 45.0338 424.302 45.0338C423.915 45.0338 423.602 44.7203 423.602 44.3338C423.602 43.9472 423.915 43.6338 424.302 43.6338C424.688 43.6338 425.002 43.9472 425.002 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 44.3338C443.205 44.7203 442.891 45.0338 442.505 45.0338C442.118 45.0338 441.805 44.7203 441.805 44.3338C441.805 43.9472 442.118 43.6338 442.505 43.6338C442.891 43.6338 443.205 43.9472 443.205 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 44.3338C461.4 44.7203 461.087 45.0338 460.7 45.0338C460.313 45.0338 460 44.7203 460 44.3338C460 43.9472 460.313 43.6338 460.7 43.6338C461.087 43.6338 461.4 43.9472 461.4 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 44.3338C479.603 44.7203 479.29 45.0338 478.903 45.0338C478.517 45.0338 478.203 44.7203 478.203 44.3338C478.203 43.9472 478.517 43.6338 478.903 43.6338C479.29 43.6338 479.603 43.9472 479.603 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 44.3338C497.798 44.7203 497.485 45.0338 497.098 45.0338C496.712 45.0338 496.398 44.7203 496.398 44.3338C496.398 43.9472 496.712 43.6338 497.098 43.6338C497.485 43.6338 497.798 43.9472 497.798 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 44.3338C516.002 44.7203 515.688 45.0338 515.302 45.0338C514.915 45.0338 514.602 44.7203 514.602 44.3338C514.602 43.9472 514.915 43.6338 515.302 43.6338C515.688 43.6338 516.002 43.9472 516.002 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 44.3338C534.205 44.7203 533.891 45.0338 533.505 45.0338C533.118 45.0338 532.805 44.7203 532.805 44.3338C532.805 43.9472 533.118 43.6338 533.505 43.6338C533.891 43.6338 534.205 43.9472 534.205 44.3338Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 62.533C370.4 62.9195 370.087 63.233 369.7 63.233C369.313 63.233 369 62.9195 369 62.533C369 62.1465 369.313 61.833 369.7 61.833C370.087 61.833 370.4 62.1465 370.4 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 62.533C388.603 62.9195 388.29 63.233 387.903 63.233C387.517 63.233 387.203 62.9195 387.203 62.533C387.203 62.1465 387.517 61.833 387.903 61.833C388.29 61.833 388.603 62.1465 388.603 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 62.533C406.798 62.9195 406.485 63.233 406.098 63.233C405.712 63.233 405.398 62.9195 405.398 62.533C405.398 62.1465 405.712 61.833 406.098 61.833C406.485 61.833 406.798 62.1465 406.798 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 62.533C425.002 62.9195 424.688 63.233 424.302 63.233C423.915 63.233 423.602 62.9195 423.602 62.533C423.602 62.1465 423.915 61.833 424.302 61.833C424.688 61.833 425.002 62.1465 425.002 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 62.533C443.205 62.9195 442.891 63.233 442.505 63.233C442.118 63.233 441.805 62.9195 441.805 62.533C441.805 62.1465 442.118 61.833 442.505 61.833C442.891 61.833 443.205 62.1465 443.205 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 62.533C461.4 62.9195 461.087 63.233 460.7 63.233C460.313 63.233 460 62.9195 460 62.533C460 62.1465 460.313 61.833 460.7 61.833C461.087 61.833 461.4 62.1465 461.4 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 62.533C479.603 62.9195 479.29 63.233 478.903 63.233C478.517 63.233 478.203 62.9195 478.203 62.533C478.203 62.1465 478.517 61.833 478.903 61.833C479.29 61.833 479.603 62.1465 479.603 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 62.533C497.798 62.9195 497.485 63.233 497.098 63.233C496.712 63.233 496.398 62.9195 496.398 62.533C496.398 62.1465 496.712 61.833 497.098 61.833C497.485 61.833 497.798 62.1465 497.798 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 62.533C516.002 62.9195 515.688 63.233 515.302 63.233C514.915 63.233 514.602 62.9195 514.602 62.533C514.602 62.1465 514.915 61.833 515.302 61.833C515.688 61.833 516.002 62.1465 516.002 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 62.533C534.205 62.9195 533.891 63.233 533.505 63.233C533.118 63.233 532.805 62.9195 532.805 62.533C532.805 62.1465 533.118 61.833 533.505 61.833C533.891 61.833 534.205 62.1465 534.205 62.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 80.7332C370.4 81.1197 370.087 81.4332 369.7 81.4332C369.313 81.4332 369 81.1197 369 80.7332C369 80.3467 369.313 80.0332 369.7 80.0332C370.087 80.0332 370.4 80.3467 370.4 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 80.7332C388.603 81.1197 388.29 81.4332 387.903 81.4332C387.517 81.4332 387.203 81.1197 387.203 80.7332C387.203 80.3467 387.517 80.0332 387.903 80.0332C388.29 80.0332 388.603 80.3467 388.603 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 80.7332C406.798 81.1197 406.485 81.4332 406.098 81.4332C405.712 81.4332 405.398 81.1197 405.398 80.7332C405.398 80.3467 405.712 80.0332 406.098 80.0332C406.485 80.0332 406.798 80.3467 406.798 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 80.7334C425.002 81.12 424.688 81.4334 424.302 81.4334C423.915 81.4334 423.602 81.12 423.602 80.7334C423.602 80.3469 423.915 80.0334 424.302 80.0334C424.688 80.0334 425.002 80.3469 425.002 80.7334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 80.7332C443.205 81.1197 442.891 81.4332 442.505 81.4332C442.118 81.4332 441.805 81.1197 441.805 80.7332C441.805 80.3467 442.118 80.0332 442.505 80.0332C442.891 80.0332 443.205 80.3467 443.205 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 80.7332C461.4 81.1197 461.087 81.4332 460.7 81.4332C460.313 81.4332 460 81.1197 460 80.7332C460 80.3467 460.313 80.0332 460.7 80.0332C461.087 80.0332 461.4 80.3467 461.4 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 80.7332C479.603 81.1197 479.29 81.4332 478.903 81.4332C478.517 81.4332 478.203 81.1197 478.203 80.7332C478.203 80.3467 478.517 80.0332 478.903 80.0332C479.29 80.0332 479.603 80.3467 479.603 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 80.7332C497.798 81.1197 497.485 81.4332 497.098 81.4332C496.712 81.4332 496.398 81.1197 496.398 80.7332C496.398 80.3467 496.712 80.0332 497.098 80.0332C497.485 80.0332 497.798 80.3467 497.798 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 80.7334C516.002 81.12 515.688 81.4334 515.302 81.4334C514.915 81.4334 514.602 81.12 514.602 80.7334C514.602 80.3469 514.915 80.0334 515.302 80.0334C515.688 80.0334 516.002 80.3469 516.002 80.7334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 80.7332C534.205 81.1197 533.891 81.4332 533.505 81.4332C533.118 81.4332 532.805 81.1197 532.805 80.7332C532.805 80.3467 533.118 80.0332 533.505 80.0332C533.891 80.0332 534.205 80.3467 534.205 80.7332Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 98.9334C370.4 99.3199 370.087 99.6334 369.7 99.6334C369.313 99.6334 369 99.3199 369 98.9334C369 98.5469 369.313 98.2334 369.7 98.2334C370.087 98.2334 370.4 98.5469 370.4 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 98.9334C388.603 99.3199 388.29 99.6334 387.903 99.6334C387.517 99.6334 387.203 99.3199 387.203 98.9334C387.203 98.5469 387.517 98.2334 387.903 98.2334C388.29 98.2334 388.603 98.5469 388.603 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 98.9334C406.798 99.3199 406.485 99.6334 406.098 99.6334C405.712 99.6334 405.398 99.3199 405.398 98.9334C405.398 98.5469 405.712 98.2334 406.098 98.2334C406.485 98.2334 406.798 98.5469 406.798 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 98.9334C425.002 99.3199 424.688 99.6334 424.302 99.6334C423.915 99.6334 423.602 99.3199 423.602 98.9334C423.602 98.5469 423.915 98.2334 424.302 98.2334C424.688 98.2334 425.002 98.5469 425.002 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 98.9334C443.205 99.3199 442.891 99.6334 442.505 99.6334C442.118 99.6334 441.805 99.3199 441.805 98.9334C441.805 98.5469 442.118 98.2334 442.505 98.2334C442.891 98.2334 443.205 98.5469 443.205 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 98.9334C461.4 99.3199 461.087 99.6334 460.7 99.6334C460.313 99.6334 460 99.3199 460 98.9334C460 98.5469 460.313 98.2334 460.7 98.2334C461.087 98.2334 461.4 98.5469 461.4 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 98.9334C479.603 99.3199 479.29 99.6334 478.903 99.6334C478.517 99.6334 478.203 99.3199 478.203 98.9334C478.203 98.5469 478.517 98.2334 478.903 98.2334C479.29 98.2334 479.603 98.5469 479.603 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 98.9334C497.798 99.3199 497.485 99.6334 497.098 99.6334C496.712 99.6334 496.398 99.3199 496.398 98.9334C496.398 98.5469 496.712 98.2334 497.098 98.2334C497.485 98.2334 497.798 98.5469 497.798 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 98.9334C516.002 99.3199 515.688 99.6334 515.302 99.6334C514.915 99.6334 514.602 99.3199 514.602 98.9334C514.602 98.5469 514.915 98.2334 515.302 98.2334C515.688 98.2334 516.002 98.5469 516.002 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 98.9334C534.205 99.3199 533.891 99.6334 533.505 99.6334C533.118 99.6334 532.805 99.3199 532.805 98.9334C532.805 98.5469 533.118 98.2334 533.505 98.2334C533.891 98.2334 534.205 98.5469 534.205 98.9334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 117.134C370.4 117.52 370.087 117.834 369.7 117.834C369.313 117.834 369 117.52 369 117.134C369 116.747 369.313 116.434 369.7 116.434C370.087 116.434 370.4 116.747 370.4 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 117.134C388.603 117.52 388.29 117.834 387.903 117.834C387.517 117.834 387.203 117.52 387.203 117.134C387.203 116.747 387.517 116.434 387.903 116.434C388.29 116.434 388.603 116.747 388.603 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 117.134C406.798 117.52 406.485 117.834 406.098 117.834C405.712 117.834 405.398 117.52 405.398 117.134C405.398 116.747 405.712 116.434 406.098 116.434C406.485 116.434 406.798 116.747 406.798 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 117.133C425.002 117.52 424.688 117.833 424.302 117.833C423.915 117.833 423.602 117.52 423.602 117.133C423.602 116.747 423.915 116.433 424.302 116.433C424.688 116.433 425.002 116.747 425.002 117.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 117.134C443.205 117.52 442.891 117.834 442.505 117.834C442.118 117.834 441.805 117.52 441.805 117.134C441.805 116.747 442.118 116.434 442.505 116.434C442.891 116.434 443.205 116.747 443.205 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 117.134C461.4 117.52 461.087 117.834 460.7 117.834C460.313 117.834 460 117.52 460 117.134C460 116.747 460.313 116.434 460.7 116.434C461.087 116.434 461.4 116.747 461.4 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 117.134C479.603 117.52 479.29 117.834 478.903 117.834C478.517 117.834 478.203 117.52 478.203 117.134C478.203 116.747 478.517 116.434 478.903 116.434C479.29 116.434 479.603 116.747 479.603 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 117.134C497.798 117.52 497.485 117.834 497.098 117.834C496.712 117.834 496.398 117.52 496.398 117.134C496.398 116.747 496.712 116.434 497.098 116.434C497.485 116.434 497.798 116.747 497.798 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 117.133C516.002 117.52 515.688 117.833 515.302 117.833C514.915 117.833 514.602 117.52 514.602 117.133C514.602 116.747 514.915 116.433 515.302 116.433C515.688 116.433 516.002 116.747 516.002 117.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 117.134C534.205 117.52 533.891 117.834 533.505 117.834C533.118 117.834 532.805 117.52 532.805 117.134C532.805 116.747 533.118 116.434 533.505 116.434C533.891 116.434 534.205 116.747 534.205 117.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 135.334C370.4 135.72 370.087 136.034 369.7 136.034C369.313 136.034 369 135.72 369 135.334C369 134.947 369.313 134.634 369.7 134.634C370.087 134.634 370.4 134.947 370.4 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 135.334C388.603 135.72 388.29 136.034 387.903 136.034C387.517 136.034 387.203 135.72 387.203 135.334C387.203 134.947 387.517 134.634 387.903 134.634C388.29 134.634 388.603 134.947 388.603 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 135.334C406.798 135.72 406.485 136.034 406.098 136.034C405.712 136.034 405.398 135.72 405.398 135.334C405.398 134.947 405.712 134.634 406.098 134.634C406.485 134.634 406.798 134.947 406.798 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 135.334C425.002 135.72 424.688 136.034 424.302 136.034C423.915 136.034 423.602 135.72 423.602 135.334C423.602 134.947 423.915 134.634 424.302 134.634C424.688 134.634 425.002 134.947 425.002 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 135.334C443.205 135.72 442.891 136.034 442.505 136.034C442.118 136.034 441.805 135.72 441.805 135.334C441.805 134.947 442.118 134.634 442.505 134.634C442.891 134.634 443.205 134.947 443.205 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 135.334C461.4 135.72 461.087 136.034 460.7 136.034C460.313 136.034 460 135.72 460 135.334C460 134.947 460.313 134.634 460.7 134.634C461.087 134.634 461.4 134.947 461.4 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 135.334C479.603 135.72 479.29 136.034 478.903 136.034C478.517 136.034 478.203 135.72 478.203 135.334C478.203 134.947 478.517 134.634 478.903 134.634C479.29 134.634 479.603 134.947 479.603 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 135.334C497.798 135.72 497.485 136.034 497.098 136.034C496.712 136.034 496.398 135.72 496.398 135.334C496.398 134.947 496.712 134.634 497.098 134.634C497.485 134.634 497.798 134.947 497.798 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 135.334C516.002 135.72 515.688 136.034 515.302 136.034C514.915 136.034 514.602 135.72 514.602 135.334C514.602 134.947 514.915 134.634 515.302 134.634C515.688 134.634 516.002 134.947 516.002 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 135.334C534.205 135.72 533.891 136.034 533.505 136.034C533.118 136.034 532.805 135.72 532.805 135.334C532.805 134.947 533.118 134.634 533.505 134.634C533.891 134.634 534.205 134.947 534.205 135.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 153.533C370.4 153.919 370.087 154.233 369.7 154.233C369.313 154.233 369 153.919 369 153.533C369 153.147 369.313 152.833 369.7 152.833C370.087 152.833 370.4 153.147 370.4 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 153.533C388.603 153.919 388.29 154.233 387.903 154.233C387.517 154.233 387.203 153.919 387.203 153.533C387.203 153.147 387.517 152.833 387.903 152.833C388.29 152.833 388.603 153.147 388.603 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 153.533C406.798 153.919 406.485 154.233 406.098 154.233C405.712 154.233 405.398 153.919 405.398 153.533C405.398 153.147 405.712 152.833 406.098 152.833C406.485 152.833 406.798 153.147 406.798 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 153.533C425.002 153.919 424.688 154.233 424.302 154.233C423.915 154.233 423.602 153.919 423.602 153.533C423.602 153.147 423.915 152.833 424.302 152.833C424.688 152.833 425.002 153.147 425.002 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 153.533C443.205 153.919 442.891 154.233 442.505 154.233C442.118 154.233 441.805 153.919 441.805 153.533C441.805 153.147 442.118 152.833 442.505 152.833C442.891 152.833 443.205 153.147 443.205 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 153.533C461.4 153.919 461.087 154.233 460.7 154.233C460.313 154.233 460 153.919 460 153.533C460 153.147 460.313 152.833 460.7 152.833C461.087 152.833 461.4 153.147 461.4 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 153.533C479.603 153.919 479.29 154.233 478.903 154.233C478.517 154.233 478.203 153.919 478.203 153.533C478.203 153.147 478.517 152.833 478.903 152.833C479.29 152.833 479.603 153.147 479.603 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 153.533C497.798 153.919 497.485 154.233 497.098 154.233C496.712 154.233 496.398 153.919 496.398 153.533C496.398 153.147 496.712 152.833 497.098 152.833C497.485 152.833 497.798 153.147 497.798 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 153.533C516.002 153.919 515.688 154.233 515.302 154.233C514.915 154.233 514.602 153.919 514.602 153.533C514.602 153.147 514.915 152.833 515.302 152.833C515.688 152.833 516.002 153.147 516.002 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 153.533C534.205 153.919 533.891 154.233 533.505 154.233C533.118 154.233 532.805 153.919 532.805 153.533C532.805 153.147 533.118 152.833 533.505 152.833C533.891 152.833 534.205 153.147 534.205 153.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 171.733C370.4 172.12 370.087 172.433 369.7 172.433C369.313 172.433 369 172.12 369 171.733C369 171.347 369.313 171.033 369.7 171.033C370.087 171.033 370.4 171.347 370.4 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 171.733C388.603 172.12 388.29 172.433 387.903 172.433C387.517 172.433 387.203 172.12 387.203 171.733C387.203 171.347 387.517 171.033 387.903 171.033C388.29 171.033 388.603 171.347 388.603 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 171.733C406.798 172.12 406.485 172.433 406.098 172.433C405.712 172.433 405.398 172.12 405.398 171.733C405.398 171.347 405.712 171.033 406.098 171.033C406.485 171.033 406.798 171.347 406.798 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 171.733C425.002 172.12 424.688 172.433 424.302 172.433C423.915 172.433 423.602 172.12 423.602 171.733C423.602 171.347 423.915 171.033 424.302 171.033C424.688 171.033 425.002 171.347 425.002 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 171.733C443.205 172.12 442.891 172.433 442.505 172.433C442.118 172.433 441.805 172.12 441.805 171.733C441.805 171.347 442.118 171.033 442.505 171.033C442.891 171.033 443.205 171.347 443.205 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 171.733C461.4 172.12 461.087 172.433 460.7 172.433C460.313 172.433 460 172.12 460 171.733C460 171.347 460.313 171.033 460.7 171.033C461.087 171.033 461.4 171.347 461.4 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 171.733C479.603 172.12 479.29 172.433 478.903 172.433C478.517 172.433 478.203 172.12 478.203 171.733C478.203 171.347 478.517 171.033 478.903 171.033C479.29 171.033 479.603 171.347 479.603 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 171.733C497.798 172.12 497.485 172.433 497.098 172.433C496.712 172.433 496.398 172.12 496.398 171.733C496.398 171.347 496.712 171.033 497.098 171.033C497.485 171.033 497.798 171.347 497.798 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 171.733C516.002 172.12 515.688 172.433 515.302 172.433C514.915 172.433 514.602 172.12 514.602 171.733C514.602 171.347 514.915 171.033 515.302 171.033C515.688 171.033 516.002 171.347 516.002 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 171.733C534.205 172.12 533.891 172.433 533.505 172.433C533.118 172.433 532.805 172.12 532.805 171.733C532.805 171.347 533.118 171.033 533.505 171.033C533.891 171.033 534.205 171.347 534.205 171.733Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 189.933C370.4 190.32 370.087 190.633 369.7 190.633C369.313 190.633 369 190.32 369 189.933C369 189.547 369.313 189.233 369.7 189.233C370.087 189.233 370.4 189.547 370.4 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 189.933C388.603 190.32 388.29 190.633 387.903 190.633C387.517 190.633 387.203 190.32 387.203 189.933C387.203 189.547 387.517 189.233 387.903 189.233C388.29 189.233 388.603 189.547 388.603 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 189.933C406.798 190.32 406.485 190.633 406.098 190.633C405.712 190.633 405.398 190.32 405.398 189.933C405.398 189.547 405.712 189.233 406.098 189.233C406.485 189.233 406.798 189.547 406.798 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 189.933C425.002 190.32 424.688 190.633 424.302 190.633C423.915 190.633 423.602 190.32 423.602 189.933C423.602 189.547 423.915 189.233 424.302 189.233C424.688 189.233 425.002 189.547 425.002 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 189.933C443.205 190.32 442.891 190.633 442.505 190.633C442.118 190.633 441.805 190.32 441.805 189.933C441.805 189.547 442.118 189.233 442.505 189.233C442.891 189.233 443.205 189.547 443.205 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 189.933C461.4 190.32 461.087 190.633 460.7 190.633C460.313 190.633 460 190.32 460 189.933C460 189.547 460.313 189.233 460.7 189.233C461.087 189.233 461.4 189.547 461.4 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 189.933C479.603 190.32 479.29 190.633 478.903 190.633C478.517 190.633 478.203 190.32 478.203 189.933C478.203 189.547 478.517 189.233 478.903 189.233C479.29 189.233 479.603 189.547 479.603 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 189.933C497.798 190.32 497.485 190.633 497.098 190.633C496.712 190.633 496.398 190.32 496.398 189.933C496.398 189.547 496.712 189.233 497.098 189.233C497.485 189.233 497.798 189.547 497.798 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 189.933C516.002 190.32 515.688 190.633 515.302 190.633C514.915 190.633 514.602 190.32 514.602 189.933C514.602 189.547 514.915 189.233 515.302 189.233C515.688 189.233 516.002 189.547 516.002 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 189.933C534.205 190.32 533.891 190.633 533.505 190.633C533.118 190.633 532.805 190.32 532.805 189.933C532.805 189.547 533.118 189.233 533.505 189.233C533.891 189.233 534.205 189.547 534.205 189.933Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 208.134C370.4 208.52 370.087 208.834 369.7 208.834C369.313 208.834 369 208.52 369 208.134C369 207.747 369.313 207.434 369.7 207.434C370.087 207.434 370.4 207.747 370.4 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 208.134C388.603 208.52 388.29 208.834 387.903 208.834C387.517 208.834 387.203 208.52 387.203 208.134C387.203 207.747 387.517 207.434 387.903 207.434C388.29 207.434 388.603 207.747 388.603 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 208.134C406.798 208.52 406.485 208.834 406.098 208.834C405.712 208.834 405.398 208.52 405.398 208.134C405.398 207.747 405.712 207.434 406.098 207.434C406.485 207.434 406.798 207.747 406.798 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 208.133C425.002 208.52 424.688 208.833 424.302 208.833C423.915 208.833 423.602 208.52 423.602 208.133C423.602 207.747 423.915 207.433 424.302 207.433C424.688 207.433 425.002 207.747 425.002 208.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 208.134C443.205 208.52 442.891 208.834 442.505 208.834C442.118 208.834 441.805 208.52 441.805 208.134C441.805 207.747 442.118 207.434 442.505 207.434C442.891 207.434 443.205 207.747 443.205 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 208.134C461.4 208.52 461.087 208.834 460.7 208.834C460.313 208.834 460 208.52 460 208.134C460 207.747 460.313 207.434 460.7 207.434C461.087 207.434 461.4 207.747 461.4 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 208.134C479.603 208.52 479.29 208.834 478.903 208.834C478.517 208.834 478.203 208.52 478.203 208.134C478.203 207.747 478.517 207.434 478.903 207.434C479.29 207.434 479.603 207.747 479.603 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 208.134C497.798 208.52 497.485 208.834 497.098 208.834C496.712 208.834 496.398 208.52 496.398 208.134C496.398 207.747 496.712 207.434 497.098 207.434C497.485 207.434 497.798 207.747 497.798 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 208.133C516.002 208.52 515.688 208.833 515.302 208.833C514.915 208.833 514.602 208.52 514.602 208.133C514.602 207.747 514.915 207.433 515.302 207.433C515.688 207.433 516.002 207.747 516.002 208.133Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 208.134C534.205 208.52 533.891 208.834 533.505 208.834C533.118 208.834 532.805 208.52 532.805 208.134C532.805 207.747 533.118 207.434 533.505 207.434C533.891 207.434 534.205 207.747 534.205 208.134Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 226.334C370.4 226.72 370.087 227.034 369.7 227.034C369.313 227.034 369 226.72 369 226.334C369 225.947 369.313 225.634 369.7 225.634C370.087 225.634 370.4 225.947 370.4 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 226.334C388.603 226.72 388.29 227.034 387.903 227.034C387.517 227.034 387.203 226.72 387.203 226.334C387.203 225.947 387.517 225.634 387.903 225.634C388.29 225.634 388.603 225.947 388.603 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 226.334C406.798 226.72 406.485 227.034 406.098 227.034C405.712 227.034 405.398 226.72 405.398 226.334C405.398 225.947 405.712 225.634 406.098 225.634C406.485 225.634 406.798 225.947 406.798 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 226.334C425.002 226.72 424.688 227.034 424.302 227.034C423.915 227.034 423.602 226.72 423.602 226.334C423.602 225.947 423.915 225.634 424.302 225.634C424.688 225.634 425.002 225.947 425.002 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 226.334C443.205 226.72 442.891 227.034 442.505 227.034C442.118 227.034 441.805 226.72 441.805 226.334C441.805 225.947 442.118 225.634 442.505 225.634C442.891 225.634 443.205 225.947 443.205 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 226.334C461.4 226.72 461.087 227.034 460.7 227.034C460.313 227.034 460 226.72 460 226.334C460 225.947 460.313 225.634 460.7 225.634C461.087 225.634 461.4 225.947 461.4 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 226.334C479.603 226.72 479.29 227.034 478.903 227.034C478.517 227.034 478.203 226.72 478.203 226.334C478.203 225.947 478.517 225.634 478.903 225.634C479.29 225.634 479.603 225.947 479.603 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 226.334C497.798 226.72 497.485 227.034 497.098 227.034C496.712 227.034 496.398 226.72 496.398 226.334C496.398 225.947 496.712 225.634 497.098 225.634C497.485 225.634 497.798 225.947 497.798 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 226.334C516.002 226.72 515.688 227.034 515.302 227.034C514.915 227.034 514.602 226.72 514.602 226.334C514.602 225.947 514.915 225.634 515.302 225.634C515.688 225.634 516.002 225.947 516.002 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 226.334C534.205 226.72 533.891 227.034 533.505 227.034C533.118 227.034 532.805 226.72 532.805 226.334C532.805 225.947 533.118 225.634 533.505 225.634C533.891 225.634 534.205 225.947 534.205 226.334Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 244.533C370.4 244.919 370.087 245.233 369.7 245.233C369.313 245.233 369 244.919 369 244.533C369 244.147 369.313 243.833 369.7 243.833C370.087 243.833 370.4 244.147 370.4 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 244.533C388.603 244.919 388.29 245.233 387.903 245.233C387.517 245.233 387.203 244.919 387.203 244.533C387.203 244.147 387.517 243.833 387.903 243.833C388.29 243.833 388.603 244.147 388.603 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 244.533C406.798 244.919 406.485 245.233 406.098 245.233C405.712 245.233 405.398 244.919 405.398 244.533C405.398 244.147 405.712 243.833 406.098 243.833C406.485 243.833 406.798 244.147 406.798 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 244.533C425.002 244.919 424.688 245.233 424.302 245.233C423.915 245.233 423.602 244.919 423.602 244.533C423.602 244.147 423.915 243.833 424.302 243.833C424.688 243.833 425.002 244.147 425.002 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 244.533C443.205 244.919 442.891 245.233 442.505 245.233C442.118 245.233 441.805 244.919 441.805 244.533C441.805 244.147 442.118 243.833 442.505 243.833C442.891 243.833 443.205 244.147 443.205 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 244.533C461.4 244.919 461.087 245.233 460.7 245.233C460.313 245.233 460 244.919 460 244.533C460 244.147 460.313 243.833 460.7 243.833C461.087 243.833 461.4 244.147 461.4 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 244.533C479.603 244.919 479.29 245.233 478.903 245.233C478.517 245.233 478.203 244.919 478.203 244.533C478.203 244.147 478.517 243.833 478.903 243.833C479.29 243.833 479.603 244.147 479.603 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 244.533C497.798 244.919 497.485 245.233 497.098 245.233C496.712 245.233 496.398 244.919 496.398 244.533C496.398 244.147 496.712 243.833 497.098 243.833C497.485 243.833 497.798 244.147 497.798 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 244.533C516.002 244.919 515.688 245.233 515.302 245.233C514.915 245.233 514.602 244.919 514.602 244.533C514.602 244.147 514.915 243.833 515.302 243.833C515.688 243.833 516.002 244.147 516.002 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 244.533C534.205 244.919 533.891 245.233 533.505 245.233C533.118 245.233 532.805 244.919 532.805 244.533C532.805 244.147 533.118 243.833 533.505 243.833C533.891 243.833 534.205 244.147 534.205 244.533Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.016 91H343.599C342.457 91 341.531 91.9256 341.531 93.0675C341.531 94.2093 342.457 95.1349 343.599 95.1349H387.016C388.157 95.1349 389.083 94.2093 389.083 93.0675C389.083 91.9256 388.157 91 387.016 91Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.472 81H343.067C341.926 81 341 81.9256 341 83.0675C341 84.2093 341.926 85.1349 343.067 85.1349H435.472C436.614 85.1349 437.54 84.2093 437.54 83.0675C437.54 81.9256 436.614 81 435.472 81Z",
    fill: "#5539FF",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_6136_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.4 264.7C370.4 265.087 370.087 265.4 369.7 265.4C369.313 265.4 369 265.087 369 264.7C369 264.313 369.313 264 369.7 264C370.087 264 370.4 264.313 370.4 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 264.7C388.603 265.087 388.29 265.4 387.903 265.4C387.517 265.4 387.203 265.087 387.203 264.7C387.203 264.313 387.517 264 387.903 264C388.29 264 388.603 264.313 388.603 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 264.7C406.798 265.087 406.485 265.4 406.098 265.4C405.712 265.4 405.398 265.087 405.398 264.7C405.398 264.313 405.712 264 406.098 264C406.485 264 406.798 264.313 406.798 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 264.7C425.002 265.087 424.688 265.4 424.302 265.4C423.915 265.4 423.602 265.087 423.602 264.7C423.602 264.313 423.915 264 424.302 264C424.688 264 425.002 264.313 425.002 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 264.7C443.205 265.087 442.891 265.4 442.505 265.4C442.118 265.4 441.805 265.087 441.805 264.7C441.805 264.313 442.118 264 442.505 264C442.891 264 443.205 264.313 443.205 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 264.7C461.4 265.087 461.087 265.4 460.7 265.4C460.313 265.4 460 265.087 460 264.7C460 264.313 460.313 264 460.7 264C461.087 264 461.4 264.313 461.4 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 264.7C479.603 265.087 479.29 265.4 478.903 265.4C478.517 265.4 478.203 265.087 478.203 264.7C478.203 264.313 478.517 264 478.903 264C479.29 264 479.603 264.313 479.603 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 264.7C497.798 265.087 497.485 265.4 497.098 265.4C496.712 265.4 496.398 265.087 496.398 264.7C496.398 264.313 496.712 264 497.098 264C497.485 264 497.798 264.313 497.798 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 264.7C516.002 265.087 515.688 265.4 515.302 265.4C514.915 265.4 514.602 265.087 514.602 264.7C514.602 264.313 514.915 264 515.302 264C515.688 264 516.002 264.313 516.002 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 264.7C534.205 265.087 533.891 265.4 533.505 265.4C533.118 265.4 532.805 265.087 532.805 264.7C532.805 264.313 533.118 264 533.505 264C533.891 264 534.205 264.313 534.205 264.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 282.9C370.4 283.287 370.087 283.6 369.7 283.6C369.313 283.6 369 283.287 369 282.9C369 282.514 369.313 282.2 369.7 282.2C370.087 282.2 370.4 282.514 370.4 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 282.9C388.603 283.287 388.29 283.6 387.903 283.6C387.517 283.6 387.203 283.287 387.203 282.9C387.203 282.514 387.517 282.2 387.903 282.2C388.29 282.2 388.603 282.514 388.603 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 282.9C406.798 283.287 406.485 283.6 406.098 283.6C405.712 283.6 405.398 283.287 405.398 282.9C405.398 282.514 405.712 282.2 406.098 282.2C406.485 282.2 406.798 282.514 406.798 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 282.9C425.002 283.286 424.688 283.6 424.302 283.6C423.915 283.6 423.602 283.286 423.602 282.9C423.602 282.513 423.915 282.2 424.302 282.2C424.688 282.2 425.002 282.513 425.002 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 282.9C443.205 283.287 442.891 283.6 442.505 283.6C442.118 283.6 441.805 283.287 441.805 282.9C441.805 282.514 442.118 282.2 442.505 282.2C442.891 282.2 443.205 282.514 443.205 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 282.9C461.4 283.287 461.087 283.6 460.7 283.6C460.313 283.6 460 283.287 460 282.9C460 282.514 460.313 282.2 460.7 282.2C461.087 282.2 461.4 282.514 461.4 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 282.9C479.603 283.287 479.29 283.6 478.903 283.6C478.517 283.6 478.203 283.287 478.203 282.9C478.203 282.514 478.517 282.2 478.903 282.2C479.29 282.2 479.603 282.514 479.603 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 282.9C497.798 283.287 497.485 283.6 497.098 283.6C496.712 283.6 496.398 283.287 496.398 282.9C496.398 282.514 496.712 282.2 497.098 282.2C497.485 282.2 497.798 282.514 497.798 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 282.9C516.002 283.286 515.688 283.6 515.302 283.6C514.915 283.6 514.602 283.286 514.602 282.9C514.602 282.513 514.915 282.2 515.302 282.2C515.688 282.2 516.002 282.513 516.002 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 282.9C534.205 283.287 533.891 283.6 533.505 283.6C533.118 283.6 532.805 283.287 532.805 282.9C532.805 282.514 533.118 282.2 533.505 282.2C533.891 282.2 534.205 282.514 534.205 282.9Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 301.1C370.4 301.487 370.087 301.8 369.7 301.8C369.313 301.8 369 301.487 369 301.1C369 300.714 369.313 300.4 369.7 300.4C370.087 300.4 370.4 300.714 370.4 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 301.1C388.603 301.487 388.29 301.8 387.903 301.8C387.517 301.8 387.203 301.487 387.203 301.1C387.203 300.714 387.517 300.4 387.903 300.4C388.29 300.4 388.603 300.714 388.603 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 301.1C406.798 301.487 406.485 301.8 406.098 301.8C405.712 301.8 405.398 301.487 405.398 301.1C405.398 300.714 405.712 300.4 406.098 300.4C406.485 300.4 406.798 300.714 406.798 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 301.1C425.002 301.487 424.688 301.8 424.302 301.8C423.915 301.8 423.602 301.487 423.602 301.1C423.602 300.714 423.915 300.4 424.302 300.4C424.688 300.4 425.002 300.714 425.002 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 301.1C443.205 301.487 442.891 301.8 442.505 301.8C442.118 301.8 441.805 301.487 441.805 301.1C441.805 300.714 442.118 300.4 442.505 300.4C442.891 300.4 443.205 300.714 443.205 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 301.1C461.4 301.487 461.087 301.8 460.7 301.8C460.313 301.8 460 301.487 460 301.1C460 300.714 460.313 300.4 460.7 300.4C461.087 300.4 461.4 300.714 461.4 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 301.1C479.603 301.487 479.29 301.8 478.903 301.8C478.517 301.8 478.203 301.487 478.203 301.1C478.203 300.714 478.517 300.4 478.903 300.4C479.29 300.4 479.603 300.714 479.603 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 301.1C497.798 301.487 497.485 301.8 497.098 301.8C496.712 301.8 496.398 301.487 496.398 301.1C496.398 300.714 496.712 300.4 497.098 300.4C497.485 300.4 497.798 300.714 497.798 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 301.1C516.002 301.487 515.688 301.8 515.302 301.8C514.915 301.8 514.602 301.487 514.602 301.1C514.602 300.714 514.915 300.4 515.302 300.4C515.688 300.4 516.002 300.714 516.002 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 301.1C534.205 301.487 533.891 301.8 533.505 301.8C533.118 301.8 532.805 301.487 532.805 301.1C532.805 300.714 533.118 300.4 533.505 300.4C533.891 300.4 534.205 300.714 534.205 301.1Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 319.3C370.4 319.686 370.087 320 369.7 320C369.313 320 369 319.686 369 319.3C369 318.913 369.313 318.6 369.7 318.6C370.087 318.6 370.4 318.913 370.4 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 319.3C388.603 319.686 388.29 320 387.903 320C387.517 320 387.203 319.686 387.203 319.3C387.203 318.913 387.517 318.6 387.903 318.6C388.29 318.6 388.603 318.913 388.603 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 319.3C406.798 319.686 406.485 320 406.098 320C405.712 320 405.398 319.686 405.398 319.3C405.398 318.913 405.712 318.6 406.098 318.6C406.485 318.6 406.798 318.913 406.798 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 319.3C425.002 319.686 424.688 320 424.302 320C423.915 320 423.602 319.686 423.602 319.3C423.602 318.913 423.915 318.6 424.302 318.6C424.688 318.6 425.002 318.913 425.002 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 319.3C443.205 319.686 442.891 320 442.505 320C442.118 320 441.805 319.686 441.805 319.3C441.805 318.913 442.118 318.6 442.505 318.6C442.891 318.6 443.205 318.913 443.205 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 319.3C461.4 319.686 461.087 320 460.7 320C460.313 320 460 319.686 460 319.3C460 318.913 460.313 318.6 460.7 318.6C461.087 318.6 461.4 318.913 461.4 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 319.3C479.603 319.686 479.29 320 478.903 320C478.517 320 478.203 319.686 478.203 319.3C478.203 318.913 478.517 318.6 478.903 318.6C479.29 318.6 479.603 318.913 479.603 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 319.3C497.798 319.686 497.485 320 497.098 320C496.712 320 496.398 319.686 496.398 319.3C496.398 318.913 496.712 318.6 497.098 318.6C497.485 318.6 497.798 318.913 497.798 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 319.3C516.002 319.686 515.688 320 515.302 320C514.915 320 514.602 319.686 514.602 319.3C514.602 318.913 514.915 318.6 515.302 318.6C515.688 318.6 516.002 318.913 516.002 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 319.3C534.205 319.686 533.891 320 533.505 320C533.118 320 532.805 319.686 532.805 319.3C532.805 318.913 533.118 318.6 533.505 318.6C533.891 318.6 534.205 318.913 534.205 319.3Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 337.5C370.4 337.886 370.087 338.2 369.7 338.2C369.313 338.2 369 337.886 369 337.5C369 337.113 369.313 336.8 369.7 336.8C370.087 336.8 370.4 337.113 370.4 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 337.5C388.603 337.886 388.29 338.2 387.903 338.2C387.517 338.2 387.203 337.886 387.203 337.5C387.203 337.113 387.517 336.8 387.903 336.8C388.29 336.8 388.603 337.113 388.603 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 337.5C406.798 337.886 406.485 338.2 406.098 338.2C405.712 338.2 405.398 337.886 405.398 337.5C405.398 337.113 405.712 336.8 406.098 336.8C406.485 336.8 406.798 337.113 406.798 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 337.5C425.002 337.887 424.688 338.2 424.302 338.2C423.915 338.2 423.602 337.887 423.602 337.5C423.602 337.114 423.915 336.8 424.302 336.8C424.688 336.8 425.002 337.114 425.002 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 337.5C443.205 337.886 442.891 338.2 442.505 338.2C442.118 338.2 441.805 337.886 441.805 337.5C441.805 337.113 442.118 336.8 442.505 336.8C442.891 336.8 443.205 337.113 443.205 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 337.5C461.4 337.886 461.087 338.2 460.7 338.2C460.313 338.2 460 337.886 460 337.5C460 337.113 460.313 336.8 460.7 336.8C461.087 336.8 461.4 337.113 461.4 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 337.5C479.603 337.886 479.29 338.2 478.903 338.2C478.517 338.2 478.203 337.886 478.203 337.5C478.203 337.113 478.517 336.8 478.903 336.8C479.29 336.8 479.603 337.113 479.603 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 337.5C497.798 337.886 497.485 338.2 497.098 338.2C496.712 338.2 496.398 337.886 496.398 337.5C496.398 337.113 496.712 336.8 497.098 336.8C497.485 336.8 497.798 337.113 497.798 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 337.5C516.002 337.887 515.688 338.2 515.302 338.2C514.915 338.2 514.602 337.887 514.602 337.5C514.602 337.114 514.915 336.8 515.302 336.8C515.688 336.8 516.002 337.114 516.002 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 337.5C534.205 337.886 533.891 338.2 533.505 338.2C533.118 338.2 532.805 337.886 532.805 337.5C532.805 337.113 533.118 336.8 533.505 336.8C533.891 336.8 534.205 337.113 534.205 337.5Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4 355.7C370.4 356.087 370.087 356.4 369.7 356.4C369.313 356.4 369 356.087 369 355.7C369 355.313 369.313 355 369.7 355C370.087 355 370.4 355.313 370.4 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 355.7C388.603 356.087 388.29 356.4 387.903 356.4C387.517 356.4 387.203 356.087 387.203 355.7C387.203 355.313 387.517 355 387.903 355C388.29 355 388.603 355.313 388.603 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.798 355.7C406.798 356.087 406.485 356.4 406.098 356.4C405.712 356.4 405.398 356.087 405.398 355.7C405.398 355.313 405.712 355 406.098 355C406.485 355 406.798 355.313 406.798 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.002 355.7C425.002 356.087 424.688 356.4 424.302 356.4C423.915 356.4 423.602 356.087 423.602 355.7C423.602 355.313 423.915 355 424.302 355C424.688 355 425.002 355.313 425.002 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.205 355.7C443.205 356.087 442.891 356.4 442.505 356.4C442.118 356.4 441.805 356.087 441.805 355.7C441.805 355.313 442.118 355 442.505 355C442.891 355 443.205 355.313 443.205 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 355.7C461.4 356.087 461.087 356.4 460.7 356.4C460.313 356.4 460 356.087 460 355.7C460 355.313 460.313 355 460.7 355C461.087 355 461.4 355.313 461.4 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.603 355.7C479.603 356.087 479.29 356.4 478.903 356.4C478.517 356.4 478.203 356.087 478.203 355.7C478.203 355.313 478.517 355 478.903 355C479.29 355 479.603 355.313 479.603 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.798 355.7C497.798 356.087 497.485 356.4 497.098 356.4C496.712 356.4 496.398 356.087 496.398 355.7C496.398 355.313 496.712 355 497.098 355C497.485 355 497.798 355.313 497.798 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.002 355.7C516.002 356.087 515.688 356.4 515.302 356.4C514.915 356.4 514.602 356.087 514.602 355.7C514.602 355.313 514.915 355 515.302 355C515.688 355 516.002 355.313 516.002 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.205 355.7C534.205 356.087 533.891 356.4 533.505 356.4C533.118 356.4 532.805 356.087 532.805 355.7C532.805 355.313 533.118 355 533.505 355C533.891 355 534.205 355.313 534.205 355.7Z",
    fill: "#22328A",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-605-inside-1_6136_4726",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9354 52.4329C41.6681 51.4926 43.6109 51.0069 45.5822 51.0212H234.043C236.453 51.0171 238.806 51.762 240.775 53.153C242.743 54.5439 244.231 56.5122 245.033 58.7856C246.601 63.3075 249.501 67.2491 253.351 70.0925C257.201 72.9359 261.821 74.5479 266.604 74.7168C266.879 74.7168 267.169 74.7168 267.458 74.7168C272.392 74.7177 277.203 73.1821 281.225 70.3233C285.246 67.4646 288.277 63.4246 289.897 58.7644C290.697 56.4927 292.183 54.5254 294.149 53.1345C296.115 51.7437 298.465 50.9978 300.873 51H490.382C491.908 50.9991 493.419 51.2989 494.829 51.8825C496.239 52.466 497.52 53.3218 498.599 54.4009C499.678 55.48 500.534 56.7611 501.118 58.1711C501.701 59.5811 502.001 61.0924 502 62.6184V295.382C502.001 296.908 501.701 298.419 501.118 299.829C500.534 301.239 499.678 302.52 498.599 303.599C497.52 304.678 496.239 305.534 494.829 306.117C493.419 306.701 491.908 307.001 490.382 307H300.873C298.464 307.004 296.114 306.259 294.147 304.868C292.181 303.477 290.695 301.508 289.897 299.236C288.277 294.575 285.246 290.535 281.225 287.677C277.203 284.818 272.392 283.282 267.458 283.283C267.169 283.283 266.879 283.283 266.604 283.283C261.821 283.452 257.201 285.064 253.351 287.907C249.501 290.751 246.601 294.693 245.033 299.214C244.232 301.488 242.744 303.457 240.775 304.848C238.806 306.239 236.454 306.984 234.043 306.979H45.5681C44.0421 306.98 42.5309 306.68 41.1208 306.096C39.7108 305.513 38.4297 304.657 37.3506 303.578C36.2716 302.499 35.4158 301.218 34.8322 299.808C34.2487 298.398 33.9488 296.886 33.9497 295.36V62.6042C33.9517 60.5295 34.5075 58.4929 35.5598 56.7048C36.612 54.9167 38.1226 53.442 39.9354 52.4329ZM265.489 268.199C265.485 268.57 265.588 268.935 265.786 269.249C265.984 269.563 266.268 269.814 266.604 269.971C266.865 270.117 267.159 270.19 267.458 270.183C267.719 270.184 267.977 270.133 268.218 270.033C268.459 269.934 268.678 269.788 268.863 269.604C269.047 269.419 269.193 269.2 269.292 268.959C269.392 268.718 269.442 268.46 269.441 268.199V245.216C269.441 244.69 269.233 244.186 268.861 243.814C268.489 243.442 267.984 243.233 267.458 243.233C267.162 243.23 266.869 243.297 266.604 243.431C266.402 243.526 266.218 243.654 266.06 243.812C265.691 244.188 265.485 244.696 265.489 245.223V268.199ZM265.489 228.833C265.485 229.205 265.588 229.569 265.786 229.883C265.984 230.197 266.268 230.448 266.604 230.605C266.866 230.748 267.16 230.821 267.458 230.817C267.719 230.82 267.978 230.77 268.22 230.672C268.462 230.573 268.682 230.427 268.867 230.242C269.052 230.058 269.198 229.838 269.296 229.596C269.395 229.354 269.444 229.095 269.441 228.833V283.474C269.442 283.213 269.392 282.955 269.292 282.714C269.193 282.473 269.047 282.254 268.863 282.069C268.678 281.885 268.459 281.739 268.218 281.639C267.977 281.54 267.719 281.489 267.458 281.49C267.162 281.487 266.869 281.555 266.604 281.688C266.402 281.78 266.219 281.907 266.06 282.062C265.692 282.44 265.487 282.947 265.489 283.474V228.833ZM265.489 267.112C265.486 267.483 265.589 267.847 265.787 268.161C265.985 268.475 266.268 268.726 266.604 268.884C266.866 269.026 267.16 269.099 267.458 269.096C267.721 269.096 267.981 269.044 268.224 268.942C268.466 268.84 268.686 268.691 268.87 268.503C269.055 268.318 269.201 268.097 269.299 267.855C269.398 267.612 269.446 267.353 269.441 267.091V244.108C269.442 243.847 269.392 243.589 269.292 243.348C269.193 243.107 269.047 242.888 268.863 242.704C268.678 242.519 268.459 242.373 268.218 242.274C267.977 242.174 267.719 242.124 267.458 242.125C267.162 242.122 266.869 242.189 266.604 242.322C266.401 242.412 266.217 242.539 266.06 242.696C265.692 243.074 265.487 243.581 265.489 244.108V267.112ZM265.489 227.739C265.484 228.112 265.587 228.477 265.785 228.793C265.983 229.108 266.267 229.36 266.604 229.518C266.866 229.658 267.16 229.729 267.458 229.723C267.719 229.724 267.977 229.673 268.218 229.574C268.459 229.474 268.678 229.328 268.863 229.144C269.047 228.96 269.193 228.741 269.292 228.5C269.392 228.258 269.442 228 269.441 227.739V204.75C269.441 204.489 269.39 204.232 269.29 203.992C269.191 203.751 269.044 203.533 268.86 203.35C268.676 203.166 268.457 203.021 268.216 202.922C267.976 202.823 267.718 202.772 267.458 202.773C267.161 202.772 266.868 202.842 266.604 202.978C266.401 203.068 266.217 203.195 266.06 203.352C265.876 203.538 265.731 203.758 265.633 204.001C265.535 204.243 265.486 204.502 265.489 204.764V227.739ZM265.489 188.374C265.484 188.745 265.587 189.11 265.785 189.424C265.983 189.739 266.267 189.989 266.604 190.145C266.865 190.291 267.159 190.364 267.458 190.357C267.985 190.359 268.492 190.154 268.87 189.786C269.235 189.406 269.44 188.901 269.441 188.374V165.391C269.441 164.865 269.233 164.361 268.861 163.989C268.489 163.617 267.984 163.408 267.458 163.408C266.93 163.408 266.423 163.616 266.046 163.986C265.678 164.364 265.473 164.871 265.475 165.398L265.489 188.374ZM265.489 149.008C265.485 149.379 265.588 149.744 265.786 150.058C265.984 150.372 266.268 150.623 266.604 150.78C266.865 150.926 267.159 150.999 267.458 150.992C267.719 150.993 267.977 150.942 268.218 150.843C268.459 150.743 268.678 150.597 268.863 150.413C269.047 150.228 269.193 150.009 269.292 149.768C269.392 149.527 269.442 149.269 269.441 149.008V126.025C269.441 125.499 269.233 124.995 268.861 124.623C268.489 124.251 267.984 124.042 267.458 124.042C267.162 124.039 266.869 124.107 266.604 124.24C266.402 124.335 266.218 124.463 266.06 124.621C265.691 124.997 265.485 125.505 265.489 126.033V149.008ZM265.489 109.643C265.485 110.014 265.588 110.378 265.786 110.692C265.984 111.007 266.268 111.257 266.604 111.414C266.866 111.557 267.16 111.63 267.458 111.626C267.719 111.629 267.978 111.579 268.22 111.481C268.462 111.382 268.682 111.236 268.867 111.051C269.052 110.867 269.198 110.647 269.296 110.405C269.395 110.163 269.444 109.904 269.441 109.643V86.6599C269.442 86.3992 269.392 86.1408 269.292 85.8997C269.193 85.6587 269.047 85.4396 268.863 85.2552C268.678 85.0709 268.459 84.9248 268.218 84.8255C267.977 84.7261 267.719 84.6755 267.458 84.6764C267.162 84.6731 266.869 84.7409 266.604 84.8741C266.402 84.9663 266.219 85.0929 266.06 85.2482C265.691 85.6248 265.485 86.1323 265.489 86.6599V109.643Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9354 52.4329C41.6681 51.4926 43.6109 51.0069 45.5822 51.0212H234.043C236.453 51.0171 238.806 51.762 240.775 53.153C242.743 54.5439 244.231 56.5122 245.033 58.7856C246.601 63.3075 249.501 67.2491 253.351 70.0925C257.201 72.9359 261.821 74.5479 266.604 74.7168C266.879 74.7168 267.169 74.7168 267.458 74.7168C272.392 74.7177 277.203 73.1821 281.225 70.3233C285.246 67.4646 288.277 63.4246 289.897 58.7644C290.697 56.4927 292.183 54.5254 294.149 53.1345C296.115 51.7437 298.465 50.9978 300.873 51H490.382C491.908 50.9991 493.419 51.2989 494.829 51.8825C496.239 52.466 497.52 53.3218 498.599 54.4009C499.678 55.48 500.534 56.7611 501.118 58.1711C501.701 59.5811 502.001 61.0924 502 62.6184V295.382C502.001 296.908 501.701 298.419 501.118 299.829C500.534 301.239 499.678 302.52 498.599 303.599C497.52 304.678 496.239 305.534 494.829 306.117C493.419 306.701 491.908 307.001 490.382 307H300.873C298.464 307.004 296.114 306.259 294.147 304.868C292.181 303.477 290.695 301.508 289.897 299.236C288.277 294.575 285.246 290.535 281.225 287.677C277.203 284.818 272.392 283.282 267.458 283.283C267.169 283.283 266.879 283.283 266.604 283.283C261.821 283.452 257.201 285.064 253.351 287.907C249.501 290.751 246.601 294.693 245.033 299.214C244.232 301.488 242.744 303.457 240.775 304.848C238.806 306.239 236.454 306.984 234.043 306.979H45.5681C44.0421 306.98 42.5309 306.68 41.1208 306.096C39.7108 305.513 38.4297 304.657 37.3506 303.578C36.2716 302.499 35.4158 301.218 34.8322 299.808C34.2487 298.398 33.9488 296.886 33.9497 295.36V62.6042C33.9517 60.5295 34.5075 58.4929 35.5598 56.7048C36.612 54.9167 38.1226 53.442 39.9354 52.4329ZM265.489 268.199C265.485 268.57 265.588 268.935 265.786 269.249C265.984 269.563 266.268 269.814 266.604 269.971C266.865 270.117 267.159 270.19 267.458 270.183C267.719 270.184 267.977 270.133 268.218 270.033C268.459 269.934 268.678 269.788 268.863 269.604C269.047 269.419 269.193 269.2 269.292 268.959C269.392 268.718 269.442 268.46 269.441 268.199V245.216C269.441 244.69 269.233 244.186 268.861 243.814C268.489 243.442 267.984 243.233 267.458 243.233C267.162 243.23 266.869 243.297 266.604 243.431C266.402 243.526 266.218 243.654 266.06 243.812C265.691 244.188 265.485 244.696 265.489 245.223V268.199ZM265.489 228.833C265.485 229.205 265.588 229.569 265.786 229.883C265.984 230.197 266.268 230.448 266.604 230.605C266.866 230.748 267.16 230.821 267.458 230.817C267.719 230.82 267.978 230.77 268.22 230.672C268.462 230.573 268.682 230.427 268.867 230.242C269.052 230.058 269.198 229.838 269.296 229.596C269.395 229.354 269.444 229.095 269.441 228.833V283.474C269.442 283.213 269.392 282.955 269.292 282.714C269.193 282.473 269.047 282.254 268.863 282.069C268.678 281.885 268.459 281.739 268.218 281.639C267.977 281.54 267.719 281.489 267.458 281.49C267.162 281.487 266.869 281.555 266.604 281.688C266.402 281.78 266.219 281.907 266.06 282.062C265.692 282.44 265.487 282.947 265.489 283.474V228.833ZM265.489 267.112C265.486 267.483 265.589 267.847 265.787 268.161C265.985 268.475 266.268 268.726 266.604 268.884C266.866 269.026 267.16 269.099 267.458 269.096C267.721 269.096 267.981 269.044 268.224 268.942C268.466 268.84 268.686 268.691 268.87 268.503C269.055 268.318 269.201 268.097 269.299 267.855C269.398 267.612 269.446 267.353 269.441 267.091V244.108C269.442 243.847 269.392 243.589 269.292 243.348C269.193 243.107 269.047 242.888 268.863 242.704C268.678 242.519 268.459 242.373 268.218 242.274C267.977 242.174 267.719 242.124 267.458 242.125C267.162 242.122 266.869 242.189 266.604 242.322C266.401 242.412 266.217 242.539 266.06 242.696C265.692 243.074 265.487 243.581 265.489 244.108V267.112ZM265.489 227.739C265.484 228.112 265.587 228.477 265.785 228.793C265.983 229.108 266.267 229.36 266.604 229.518C266.866 229.658 267.16 229.729 267.458 229.723C267.719 229.724 267.977 229.673 268.218 229.574C268.459 229.474 268.678 229.328 268.863 229.144C269.047 228.96 269.193 228.741 269.292 228.5C269.392 228.258 269.442 228 269.441 227.739V204.75C269.441 204.489 269.39 204.232 269.29 203.992C269.191 203.751 269.044 203.533 268.86 203.35C268.676 203.166 268.457 203.021 268.216 202.922C267.976 202.823 267.718 202.772 267.458 202.773C267.161 202.772 266.868 202.842 266.604 202.978C266.401 203.068 266.217 203.195 266.06 203.352C265.876 203.538 265.731 203.758 265.633 204.001C265.535 204.243 265.486 204.502 265.489 204.764V227.739ZM265.489 188.374C265.484 188.745 265.587 189.11 265.785 189.424C265.983 189.739 266.267 189.989 266.604 190.145C266.865 190.291 267.159 190.364 267.458 190.357C267.985 190.359 268.492 190.154 268.87 189.786C269.235 189.406 269.44 188.901 269.441 188.374V165.391C269.441 164.865 269.233 164.361 268.861 163.989C268.489 163.617 267.984 163.408 267.458 163.408C266.93 163.408 266.423 163.616 266.046 163.986C265.678 164.364 265.473 164.871 265.475 165.398L265.489 188.374ZM265.489 149.008C265.485 149.379 265.588 149.744 265.786 150.058C265.984 150.372 266.268 150.623 266.604 150.78C266.865 150.926 267.159 150.999 267.458 150.992C267.719 150.993 267.977 150.942 268.218 150.843C268.459 150.743 268.678 150.597 268.863 150.413C269.047 150.228 269.193 150.009 269.292 149.768C269.392 149.527 269.442 149.269 269.441 149.008V126.025C269.441 125.499 269.233 124.995 268.861 124.623C268.489 124.251 267.984 124.042 267.458 124.042C267.162 124.039 266.869 124.107 266.604 124.24C266.402 124.335 266.218 124.463 266.06 124.621C265.691 124.997 265.485 125.505 265.489 126.033V149.008ZM265.489 109.643C265.485 110.014 265.588 110.378 265.786 110.692C265.984 111.007 266.268 111.257 266.604 111.414C266.866 111.557 267.16 111.63 267.458 111.626C267.719 111.629 267.978 111.579 268.22 111.481C268.462 111.382 268.682 111.236 268.867 111.051C269.052 110.867 269.198 110.647 269.296 110.405C269.395 110.163 269.444 109.904 269.441 109.643V86.6599C269.442 86.3992 269.392 86.1408 269.292 85.8997C269.193 85.6587 269.047 85.4396 268.863 85.2552C268.678 85.0709 268.459 84.9248 268.218 84.8255C267.977 84.7261 267.719 84.6755 267.458 84.6764C267.162 84.6731 266.869 84.7409 266.604 84.8741C266.402 84.9663 266.219 85.0929 266.06 85.2482C265.691 85.6248 265.485 86.1323 265.489 86.6599V109.643Z",
    fill: "url(#paint2_linear_6136_4726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9354 52.4329C41.6681 51.4926 43.6109 51.0069 45.5822 51.0212H234.043C236.453 51.0171 238.806 51.762 240.775 53.153C242.743 54.5439 244.231 56.5122 245.033 58.7856C246.601 63.3075 249.501 67.2491 253.351 70.0925C257.201 72.9359 261.821 74.5479 266.604 74.7168C266.879 74.7168 267.169 74.7168 267.458 74.7168C272.392 74.7177 277.203 73.1821 281.225 70.3233C285.246 67.4646 288.277 63.4246 289.897 58.7644C290.697 56.4927 292.183 54.5254 294.149 53.1345C296.115 51.7437 298.465 50.9978 300.873 51H490.382C491.908 50.9991 493.419 51.2989 494.829 51.8825C496.239 52.466 497.52 53.3218 498.599 54.4009C499.678 55.48 500.534 56.7611 501.118 58.1711C501.701 59.5811 502.001 61.0924 502 62.6184V295.382C502.001 296.908 501.701 298.419 501.118 299.829C500.534 301.239 499.678 302.52 498.599 303.599C497.52 304.678 496.239 305.534 494.829 306.117C493.419 306.701 491.908 307.001 490.382 307H300.873C298.464 307.004 296.114 306.259 294.147 304.868C292.181 303.477 290.695 301.508 289.897 299.236C288.277 294.575 285.246 290.535 281.225 287.677C277.203 284.818 272.392 283.282 267.458 283.283C267.169 283.283 266.879 283.283 266.604 283.283C261.821 283.452 257.201 285.064 253.351 287.907C249.501 290.751 246.601 294.693 245.033 299.214C244.232 301.488 242.744 303.457 240.775 304.848C238.806 306.239 236.454 306.984 234.043 306.979H45.5681C44.0421 306.98 42.5309 306.68 41.1208 306.096C39.7108 305.513 38.4297 304.657 37.3506 303.578C36.2716 302.499 35.4158 301.218 34.8322 299.808C34.2487 298.398 33.9488 296.886 33.9497 295.36V62.6042C33.9517 60.5295 34.5075 58.4929 35.5598 56.7048C36.612 54.9167 38.1226 53.442 39.9354 52.4329ZM265.489 268.199C265.485 268.57 265.588 268.935 265.786 269.249C265.984 269.563 266.268 269.814 266.604 269.971C266.865 270.117 267.159 270.19 267.458 270.183C267.719 270.184 267.977 270.133 268.218 270.033C268.459 269.934 268.678 269.788 268.863 269.604C269.047 269.419 269.193 269.2 269.292 268.959C269.392 268.718 269.442 268.46 269.441 268.199V245.216C269.441 244.69 269.233 244.186 268.861 243.814C268.489 243.442 267.984 243.233 267.458 243.233C267.162 243.23 266.869 243.297 266.604 243.431C266.402 243.526 266.218 243.654 266.06 243.812C265.691 244.188 265.485 244.696 265.489 245.223V268.199ZM265.489 228.833C265.485 229.205 265.588 229.569 265.786 229.883C265.984 230.197 266.268 230.448 266.604 230.605C266.866 230.748 267.16 230.821 267.458 230.817C267.719 230.82 267.978 230.77 268.22 230.672C268.462 230.573 268.682 230.427 268.867 230.242C269.052 230.058 269.198 229.838 269.296 229.596C269.395 229.354 269.444 229.095 269.441 228.833V283.474C269.442 283.213 269.392 282.955 269.292 282.714C269.193 282.473 269.047 282.254 268.863 282.069C268.678 281.885 268.459 281.739 268.218 281.639C267.977 281.54 267.719 281.489 267.458 281.49C267.162 281.487 266.869 281.555 266.604 281.688C266.402 281.78 266.219 281.907 266.06 282.062C265.692 282.44 265.487 282.947 265.489 283.474V228.833ZM265.489 267.112C265.486 267.483 265.589 267.847 265.787 268.161C265.985 268.475 266.268 268.726 266.604 268.884C266.866 269.026 267.16 269.099 267.458 269.096C267.721 269.096 267.981 269.044 268.224 268.942C268.466 268.84 268.686 268.691 268.87 268.503C269.055 268.318 269.201 268.097 269.299 267.855C269.398 267.612 269.446 267.353 269.441 267.091V244.108C269.442 243.847 269.392 243.589 269.292 243.348C269.193 243.107 269.047 242.888 268.863 242.704C268.678 242.519 268.459 242.373 268.218 242.274C267.977 242.174 267.719 242.124 267.458 242.125C267.162 242.122 266.869 242.189 266.604 242.322C266.401 242.412 266.217 242.539 266.06 242.696C265.692 243.074 265.487 243.581 265.489 244.108V267.112ZM265.489 227.739C265.484 228.112 265.587 228.477 265.785 228.793C265.983 229.108 266.267 229.36 266.604 229.518C266.866 229.658 267.16 229.729 267.458 229.723C267.719 229.724 267.977 229.673 268.218 229.574C268.459 229.474 268.678 229.328 268.863 229.144C269.047 228.96 269.193 228.741 269.292 228.5C269.392 228.258 269.442 228 269.441 227.739V204.75C269.441 204.489 269.39 204.232 269.29 203.992C269.191 203.751 269.044 203.533 268.86 203.35C268.676 203.166 268.457 203.021 268.216 202.922C267.976 202.823 267.718 202.772 267.458 202.773C267.161 202.772 266.868 202.842 266.604 202.978C266.401 203.068 266.217 203.195 266.06 203.352C265.876 203.538 265.731 203.758 265.633 204.001C265.535 204.243 265.486 204.502 265.489 204.764V227.739ZM265.489 188.374C265.484 188.745 265.587 189.11 265.785 189.424C265.983 189.739 266.267 189.989 266.604 190.145C266.865 190.291 267.159 190.364 267.458 190.357C267.985 190.359 268.492 190.154 268.87 189.786C269.235 189.406 269.44 188.901 269.441 188.374V165.391C269.441 164.865 269.233 164.361 268.861 163.989C268.489 163.617 267.984 163.408 267.458 163.408C266.93 163.408 266.423 163.616 266.046 163.986C265.678 164.364 265.473 164.871 265.475 165.398L265.489 188.374ZM265.489 149.008C265.485 149.379 265.588 149.744 265.786 150.058C265.984 150.372 266.268 150.623 266.604 150.78C266.865 150.926 267.159 150.999 267.458 150.992C267.719 150.993 267.977 150.942 268.218 150.843C268.459 150.743 268.678 150.597 268.863 150.413C269.047 150.228 269.193 150.009 269.292 149.768C269.392 149.527 269.442 149.269 269.441 149.008V126.025C269.441 125.499 269.233 124.995 268.861 124.623C268.489 124.251 267.984 124.042 267.458 124.042C267.162 124.039 266.869 124.107 266.604 124.24C266.402 124.335 266.218 124.463 266.06 124.621C265.691 124.997 265.485 125.505 265.489 126.033V149.008ZM265.489 109.643C265.485 110.014 265.588 110.378 265.786 110.692C265.984 111.007 266.268 111.257 266.604 111.414C266.866 111.557 267.16 111.63 267.458 111.626C267.719 111.629 267.978 111.579 268.22 111.481C268.462 111.382 268.682 111.236 268.867 111.051C269.052 110.867 269.198 110.647 269.296 110.405C269.395 110.163 269.444 109.904 269.441 109.643V86.6599C269.442 86.3992 269.392 86.1408 269.292 85.8997C269.193 85.6587 269.047 85.4396 268.863 85.2552C268.678 85.0709 268.459 84.9248 268.218 84.8255C267.977 84.7261 267.719 84.6755 267.458 84.6764C267.162 84.6731 266.869 84.7409 266.604 84.8741C266.402 84.9663 266.219 85.0929 266.06 85.2482C265.691 85.6248 265.485 86.1323 265.489 86.6599V109.643Z",
    fill: "url(#paint3_linear_6136_4726)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9354 52.4329C41.6681 51.4926 43.6109 51.0069 45.5822 51.0212H234.043C236.453 51.0171 238.806 51.762 240.775 53.153C242.743 54.5439 244.231 56.5122 245.033 58.7856C246.601 63.3075 249.501 67.2491 253.351 70.0925C257.201 72.9359 261.821 74.5479 266.604 74.7168C266.879 74.7168 267.169 74.7168 267.458 74.7168C272.392 74.7177 277.203 73.1821 281.225 70.3233C285.246 67.4646 288.277 63.4246 289.897 58.7644C290.697 56.4927 292.183 54.5254 294.149 53.1345C296.115 51.7437 298.465 50.9978 300.873 51H490.382C491.908 50.9991 493.419 51.2989 494.829 51.8825C496.239 52.466 497.52 53.3218 498.599 54.4009C499.678 55.48 500.534 56.7611 501.118 58.1711C501.701 59.5811 502.001 61.0924 502 62.6184V295.382C502.001 296.908 501.701 298.419 501.118 299.829C500.534 301.239 499.678 302.52 498.599 303.599C497.52 304.678 496.239 305.534 494.829 306.117C493.419 306.701 491.908 307.001 490.382 307H300.873C298.464 307.004 296.114 306.259 294.147 304.868C292.181 303.477 290.695 301.508 289.897 299.236C288.277 294.575 285.246 290.535 281.225 287.677C277.203 284.818 272.392 283.282 267.458 283.283C267.169 283.283 266.879 283.283 266.604 283.283C261.821 283.452 257.201 285.064 253.351 287.907C249.501 290.751 246.601 294.693 245.033 299.214C244.232 301.488 242.744 303.457 240.775 304.848C238.806 306.239 236.454 306.984 234.043 306.979H45.5681C44.0421 306.98 42.5309 306.68 41.1208 306.096C39.7108 305.513 38.4297 304.657 37.3506 303.578C36.2716 302.499 35.4158 301.218 34.8322 299.808C34.2487 298.398 33.9488 296.886 33.9497 295.36V62.6042C33.9517 60.5295 34.5075 58.4929 35.5598 56.7048C36.612 54.9167 38.1226 53.442 39.9354 52.4329ZM265.489 268.199C265.485 268.57 265.588 268.935 265.786 269.249C265.984 269.563 266.268 269.814 266.604 269.971C266.865 270.117 267.159 270.19 267.458 270.183C267.719 270.184 267.977 270.133 268.218 270.033C268.459 269.934 268.678 269.788 268.863 269.604C269.047 269.419 269.193 269.2 269.292 268.959C269.392 268.718 269.442 268.46 269.441 268.199V245.216C269.441 244.69 269.233 244.186 268.861 243.814C268.489 243.442 267.984 243.233 267.458 243.233C267.162 243.23 266.869 243.297 266.604 243.431C266.402 243.526 266.218 243.654 266.06 243.812C265.691 244.188 265.485 244.696 265.489 245.223V268.199ZM265.489 228.833C265.485 229.205 265.588 229.569 265.786 229.883C265.984 230.197 266.268 230.448 266.604 230.605C266.866 230.748 267.16 230.821 267.458 230.817C267.719 230.82 267.978 230.77 268.22 230.672C268.462 230.573 268.682 230.427 268.867 230.242C269.052 230.058 269.198 229.838 269.296 229.596C269.395 229.354 269.444 229.095 269.441 228.833V283.474C269.442 283.213 269.392 282.955 269.292 282.714C269.193 282.473 269.047 282.254 268.863 282.069C268.678 281.885 268.459 281.739 268.218 281.639C267.977 281.54 267.719 281.489 267.458 281.49C267.162 281.487 266.869 281.555 266.604 281.688C266.402 281.78 266.219 281.907 266.06 282.062C265.692 282.44 265.487 282.947 265.489 283.474V228.833ZM265.489 267.112C265.486 267.483 265.589 267.847 265.787 268.161C265.985 268.475 266.268 268.726 266.604 268.884C266.866 269.026 267.16 269.099 267.458 269.096C267.721 269.096 267.981 269.044 268.224 268.942C268.466 268.84 268.686 268.691 268.87 268.503C269.055 268.318 269.201 268.097 269.299 267.855C269.398 267.612 269.446 267.353 269.441 267.091V244.108C269.442 243.847 269.392 243.589 269.292 243.348C269.193 243.107 269.047 242.888 268.863 242.704C268.678 242.519 268.459 242.373 268.218 242.274C267.977 242.174 267.719 242.124 267.458 242.125C267.162 242.122 266.869 242.189 266.604 242.322C266.401 242.412 266.217 242.539 266.06 242.696C265.692 243.074 265.487 243.581 265.489 244.108V267.112ZM265.489 227.739C265.484 228.112 265.587 228.477 265.785 228.793C265.983 229.108 266.267 229.36 266.604 229.518C266.866 229.658 267.16 229.729 267.458 229.723C267.719 229.724 267.977 229.673 268.218 229.574C268.459 229.474 268.678 229.328 268.863 229.144C269.047 228.96 269.193 228.741 269.292 228.5C269.392 228.258 269.442 228 269.441 227.739V204.75C269.441 204.489 269.39 204.232 269.29 203.992C269.191 203.751 269.044 203.533 268.86 203.35C268.676 203.166 268.457 203.021 268.216 202.922C267.976 202.823 267.718 202.772 267.458 202.773C267.161 202.772 266.868 202.842 266.604 202.978C266.401 203.068 266.217 203.195 266.06 203.352C265.876 203.538 265.731 203.758 265.633 204.001C265.535 204.243 265.486 204.502 265.489 204.764V227.739ZM265.489 188.374C265.484 188.745 265.587 189.11 265.785 189.424C265.983 189.739 266.267 189.989 266.604 190.145C266.865 190.291 267.159 190.364 267.458 190.357C267.985 190.359 268.492 190.154 268.87 189.786C269.235 189.406 269.44 188.901 269.441 188.374V165.391C269.441 164.865 269.233 164.361 268.861 163.989C268.489 163.617 267.984 163.408 267.458 163.408C266.93 163.408 266.423 163.616 266.046 163.986C265.678 164.364 265.473 164.871 265.475 165.398L265.489 188.374ZM265.489 149.008C265.485 149.379 265.588 149.744 265.786 150.058C265.984 150.372 266.268 150.623 266.604 150.78C266.865 150.926 267.159 150.999 267.458 150.992C267.719 150.993 267.977 150.942 268.218 150.843C268.459 150.743 268.678 150.597 268.863 150.413C269.047 150.228 269.193 150.009 269.292 149.768C269.392 149.527 269.442 149.269 269.441 149.008V126.025C269.441 125.499 269.233 124.995 268.861 124.623C268.489 124.251 267.984 124.042 267.458 124.042C267.162 124.039 266.869 124.107 266.604 124.24C266.402 124.335 266.218 124.463 266.06 124.621C265.691 124.997 265.485 125.505 265.489 126.033V149.008ZM265.489 109.643C265.485 110.014 265.588 110.378 265.786 110.692C265.984 111.007 266.268 111.257 266.604 111.414C266.866 111.557 267.16 111.63 267.458 111.626C267.719 111.629 267.978 111.579 268.22 111.481C268.462 111.382 268.682 111.236 268.867 111.051C269.052 110.867 269.198 110.647 269.296 110.405C269.395 110.163 269.444 109.904 269.441 109.643V86.6599C269.442 86.3992 269.392 86.1408 269.292 85.8997C269.193 85.6587 269.047 85.4396 268.863 85.2552C268.678 85.0709 268.459 84.9248 268.218 84.8255C267.977 84.7261 267.719 84.6755 267.458 84.6764C267.162 84.6731 266.869 84.7409 266.604 84.8741C266.402 84.9663 266.219 85.0929 266.06 85.2482C265.691 85.6248 265.485 86.1323 265.489 86.6599V109.643Z",
    stroke: "#0D408D",
    strokeWidth: 1.41171,
    mask: "url(#path-605-inside-1_6136_4726)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_6136_4726)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_6136_4726)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_6136_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 141.034C49.0675 140.463 48.6047 140 48.0337 140C47.4628 140 47 140.463 47 141.034V143.101C47 143.672 47.4628 144.135 48.0337 144.135C48.6047 144.135 49.0675 143.672 49.0675 143.101V141.034Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 157.574C49.0675 157.003 48.6047 156.54 48.0337 156.54C47.4628 156.54 47 157.003 47 157.574V159.641C47 160.212 47.4628 160.675 48.0337 160.675C48.6047 160.675 49.0675 160.212 49.0675 159.641V157.574Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 174.113C49.0675 173.542 48.6047 173.079 48.0337 173.079C47.4628 173.079 47 173.542 47 174.113V176.18C47 176.751 47.4628 177.214 48.0337 177.214C48.6047 177.214 49.0675 176.751 49.0675 176.18V174.113Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 190.653C49.0675 190.082 48.6047 189.619 48.0337 189.619C47.4628 189.619 47 190.082 47 190.653V192.72C47 193.291 47.4628 193.754 48.0337 193.754C48.6047 193.754 49.0675 193.291 49.0675 192.72V190.653Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 207.193C49.0675 206.622 48.6047 206.159 48.0337 206.159C47.4628 206.159 47 206.622 47 207.193V209.26C47 209.831 47.4628 210.294 48.0337 210.294C48.6047 210.294 49.0675 209.831 49.0675 209.26V207.193Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 223.733C49.0675 223.162 48.6047 222.699 48.0337 222.699C47.4628 222.699 47 223.162 47 223.733V225.8C47 226.371 47.4628 226.834 48.0337 226.834C48.6047 226.834 49.0675 226.371 49.0675 225.8V223.733Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 240.272C49.0675 239.701 48.6047 239.238 48.0337 239.238C47.4628 239.238 47 239.701 47 240.272V242.339C47 242.91 47.4628 243.373 48.0337 243.373C48.6047 243.373 49.0675 242.91 49.0675 242.339V240.272Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 256.812C49.0675 256.241 48.6047 255.778 48.0337 255.778C47.4628 255.778 47 256.241 47 256.812V258.88C47 259.45 47.4628 259.913 48.0337 259.913C48.6047 259.913 49.0675 259.45 49.0675 258.88V256.812Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0675 273.352C49.0675 272.781 48.6047 272.318 48.0337 272.318C47.4628 272.318 47 272.781 47 273.352V275.42C47 275.99 47.4628 276.453 48.0337 276.453C48.6047 276.453 49.0675 275.99 49.0675 275.42V273.352Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9446 156.54H63.0675C61.9256 156.54 61 157.466 61 158.608C61 159.749 61.9256 160.675 63.0675 160.675H89.9446C91.0864 160.675 92.0121 159.749 92.0121 158.608C92.0121 157.466 91.0864 156.54 89.9446 156.54Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.489 156.54H100.286C99.1444 156.54 98.2188 157.466 98.2188 158.608C98.2188 159.749 99.1444 160.675 100.286 160.675H106.489C107.63 160.675 108.556 159.749 108.556 158.608C108.556 157.466 107.63 156.54 106.489 156.54Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.222 156.54H116.817C115.676 156.54 114.75 157.466 114.75 158.608C114.75 159.749 115.676 160.675 116.817 160.675H129.222C130.364 160.675 131.29 159.749 131.29 158.608C131.29 157.466 130.364 156.54 129.222 156.54Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8736 140H63.5362C62.3944 140 61.4688 140.926 61.4688 142.067C61.4688 143.209 62.3944 144.135 63.5362 144.135H73.8736C75.0154 144.135 75.941 143.209 75.941 142.067C75.941 140.926 75.0154 140 73.8736 140Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4105 140H84.2081C83.0663 140 82.1406 140.926 82.1406 142.067C82.1406 143.209 83.0663 144.135 84.2081 144.135H90.4105C91.5523 144.135 92.478 143.209 92.478 142.067C92.478 140.926 91.5523 140 90.4105 140Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.172 140H100.755C99.6131 140 98.6875 140.926 98.6875 142.067C98.6875 143.209 99.6131 144.135 100.755 144.135H144.172C145.314 144.135 146.239 143.209 146.239 142.067C146.239 140.926 145.314 140 144.172 140Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.484 173.079H63.0675C61.9256 173.079 61 174.005 61 175.147C61 176.288 61.9256 177.214 63.0675 177.214H106.484C107.626 177.214 108.552 176.288 108.552 175.147C108.552 174.005 107.626 173.079 106.484 173.079Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.492 173.079H116.817C115.676 173.079 114.75 174.005 114.75 175.147C114.75 176.288 115.676 177.214 116.817 177.214H137.492C138.634 177.214 139.56 176.288 139.56 175.147C139.56 174.005 138.634 173.079 137.492 173.079Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.238 173.079H147.833C146.691 173.079 145.766 174.005 145.766 175.147C145.766 176.288 146.691 177.214 147.833 177.214H160.238C161.38 177.214 162.305 176.288 162.305 175.147C162.305 174.005 161.38 173.079 160.238 173.079Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3374 206.159H63.0675C61.9256 206.159 61 207.085 61 208.227C61 209.368 61.9256 210.294 63.0675 210.294H71.3374C72.4792 210.294 73.4048 209.368 73.4048 208.227C73.4048 207.085 72.4792 206.159 71.3374 206.159Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.352 206.159H81.6768C80.535 206.159 79.6094 207.085 79.6094 208.227C79.6094 209.368 80.535 210.294 81.6768 210.294H102.352C103.493 210.294 104.419 209.368 104.419 208.227C104.419 207.085 103.493 206.159 102.352 206.159Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82 206.159H112.685C111.543 206.159 110.617 207.085 110.617 208.227C110.617 209.368 111.543 210.294 112.685 210.294H116.82C117.961 210.294 118.887 209.368 118.887 208.227C118.887 207.085 117.961 206.159 116.82 206.159Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.626 206.159H127.153C126.012 206.159 125.086 207.085 125.086 208.227C125.086 209.368 126.012 210.294 127.153 210.294H141.626C142.768 210.294 143.693 209.368 143.693 208.227C143.693 207.085 142.768 206.159 141.626 206.159Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4723 222.699H63.0675C61.9256 222.699 61 223.625 61 224.767C61 225.909 61.9256 226.834 63.0675 226.834H75.4723C76.6141 226.834 77.5398 225.909 77.5398 224.767C77.5398 223.625 76.6141 222.699 75.4723 222.699Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0043 222.699H85.8018C84.66 222.699 83.7344 223.625 83.7344 224.767C83.7344 225.909 84.66 226.834 85.8018 226.834H92.0043C93.1461 226.834 94.0717 225.909 94.0717 224.767C94.0717 223.625 93.1461 222.699 92.0043 222.699Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.901 222.699H102.349C101.207 222.699 100.281 223.625 100.281 224.767C100.281 225.909 101.207 226.834 102.349 226.834H149.901C151.042 226.834 151.968 225.909 151.968 224.767C151.968 223.625 151.042 222.699 149.901 222.699Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.307 222.699H160.239C159.098 222.699 158.172 223.625 158.172 224.767C158.172 225.909 159.098 226.834 160.239 226.834H162.307C163.449 226.834 164.374 225.909 164.374 224.767C164.374 223.625 163.449 222.699 162.307 222.699Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.941 255.778H63.5362C62.3944 255.778 61.4688 256.704 61.4688 257.846C61.4688 258.988 62.3944 259.913 63.5362 259.913H75.941C77.0829 259.913 78.0085 258.988 78.0085 257.846C78.0085 256.704 77.0829 255.778 75.941 255.778Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.08 255.778H86.2706C85.1288 255.778 84.2031 256.704 84.2031 257.846C84.2031 258.988 85.1288 259.913 86.2706 259.913H111.08C112.222 259.913 113.148 258.988 113.148 257.846C113.148 256.704 112.222 255.778 111.08 255.778Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.629 255.778H121.427C120.285 255.778 119.359 256.704 119.359 257.846C119.359 258.988 120.285 259.913 121.427 259.913H127.629C128.771 259.913 129.697 258.988 129.697 257.846C129.697 256.704 128.771 255.778 127.629 255.778Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.565 255.778H137.958C136.816 255.778 135.891 256.704 135.891 257.846C135.891 258.988 136.816 259.913 137.958 259.913H156.565C157.707 259.913 158.633 258.988 158.633 257.846C158.633 256.704 157.707 255.778 156.565 255.778Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M107.484 91H64.0675C62.9256 91 62 91.9256 62 93.0675C62 94.2093 62.9256 95.1349 64.0675 95.1349H107.484C108.626 95.1349 109.552 94.2093 109.552 93.0675C109.552 91.9256 108.626 91 107.484 91Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.484 91H378.067C376.926 91 376 91.9256 376 93.0675C376 94.2093 376.926 95.1349 378.067 95.1349H421.484C422.626 95.1349 423.552 94.2093 423.552 93.0675C423.552 91.9256 422.626 91 421.484 91Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.941 81H63.5362C62.3944 81 61.4688 81.9256 61.4688 83.0675C61.4688 84.2093 62.3944 85.1349 63.5362 85.1349H155.941C157.083 85.1349 158.009 84.2093 158.009 83.0675C158.009 81.9256 157.083 81 155.941 81Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.472 81H354.067C352.926 81 352 81.9256 352 83.0675C352 84.2093 352.926 85.1349 354.067 85.1349H446.472C447.614 85.1349 448.54 84.2093 448.54 83.0675C448.54 81.9256 447.614 81 446.472 81Z",
    fill: "#5539FF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.5,
    y: 153.5,
    width: 48.6193,
    height: 48.6193,
    rx: 24.3096,
    fill: "#FF5D30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.5,
    y: 153.5,
    width: 48.6193,
    height: 48.6193,
    rx: 24.3096,
    stroke: "#0D408D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_6136_4726)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_6136_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.334 172.683C273.334 172.183 272.929 171.778 272.429 171.778C271.93 171.778 271.525 172.183 271.525 172.683C271.525 175.608 270.879 177.508 269.695 178.692C268.511 179.876 266.611 180.522 263.686 180.522C263.186 180.522 262.781 180.927 262.781 181.427C262.781 181.926 263.186 182.331 263.686 182.331C266.611 182.331 268.511 182.977 269.695 184.161C270.879 185.345 271.525 187.245 271.525 190.17C271.525 190.67 271.93 191.075 272.429 191.075C272.929 191.075 273.334 190.67 273.334 190.17C273.334 187.245 273.98 185.345 275.164 184.161C276.348 182.977 278.248 182.331 281.173 182.331C281.673 182.331 282.078 181.926 282.078 181.427C282.078 180.927 281.673 180.522 281.173 180.522C278.248 180.522 276.348 179.876 275.164 178.692C273.98 177.508 273.334 175.608 273.334 172.683Z",
    fill: "white",
    stroke: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.085 165.447C263.085 164.948 262.68 164.543 262.18 164.543C261.68 164.543 261.276 164.948 261.276 165.447C261.276 167.326 260.86 168.472 260.168 169.164C259.476 169.856 258.33 170.272 256.451 170.272C255.952 170.272 255.547 170.677 255.547 171.176C255.547 171.676 255.952 172.081 256.451 172.081C258.33 172.081 259.476 172.497 260.168 173.188C260.86 173.88 261.276 175.026 261.276 176.905C261.276 177.404 261.68 177.809 262.18 177.809C262.68 177.809 263.085 177.404 263.085 176.905C263.085 175.026 263.501 173.88 264.192 173.188C264.884 172.497 266.03 172.081 267.909 172.081C268.408 172.081 268.813 171.676 268.813 171.176C268.813 170.677 268.408 170.272 267.909 170.272C266.03 170.272 264.884 169.856 264.192 169.164C263.501 168.472 263.085 167.326 263.085 165.447Z",
    fill: "white",
    stroke: "#0D408D"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M326 273.526L326 265.801L333.725 265.801L333.725 273.526L326 273.526Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 258.077L326 250.352L333.725 250.352L333.725 258.077L326 258.077Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 242.624L326 234.899L333.725 234.899L333.725 242.624L326 242.624Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 234.901L326 227.176L333.725 227.176L333.725 234.901L326 234.901Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 227.175L326 219.45L333.725 219.45L333.725 227.175L326 227.175Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 211.725L326 204L333.725 204L333.725 211.725L326 211.725Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.727 258.077L333.727 250.352L341.452 250.352L341.452 258.077L333.727 258.077Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.727 219.452L333.727 211.727L341.452 211.727L341.452 219.452L333.727 219.452Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 273.526L341.453 265.801L349.178 265.801L349.178 273.526L341.453 273.526Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 265.8L341.453 258.075L349.178 258.075L349.178 265.8L341.453 265.8Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 250.35L341.453 242.625L349.178 242.625L349.178 250.35L341.453 250.35Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 234.901L341.453 227.176L349.178 227.176L349.178 234.901L341.453 234.901Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 227.175L341.453 219.45L349.178 219.45L349.178 227.175L341.453 227.175Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 211.725L341.453 204L349.178 204L349.178 211.725L341.453 211.725Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 250.35L349.18 242.625L356.905 242.625L356.905 250.35L349.18 250.35Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 234.901L349.18 227.176L356.905 227.176L356.905 234.901L349.18 234.901Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 273.526L356.898 265.801L364.623 265.801L364.623 273.526L356.898 273.526Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 258.077L356.898 250.352L364.623 250.352L364.623 258.077L356.898 258.077Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 250.35L356.898 242.625L364.623 242.625L364.623 250.35L356.898 250.35Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 242.624L356.898 234.899L364.623 234.899L364.623 242.624L356.898 242.624Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 234.901L356.898 227.176L364.623 227.176L364.623 234.901L356.898 234.901Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 227.175L356.898 219.45L364.623 219.45L364.623 227.175L356.898 227.175Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.625 265.8L364.625 258.075L372.35 258.075L372.35 265.8L364.625 265.8Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.625 250.35L364.625 242.625L372.35 242.625L372.35 250.35L364.625 250.35Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.625 234.901L364.625 227.176L372.35 227.176L372.35 234.901L364.625 234.901Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.625 219.452L364.625 211.727L372.35 211.727L372.35 219.452L364.625 219.452Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.352 273.526L372.352 265.801L380.077 265.801L380.077 273.526L372.352 273.526Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.352 250.35L372.352 242.625L380.077 242.625L380.077 250.35L372.352 250.35Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.352 234.901L372.352 227.176L380.077 227.176L380.077 234.901L372.352 234.901Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.352 211.725L372.352 204L380.077 204L380.077 211.725L372.352 211.725Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 258.077L380.078 250.352L387.803 250.352L387.803 258.077L380.078 258.077Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 250.35L380.078 242.625L387.803 242.625L387.803 250.35L380.078 250.35Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 234.901L380.078 227.176L387.803 227.176L387.803 234.901L380.078 234.901Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 211.725L380.078 204L387.803 204L387.803 211.725L380.078 211.725Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 219.452L380.078 211.727L387.803 211.727L387.803 219.452L380.078 219.452Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 273.526L387.805 265.801L395.53 265.801L395.53 273.526L387.805 273.526Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 265.8L387.805 258.075L395.53 258.075L395.53 265.8L387.805 265.8Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 258.077L387.805 250.352L395.53 250.352L395.53 258.077L387.805 258.077Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 227.175L387.805 219.45L395.53 219.45L395.53 227.175L387.805 227.175Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 219.452L387.805 211.727L395.53 211.727L395.53 219.452L387.805 219.452Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 211.725L387.805 204L395.53 204L395.53 211.725L387.805 211.725Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.523 250.35L395.523 242.625L403.248 242.625L403.248 250.35L395.523 250.35Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.523 227.175L395.523 219.45L403.248 219.45L403.248 227.175L395.523 227.175Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.523 219.452L395.523 211.727L403.248 211.727L403.248 219.452L395.523 219.452Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.25 258.077L403.25 250.352L410.975 250.352L410.975 258.077L403.25 258.077Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.25 242.624L403.25 234.899L410.975 234.899L410.975 242.624L403.25 242.624Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 265.8L410.977 258.075L418.702 258.075L418.702 265.8L410.977 265.8Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 250.35L410.977 242.625L418.702 242.625L418.702 250.35L410.977 250.35Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 234.901L410.977 227.176L418.702 227.176L418.702 234.901L410.977 234.901Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 211.725L410.977 204L418.702 204L418.702 211.725L410.977 211.725Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 219.452L410.977 211.727L418.702 211.727L418.702 219.452L410.977 219.452Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 273.526L418.703 265.801L426.428 265.801L426.428 273.526L418.703 273.526Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 258.077L418.703 250.352L426.428 250.352L426.428 258.077L418.703 258.077Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 234.901L418.703 227.176L426.428 227.176L426.428 234.901L418.703 234.901Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 227.175L418.703 219.45L426.428 219.45L426.428 227.175L418.703 227.175Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 211.725L418.703 204L426.428 204L426.428 211.725L418.703 211.725Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 265.8L426.43 258.075L434.155 258.075L434.155 265.8L426.43 265.8Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 227.175L426.43 219.45L434.155 219.45L434.155 227.175L426.43 227.175Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 211.725L426.43 204L434.155 204L434.155 211.725L426.43 211.725Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 258.077L434.148 250.352L441.873 250.352L441.873 258.077L434.148 258.077Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 250.35L434.148 242.625L441.873 242.625L441.873 250.35L434.148 250.35Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 242.624L434.148 234.899L441.873 234.899L441.873 242.624L434.148 242.624Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 234.901L434.148 227.176L441.873 227.176L441.873 234.901L434.148 234.901Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 227.175L434.148 219.45L441.873 219.45L441.873 227.175L434.148 227.175Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 273.526L441.875 265.801L449.6 265.801L449.6 273.526L441.875 273.526Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 265.8L441.875 258.075L449.6 258.075L449.6 265.8L441.875 265.8Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 258.077L441.875 250.352L449.6 250.352L449.6 258.077L441.875 258.077Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 242.624L441.875 234.899L449.6 234.899L449.6 242.624L441.875 242.624Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 234.901L441.875 227.176L449.6 227.176L449.6 234.901L441.875 234.901Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 219.452L441.875 211.727L449.6 211.727L449.6 219.452L441.875 219.452Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 273.526L449.602 265.801L457.327 265.801L457.327 273.526L449.602 273.526Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 258.077L449.602 250.352L457.327 250.352L457.327 258.077L449.602 258.077Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 242.624L449.602 234.899L457.327 234.899L457.327 242.624L449.602 242.624Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 227.175L449.602 219.45L457.327 219.45L457.327 227.175L449.602 227.175Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 211.725L449.602 204L457.327 204L457.327 211.725L449.602 211.725Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 265.8L457.328 258.075L465.053 258.075L465.053 265.8L457.328 265.8Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 250.35L457.328 242.625L465.053 242.625L465.053 250.35L457.328 250.35Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 242.624L457.328 234.899L465.053 234.899L465.053 242.624L457.328 242.624Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 234.901L457.328 227.176L465.053 227.176L465.053 234.901L457.328 234.901Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 219.452L457.328 211.727L465.053 211.727L465.053 219.452L457.328 219.452Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 136L326 143.725L333.725 143.725L333.725 136L326 136Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 151.449L326 159.174L333.725 159.174L333.725 151.449L326 151.449Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 166.902L326 174.627L333.725 174.627L333.725 166.902L326 166.902Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 174.625L326 182.35L333.725 182.35L333.725 174.625L326 174.625Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 182.352L326 190.077L333.725 190.077L333.725 182.352L326 182.352Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 197.801L326 205.526L333.725 205.526L333.725 197.801L326 197.801Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.727 151.449L333.727 159.174L341.452 159.174L341.452 151.449L333.727 151.449Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.727 190.074L333.727 197.799L341.452 197.799L341.452 190.074L333.727 190.074Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 136L341.453 143.725L349.178 143.725L349.178 136L341.453 136Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 143.727L341.453 151.452L349.178 151.452L349.178 143.727L341.453 143.727Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 159.176L341.453 166.901L349.178 166.901L349.178 159.176L341.453 159.176Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 174.625L341.453 182.35L349.178 182.35L349.178 174.625L341.453 174.625Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 182.352L341.453 190.077L349.178 190.077L349.178 182.352L341.453 182.352Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.453 197.801L341.453 205.526L349.178 205.526L349.178 197.801L341.453 197.801Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 159.176L349.18 166.901L356.905 166.901L356.905 159.176L349.18 159.176Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18 174.625L349.18 182.35L356.905 182.35L356.905 174.625L349.18 174.625Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 136L356.898 143.725L364.623 143.725L364.623 136L356.898 136Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 151.449L356.898 159.174L364.623 159.174L364.623 151.449L356.898 151.449Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 159.176L356.898 166.901L364.623 166.901L364.623 159.176L356.898 159.176Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 166.902L356.898 174.627L364.623 174.627L364.623 166.902L356.898 166.902Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 174.625L356.898 182.35L364.623 182.35L364.623 174.625L356.898 174.625Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.898 182.352L356.898 190.077L364.623 190.077L364.623 182.352L356.898 182.352Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.625 143.727L364.625 151.452L372.35 151.452L372.35 143.727L364.625 143.727Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.625 159.176L364.625 166.901L372.35 166.901L372.35 159.176L364.625 159.176Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.625 174.625L364.625 182.35L372.35 182.35L372.35 174.625L364.625 174.625Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.625 190.074L364.625 197.799L372.35 197.799L372.35 190.074L364.625 190.074Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.352 136L372.352 143.725L380.077 143.725L380.077 136L372.352 136Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.352 159.176L372.352 166.901L380.077 166.901L380.077 159.176L372.352 159.176Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.352 174.625L372.352 182.35L380.077 182.35L380.077 174.625L372.352 174.625Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.352 197.801L372.352 205.526L380.077 205.526L380.077 197.801L372.352 197.801Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 151.449L380.078 159.174L387.803 159.174L387.803 151.449L380.078 151.449Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 159.176L380.078 166.901L387.803 166.901L387.803 159.176L380.078 159.176Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 174.625L380.078 182.35L387.803 182.35L387.803 174.625L380.078 174.625Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 197.801L380.078 205.526L387.803 205.526L387.803 197.801L380.078 197.801Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.078 190.074L380.078 197.799L387.803 197.799L387.803 190.074L380.078 190.074Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 136L387.805 143.725L395.53 143.725L395.53 136L387.805 136Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 143.727L387.805 151.452L395.53 151.452L395.53 143.727L387.805 143.727Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 151.449L387.805 159.174L395.53 159.174L395.53 151.449L387.805 151.449Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 182.352L387.805 190.077L395.53 190.077L395.53 182.352L387.805 182.352Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 190.074L387.805 197.799L395.53 197.799L395.53 190.074L387.805 190.074Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.805 197.801L387.805 205.526L395.53 205.526L395.53 197.801L387.805 197.801Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.523 159.176L395.523 166.901L403.248 166.901L403.248 159.176L395.523 159.176Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.523 182.352L395.523 190.077L403.248 190.077L403.248 182.352L395.523 182.352Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.523 190.074L395.523 197.799L403.248 197.799L403.248 190.074L395.523 190.074Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.25 151.449L403.25 159.174L410.975 159.174L410.975 151.449L403.25 151.449Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.25 166.902L403.25 174.627L410.975 174.627L410.975 166.902L403.25 166.902Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 143.727L410.977 151.452L418.702 151.452L418.702 143.727L410.977 143.727Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 159.176L410.977 166.901L418.702 166.901L418.702 159.176L410.977 159.176Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 174.625L410.977 182.35L418.702 182.35L418.702 174.625L410.977 174.625Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 197.801L410.977 205.526L418.702 205.526L418.702 197.801L410.977 197.801Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.977 190.074L410.977 197.799L418.702 197.799L418.702 190.074L410.977 190.074Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 136L418.703 143.725L426.428 143.725L426.428 136L418.703 136Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 151.449L418.703 159.174L426.428 159.174L426.428 151.449L418.703 151.449Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 174.625L418.703 182.35L426.428 182.35L426.428 174.625L418.703 174.625Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 182.352L418.703 190.077L426.428 190.077L426.428 182.352L418.703 182.352Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.703 197.801L418.703 205.526L426.428 205.526L426.428 197.801L418.703 197.801Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 143.727L426.43 151.452L434.155 151.452L434.155 143.727L426.43 143.727Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 182.352L426.43 190.077L434.155 190.077L434.155 182.352L426.43 182.352Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.43 197.801L426.43 205.526L434.155 205.526L434.155 197.801L426.43 197.801Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 151.449L434.148 159.174L441.873 159.174L441.873 151.449L434.148 151.449Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 159.176L434.148 166.901L441.873 166.901L441.873 159.176L434.148 159.176Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 166.902L434.148 174.627L441.873 174.627L441.873 166.902L434.148 166.902Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 174.625L434.148 182.35L441.873 182.35L441.873 174.625L434.148 174.625Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.148 182.352L434.148 190.077L441.873 190.077L441.873 182.352L434.148 182.352Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 136L441.875 143.725L449.6 143.725L449.6 136L441.875 136Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 143.727L441.875 151.452L449.6 151.452L449.6 143.727L441.875 143.727Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 151.449L441.875 159.174L449.6 159.174L449.6 151.449L441.875 151.449Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 166.902L441.875 174.627L449.6 174.627L449.6 166.902L441.875 166.902Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 174.625L441.875 182.35L449.6 182.35L449.6 174.625L441.875 174.625Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.875 190.074L441.875 197.799L449.6 197.799L449.6 190.074L441.875 190.074Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 136L449.602 143.725L457.327 143.725L457.327 136L449.602 136Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 151.449L449.602 159.174L457.327 159.174L457.327 151.449L449.602 151.449Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 166.902L449.602 174.627L457.327 174.627L457.327 166.902L449.602 166.902Z",
    fill: "#CCE6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 182.352L449.602 190.077L457.327 190.077L457.327 182.352L449.602 182.352Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.602 197.801L449.602 205.526L457.327 205.526L457.327 197.801L449.602 197.801Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 143.727L457.328 151.452L465.053 151.452L465.053 143.727L457.328 143.727Z",
    fill: "#EDCCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 159.176L457.328 166.901L465.053 166.901L465.053 159.176L457.328 159.176Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 166.902L457.328 174.627L465.053 174.627L465.053 166.902L457.328 166.902Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 174.625L457.328 182.35L465.053 182.35L465.053 174.625L457.328 174.625Z",
    fill: "#0D408D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.328 190.074L457.328 197.799L465.053 197.799L465.053 190.074L457.328 190.074Z",
    fill: "#FEFEFF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 534.6,
    height: 360.6,
    rx: 16.1,
    stroke: "#ECE6FF",
    strokeWidth: 1.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6136_4726",
    x1: 268,
    y1: 0,
    x2: 268,
    y2: 362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6136_4726",
    x1: 268,
    y1: 0,
    x2: 268,
    y2: 362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6136_4726",
    x1: 257.975,
    y1: 51,
    x2: 257.975,
    y2: 307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6136_4726",
    x1: 502,
    y1: 179,
    x2: 13.9497,
    y2: 179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255546,
    stopColor: "#FFF7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430546,
    stopColor: "#FFF9F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500546,
    stopColor: "#F3F2FF",
    stopOpacity: 0.877075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 536,
    height: 362,
    rx: 16.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 392,
    fill: "white",
    transform: "translate(0.414062 0.233398)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347.2,
    height: 238,
    fill: "white",
    transform: "translate(6 7.2334)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347.2,
    height: 238,
    fill: "white",
    transform: "translate(6 264)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347.2,
    height: 238,
    fill: "white",
    transform: "translate(369 7.2334)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347.2,
    height: 238,
    fill: "white",
    transform: "translate(369 264)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.386,
    height: 136.453,
    fill: "white",
    transform: "translate(47 140)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.386,
    height: 136.453,
    fill: "white",
    transform: "translate(47 140)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.386,
    height: 136.453,
    fill: "white",
    transform: "translate(47 140)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.0121,
    height: 28.9446,
    fill: "white",
    transform: "translate(253.297 163.337)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_6136_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.0121,
    height: 28.9446,
    fill: "white",
    transform: "translate(253.297 163.337)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalTicket);
export default __webpack_public_path__ + "static/media/digital-ticket.676ab675bc0a28827a9b9b17692321b1.svg";
export { ForwardRef as ReactComponent };